<!-- Copyright (c) 2022 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="haulage-job-main">
    <div>
      <Menus :menu="menu" @menuClicked="menuClicked" />
    </div>
    <div class="right-container">
      <div class="top-section">
        <!-- <DateTimePicker style="margin-right: 5px" placeholder="From" :value.sync="fromDate" :showTime="false" />
        <DateTimePicker style="margin-right: 5px" placeholder="To" :value.sync="toDate" :showTime="false" /> -->
        <div class="filter-description">{{ filterText }}</div>
        <ButtonFilter
          class="button-filter-component"
          filterPosition="right"
          buttonText="Change Filter"
          :filterWidth="300"
          :isOpen.sync="filterIsOpen"
          :buttonIsDisabled="filterIsDisabled"
        >
          <div class="filter-popup">
            <BoxContainer title="Date" :isCheckBox="true" style="margin-bottom: 5px" :isChecked.sync="filterDate">
              <div class="row-display">
                <DateTimePicker
                  :showTime="false"
                  placeholder="From"
                  :isDisabled="!filterDate"
                  :value.sync="fromDate"
                  :errorMessage.sync="fromDateErrorMessage"
                />
                <DateTimePicker
                  :showTime="false"
                  placeholder="To"
                  :isDisabled="!filterDate"
                  :value.sync="toDate"
                  :errorMessage.sync="toDateErrorMessage"
                />
              </div>
            </BoxContainer>
            <BoxContainer title="Search" :isCheckBox="true" :isChecked.sync="filterSearch">
              <Dropdown
                placeholder="Job Type"
                :items="jobTypeItems"
                itemKey="Job Type"
                :selectedObject.sync="selectedFilterJobType"
                :isDisabled="!filterSearch"
              />
              <Dropdown
                placeholder="Search By"
                :items="searchByItems"
                itemKey="Search Criteria"
                :selectedObject.sync="selectedFilterSearchBy"
                :isDisabled="!filterSearch"
                :isRequired="filterSearch"
                :errorMessage.sync="searchByErrorMessage"
              />
              <Dropdown
                placeholder="Search Criteria"
                :items="searchCriteriaItems"
                itemKey="name"
                :selectedObject.sync="selectedFilterSearchCriteria"
                :isDisabled="!filterSearch"
                :isRequired="filterSearch"
                :errorMessage.sync="searchCriteriaErrorMessage"
              />
              <Input
                placeholder="Search"
                :inputValue.sync="searchInputValue"
                :isDisabled="!filterSearch"
                :isRequired="filterSearch"
                :errorMessage.sync="searchInputErrorMessage"
              />
            </BoxContainer>
            <button @click="refreshClicked" :disabled="!filterDate && !filterSearch">Refresh</button>
          </div>
        </ButtonFilter>
        <div>Last Refreshed: {{ lastRefreshed }}</div>
      </div>
      <div class="bottom-section">
        <TableBox
          title="Haulage Job"
          :tableData="jobData"
          :dataType="jobDataType"
          :selectedRow.sync="selectedJob"
          :loading="jobTableBoxIsLoading"
          :maxSelection="-1"
          :columnOrderViews.sync="tableBoxColumnOrderViews"
          :columnOrderID="tableBoxColumnOrderID"
        />
      </div>
    </div>

    <PopupEntry
      v-if="popupShow"
      :show.sync="popupShow"
      :title="popupTitle"
      :canPrint="true"
      @print="popupEntryPrintClicked"
      :createdBy="createdBy"
      :updatedBy="updatedBy"
      @save="saveClicked"
      :requiredError="requiredError"
      :successMessages="successMessages"
      :errorMessages="errorMessages"
      @requiredClicked="requiredClicked"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
    >
      <div class="popup-entry-content">
        <div class="popup-milestones">
          <div v-if="showMilestoneLoader" class="loader">
            <span class="loader-text">Loading Milestones...</span>
          </div>
          <img
            class="collapse-milestone"
            src="https://dsmapi.logistics.systems/dsm6gicons/icons8-expand-arrow-24.png"
            @click="showMilestones = !showMilestones"
            :style="{ transform: `rotate(${showMilestones ? 180 : 0}deg)` }"
          />
          <div class="milestones-row" v-if="showMilestones && milestonesItem">
            <div class="milestones-block" v-for="(m, i) in milestonesItem['milestones']" :key="i">
              <div class="milestones-item" :style="{ backgroundColor: `${m['BackColor']}` }">{{ m['ShowText'] }}</div>
              <Tooltip class="milestone-tooltip" :tooltipText="m['ShowText']">
                <div></div>
              </Tooltip>
            </div>
          </div>
          <div class="milestones-row" v-if="showMilestones && milestonesItem">
            <div v-for="(l, i) in Object.keys(milestonesItem['legend'])" :key="i" class="legend-items">
              <div class="legend-box" :style="{ backgroundColor: `${milestonesItem['legend'][l]}` }"></div>
              {{ l }}
            </div>
          </div>
          <div v-else>Milestones</div>
        </div>
        <div class="main-content-container">
          <div class="summary" v-if="tabIndex != 1">
            <div>Job Information</div>
            <Input placeholder="Job #" :inputValue="jobNo" :isDisabled="true" />
            <Input
              placeholder="Date Time"
              :inputValue="jobDateTime ? jobDateTime.formatString('yyyy-MM-dd HH:mm') : ''"
              :isDisabled="true"
            />
            <Input
              :placeholder="shipperCaption"
              :inputValue="selectedShipper ? selectedShipper['Customer Code'] : ''"
              :isDisabled="true"
            />
            <Input placeholder="Cust Ref #" :inputValue="custRefNo" :isDisabled="true" />
            <Input placeholder="Project #" :inputValue="projectNo" :isDisabled="true" />
            <Input placeholder="Request #" :inputValue="requestNo" :isDisabled="true" />
            <Input
              placeholder="Bill To"
              :inputValue="selectedBillTo ? selectedBillTo['Customer Code'] : ''"
              :isDisabled="true"
            />
            <Input
              placeholder="Payment"
              :inputValue="selectedCheque ? selectedCheque['Payment Type'] : ''"
              :isDisabled="true"
            />
            <Input
              placeholder="Job Type"
              :inputValue="selectedJobType ? selectedJobType['Job Type'] : ''"
              :isDisabled="true"
            />
            <Input placeholder="Trip" :inputValue="selectedTrip ? selectedTrip['Trip'] : ''" :isDisabled="true" />
            <Input placeholder="Coeff" :inputValue="coeff" :isDisabled="true" />
          </div>
          <Tab
            :tabs="tabsItems"
            :style="{ height: '100%', width: `calc(100% - ${tabIndex == 1 ? 0 : 120}px)` }"
            :tabIndex.sync="tabIndex"
          >
            <!-- Quick Entry -->
            <div slot="Quick Entry">
              <!-- Job Info -->
              <BoxContainer title="Job Information">
                <div class="row-display">
                  <InputQuery
                    :placeholder="shipperCaption"
                    :items.sync="shipperItems"
                    itemKey="Description"
                    descKey="Customer Name"
                    :selectedObject.sync="selectedShipper"
                    :isRequired="true"
                    :errorMessage.sync="shipperError"
                    ref="shipper"
                    :isDisabled="viewMode || editJobBilledDisabled"
                    addLink="/Home/MasterFiles/ProfileMaster/ShipperConsignee?new=1"
                    :canRefresh="true"
                    @refreshClicked="shipperInputQueryRefreshClicked"
                  />
                  <Input
                    placeholder="Request #"
                    :inputValue.sync="requestNo"
                    :isRequired="requestNoIsRequired"
                    :errorMessage.sync="requestNoError"
                    ref="requestno"
                    :isDisabled="viewMode || editJobBilledDisabled || eROTDisable"
                    validator="text,25,uppercase,alphanumeric,space"
                  />
                </div>
                <div class="job-info-bottom">
                  <div class="left-section">
                    <InputQuery
                      placeholder="Bill To"
                      :items.sync="billToItems"
                      itemKey="Description"
                      descKey="Customer Name"
                      :selectedObject.sync="selectedBillTo"
                      :isRequired="true"
                      :errorMessage.sync="billToError"
                      @selected="billToSelected"
                      ref="billto"
                      :isDisabled="viewMode || editJobBilledDisabled"
                      addLink="/Home/MasterFiles/ProfileMaster/Customer?new=1"
                      :canRefresh="true"
                      @refreshClicked="billToInputQueryRefreshClicked"
                    />
                    <div class="row-display">
                      <Dropdown
                        placeholder="Payment"
                        :items="chequeItems"
                        itemKey="code-desc"
                        :selectedObject.sync="selectedCheque"
                        :isRequired="true"
                        :errorMessage.sync="paymentError"
                        ref="payment"
                        :isDisabled="viewMode || editJobBilledDisabled"
                      />
                    </div>
                  </div>
                  <div class="right-section">
                    <div class="row-display">
                      <Dropdown
                        placeholder="Job Type"
                        :items="jobTypeItems"
                        itemKey="Job Type"
                        :selectedObject.sync="selectedJobType"
                        :isRequired="true"
                        :errorMessage.sync="jobTypeError"
                        @selected="jobTypeChanged"
                        ref="jobtype"
                        :isDisabled="viewMode || editJobBilledDisabled || editJobPaidDisabled"
                      />
                      <Dropdown
                        placeholder="Trip"
                        :items="tripItems"
                        itemKey="showValue"
                        :selectedObject.sync="selectedTrip"
                        :isRequired="true"
                        :errorMessage.sync="tripError"
                        ref="trip"
                        :isDisabled="viewMode || editJobBilledDisabled"
                      />
                    </div>
                    <div class="row-display">
                      <Input
                        placeholder="Coeff"
                        :inputValue.sync="coeff"
                        :isRequired="true"
                        :errorMessage.sync="coeffError"
                        ref="coeff"
                        :regex="regexDecimal"
                        @focusChanged="coeffLostFocus"
                        :isDisabled="viewMode || editJobBilledDisabled || editJobPaidDisabled || coeffDisable"
                      />
                    </div>
                  </div>
                </div>
              </BoxContainer>
              <!-- Send To Info -->
              <BoxContainer title="Send To Information" style="margin-top: 15px">
                <div class="send-to-container-info" style="margin: 0; padding: 0; border: none">
                  <div class="send-to-details">
                    <InputQuery
                      placeholder="Pick Up"
                      :items.sync="pickUpItems"
                      itemKey="Description"
                      descKey="Company"
                      :selectedObject.sync="selectedPickUp"
                      :isRequired="true"
                      :errorMessage.sync="pickUpError"
                      ref="sendto"
                      @selected="sendToDetailsChanged($event, 'pickup')"
                      :isDisabled="viewMode"
                      addLink="/Home/MasterFiles/OperationMaster/Destination?new=1"
                      :canRefresh="true"
                      @refreshClicked="pickUpInputQueryRefreshClicked"
                    />
                    <div class="address-container">{{ pickUpAddress }}</div>
                  </div>
                  <div class="send-to-details" style="margin-left: 5px">
                    <InputQuery
                      placeholder="Send To"
                      :items.sync="sendToItems"
                      itemKey="Description"
                      descKey="Company"
                      :selectedObject.sync="selectedSendTo"
                      :isRequired="true"
                      :errorMessage.sync="sendToError"
                      ref="pickup"
                      @selected="sendToDetailsChanged($event, 'sendto')"
                      :isDisabled="viewMode || editJobBilledDisabled"
                      addLink="/Home/MasterFiles/OperationMaster/Destination?new=1"
                      :canRefresh="true"
                      @refreshClicked="sendToInputQueryRefreshClicked"
                    />
                    <div class="row-display">
                      <CheckBoxV2
                        title="Diversion"
                        :isChecked.sync="isDiversion"
                        @checkBoxClicked="diversionChanged"
                        :isDisabled="viewMode || editJobBilledDisabled"
                      />
                      <Dropdown
                        placeholder="Premises Is"
                        :items="premisesItems"
                        itemKey="Premises Is"
                        @selected="premisesisChanged"
                        :selectedObject.sync="selectedPremises"
                        :isDisabled="viewMode"
                      />
                    </div>
                    <div class="address-container">{{ sendToAddress }}</div>
                  </div>
                  <div class="send-to-details" style="margin-left: 5px">
                    <InputQuery
                      placeholder="Drop Off"
                      :items.sync="dropOffItems"
                      itemKey="Description"
                      descKey="Company"
                      :selectedObject.sync="selectedDropOff"
                      :isRequired="true"
                      :errorMessage.sync="dropOffError"
                      ref="dropoff"
                      @selected="sendToDetailsChanged($event, 'dropoff')"
                      :isDisabled="viewMode"
                      addLink="/Home/MasterFiles/OperationMaster/Destination?new=1"
                      :canRefresh="true"
                      @refreshClicked="dropOffInputQueryRefreshClicked"
                    />
                    <div class="address-container">{{ dropOffAddress }}</div>
                  </div>
                </div>
                <!-- <div class="send-to-details">
                  <InputQuery placeholder="Pick Up" :items="pickUpItems" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedPickUp"
                    :isRequired="true" :errorMessage.sync="pickUpError" ref="sendto" @selected="sendToDetailsChanged($event, 'pickup')" />
                </div>
                <div class="send-to-details" style="margin-left: 5px">
                  <InputQuery placeholder="Send To" :items="sendToItems" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedSendTo"
                    :isRequired="true" :errorMessage.sync="sendToError" ref="pickup" @selected="sendToDetailsChanged($event, 'sendto')" />
                </div>
                <div class="send-to-details" style="margin-left: 5px">
                  <InputQuery placeholder="Drop Off" :items="dropOffItems" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedDropOff"
                    :isRequired="true" :errorMessage.sync="dropOffError" ref="dropoff" @selected="sendToDetailsChanged($event, 'dropoff')" />
                </div> -->
                <div class="quick-entry-cn">
                  <button v-if="!viewMode" @click="addConsignmentPopup">Add Consignment</button>
                  <div>Total Consignment(s): {{ consignmentListFiltered.length }} | </div>
                  <a @click="tabIndex = 2">View All Consignments</a>
                  <!-- <button @click="tabIndex = 2">View All Consignments</button> -->
                </div>
              </BoxContainer>
              <!-- Voyage Info -->
              <BoxContainer title="Voyage Information" style="margin-top: 15px">
                <div class="voyage-info">
                  <div class="left-section">
                    <InputQuery
                      placeholder="Ship Call #"
                      :items="shipCallNoItems"
                      itemKey="Ship Call No"
                      descKey="Vessel Name"
                      :selectedObject.sync="selectedShipCallNo"
                      :search.sync="shipCallNoFreeText"
                      :isRequired="true"
                      :errorMessage.sync="shipCallError"
                      ref="shipcall"
                      :isDisabled="viewMode"
                      @selected="shipCallNoSelected"
                      :allowFreeText="true"
                      validator="text,10,uppercase,alphanumeric,none"
                      :showDesc="true"
                    />
                    <Input
                      placeholder="Voy"
                      :inputValue.sync="voyNo"
                      :isRequired="true"
                      :errorMessage.sync="voyNoError"
                      ref="voyno"
                      :isDisabled="viewMode"
                      validator="text,10,uppercase,alphanumeric,space"
                    />
                  </div>
                  <div class="right-section">
                    <InputQuery
                      placeholder="Fwdg Agent"
                      :items="fwdgAgentItems"
                      itemKey="FA Code"
                      descKey="FA Name"
                      :selectedObject.sync="selectedFwdgAgent"
                      :isRequired="forwardingAgentIsRequired"
                      :errorMessage.sync="fwdgAgentError"
                      ref="fwdgagt"
                      :isDisabled="viewMode"
                    />
                    <Input
                      :placeholder="
                        selectedJobType ?
                          selectedJobType['Job Type Header'] == 'I' ?
                            'B/L No'
                          : 'Booking Ref No'
                        : 'Booking Ref No'
                      "
                      :inputValue.sync="bookingRefNo"
                      :isRequired="bookingRefNoRequired"
                      :errorMessage.sync="bookingRefNoError"
                      ref="bookingrefno"
                      :isDisabled="viewMode"
                      validator="text,35,uppercase,alphanumeric,space"
                    />
                  </div>
                </div>
              </BoxContainer>
            </div>
            <!-- Job Information Tab -->
            <div slot="Job Information">
              <div class="job-info-top">
                <div>
                  <div class="row-display">
                    <Input placeholder="Job #" :inputValue.sync="jobNo" :isDisabled="true" />
                    <CheckBoxV2
                      title="Urgent"
                      :isChecked.sync="urgent"
                      :isDisabled="viewMode || editJobBilledDisabled"
                    />
                  </div>
                  <DateTimePicker
                    placeholder="Date Time"
                    :value.sync="jobDateTime"
                    :isDisabled="viewMode"
                    :maxDate="maxDate"
                    :errorMessage.sync="dateErrMsg['jobDateTime']"
                    ref="jobdatetime"
                    @dateChanged="validateDates($event, 'jobDateTime')"
                  />
                  <InputQuery
                    :placeholder="shipperCaption"
                    :items.sync="shipperItems"
                    itemKey="Description"
                    descKey="Customer Name"
                    :selectedObject.sync="selectedShipper"
                    :isRequired="true"
                    :isDisabled="viewMode || editJobBilledDisabled"
                    addLink="/Home/MasterFiles/ProfileMaster/ShipperConsignee?new=1"
                    :canRefresh="true"
                    @refreshClicked="shipperInputQueryRefreshClicked"
                  />
                </div>
                <div>
                  <Input
                    placeholder="Cust Ref #"
                    :inputValue.sync="custRefNo"
                    :isDisabled="viewMode"
                    validator="text,40,uppercase,alphanumeric,space"
                  />
                  <Input
                    placeholder="Project #"
                    :inputValue.sync="projectNo"
                    :isDisabled="viewMode || editJobBilledDisabled"
                    validator="text,25,uppercase,alphanumeric,space"
                  />
                  <Input
                    placeholder="Request #"
                    :inputValue.sync="requestNo"
                    :isRequired="requestNoIsRequired"
                    :isDisabled="viewMode || editJobBilledDisabled || eROTDisable"
                    validator="text,25,uppercase,alphanumeric,space"
                  />
                </div>
              </div>
              <div class="job-info-bottom">
                <div class="left-section">
                  <InputQuery
                    placeholder="Bill To"
                    :items.sync="billToItems"
                    itemKey="Description"
                    descKey="Customer Name"
                    :selectedObject.sync="selectedBillTo"
                    :isRequired="true"
                    @selected="billToSelected"
                    :isDisabled="viewMode || editJobBilledDisabled"
                    addLink="/Home/MasterFiles/ProfileMaster/Customer?new=1"
                    :canRefresh="true"
                    @refreshClicked="billToInputQueryRefreshClicked"
                  />
                  <div v-if="billToDetails" style="display: flex; align-items: center">
                    <span>Status</span>
                    <span class="status-container" :style="{ backgroundColor: billToDetails['status']['color'] }">
                      {{ billToDetails['status']['text'] }}
                    </span>
                    <span>Outstanding</span>
                    <Tooltip
                      position="top"
                      :tooltipText="`${billToDetails['currency']} ${billToDetails['outstanding']['value'].toString()}`"
                      style="width: 100%"
                      :xOffset="6"
                      :yOffset="2"
                    >
                      <span class="outstanding-prog">
                        <div style="z-index: 1; display: flex; justify-content: center; width: 100%; cursor: default"
                          >{{ billToDetails['outstanding']['perc'] }}%</div
                        >
                        <div
                          class="progress-ind"
                          :style="{
                            width: `${billToDetails['outstanding']['perc'] > 100 ? 100 : billToDetails['outstanding']['perc']}%`,
                            backgroundColor: billToDetails['outstanding']['color'],
                          }"
                        ></div>
                      </span>
                    </Tooltip>
                  </div>
                  <div v-if="billToDetails"
                    >Credit Limit : {{ billToDetails['currency'] }} {{ billToDetails['creditLimit'] }} Credit Terms :
                    {{ billToDetails['creditTerms'] }}</div
                  >
                  <div class="row-display">
                    <Dropdown
                      placeholder="Payment"
                      :items="chequeItems"
                      itemKey="code-desc"
                      :selectedObject.sync="selectedCheque"
                      :isRequired="true"
                      :isDisabled="viewMode || editJobBilledDisabled"
                    />
                    <!-- <Input placeholder="Contact" :inputValue.sync="contact" :isDisabled="true" /> -->
                  </div>
                  <div class="row-display">
                    <!-- <Input placeholder="Tel" :inputValue.sync="tel" :isDisabled="true" />
                    <Input placeholder="Fax" :inputValue.sync="fax" :isDisabled="true" /> -->
                  </div>
                </div>
                <div class="right-section">
                  <div class="row-display">
                    <Dropdown
                      placeholder="Job Type"
                      :items="jobTypeItems"
                      itemKey="Job Type"
                      :selectedObject.sync="selectedJobType"
                      @selected="jobTypeChanged"
                      :isRequired="true"
                      :isDisabled="viewMode || editJobBilledDisabled || editJobPaidDisabled"
                    />
                    <Dropdown
                      placeholder="Trip"
                      :items="tripItems"
                      itemKey="showValue"
                      :selectedObject.sync="selectedTrip"
                      :isRequired="true"
                      :isDisabled="viewMode || editJobBilledDisabled"
                    />
                  </div>
                  <div class="row-display">
                    <Input
                      placeholder="Coeff"
                      :inputValue.sync="coeff"
                      :isRequired="true"
                      :regex="regexDecimal"
                      :isDisabled="viewMode || editJobBilledDisabled || editJobPaidDisabled || coeffDisable"
                    />
                    <CheckBoxV2
                      title="Keep Charges"
                      :isChecked.sync="keepCharges"
                      :isDisabled="viewMode || editJobBilledDisabled || editJobPaidDisabled || keepChargesDisable"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Send To / Container Information Tab -->
            <div slot="Send To / Container Information">
              <BoxContainer :isCollapsible="true" title="Send To Details">
                <div style="display: flex; flex-direction: row">
                  <div v-if="openSendTo" class="send-to-details">
                    <InputQuery
                      placeholder="Pick Up"
                      :items.sync="pickUpItems"
                      itemKey="Description"
                      descKey="Company"
                      :selectedObject.sync="selectedPickUp"
                      :isRequired="true"
                      @selected="sendToDetailsChanged($event, 'pickup')"
                      :isDisabled="viewMode"
                      addLink="/Home/MasterFiles/OperationMaster/Destination?new=1"
                      :canRefresh="true"
                      @refreshClicked="pickUpInputQueryRefreshClicked"
                    />
                    <div class="address-container">{{ pickUpAddress }}</div>
                  </div>
                  <div v-if="openSendTo" class="send-to-details" style="margin-left: 5px">
                    <InputQuery
                      placeholder="Send To"
                      :items.sync="sendToItems"
                      itemKey="Description"
                      descKey="Company"
                      :selectedObject.sync="selectedSendTo"
                      :isRequired="true"
                      @selected="sendToDetailsChanged($event, 'sendto')"
                      :isDisabled="viewMode || editJobBilledDisabled"
                      addLink="/Home/MasterFiles/OperationMaster/Destination?new=1"
                      :canRefresh="true"
                      @refreshClicked="sendToInputQueryRefreshClicked"
                    />
                    <div class="row-display">
                      <CheckBoxV2
                        title="Diversion"
                        :isChecked.sync="isDiversion"
                        @checkBoxClicked="diversionChanged"
                        :isDisabled="viewMode || editJobBilledDisabled"
                      />
                      <Dropdown
                        placeholder="Premises Is"
                        :items="premisesItems"
                        itemKey="Premises Is"
                        :selectedObject.sync="selectedPremises"
                        @selected="premisesisChanged"
                        :isDisabled="viewMode"
                      />
                    </div>
                    <div class="address-container">{{ sendToAddress }}</div>
                  </div>
                  <div v-if="openSendTo" class="send-to-details" style="margin-left: 5px">
                    <InputQuery
                      placeholder="Drop Off"
                      :items.sync="dropOffItems"
                      itemKey="Description"
                      descKey="Company"
                      :selectedObject.sync="selectedDropOff"
                      :isRequired="true"
                      @selected="sendToDetailsChanged($event, 'dropoff')"
                      :isDisabled="viewMode"
                      addLink="/Home/MasterFiles/OperationMaster/Destination?new=1"
                      :canRefresh="true"
                      @refreshClicked="dropOffInputQueryRefreshClicked"
                    />
                    <div class="address-container">{{ dropOffAddress }}</div>
                  </div>
                </div>
              </BoxContainer>
              <!-- <div class="send-to-container-info" :style="{ maxHeight: openSendTo ? '' : '27px', minHeight: openSendTo ? '' : '27px',
                overflow: !openSendTo ? 'hidden' : '' }">
                <div class="title" v-if="openSendTo">Send To</div>
                <img class="expand-icon" src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png?index=0" @click="openSendTo = !openSendTo"
                  :style="{ transform: `scaleY(${openSendTo ? -1 : 1})` }">
                <div v-if="openSendTo" class="send-to-details">
                  <InputQuery placeholder="Pick Up" :items.sync="pickUpItems" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedPickUp"
                    :isRequired="true" @selected="sendToDetailsChanged($event, 'pickup')" :isDisabled="viewMode"
                    addLink="/Home/MasterFiles/OperationMaster/Destination?new=1" :refreshData="{ masterfile: 'pickup_hms' }" />
                  <div class="address-container">{{ pickUpAddress }}</div>
                </div>
                <div v-if="openSendTo" class="send-to-details" style="margin-left: 5px">
                  <InputQuery placeholder="Send To" :items.sync="sendToItems" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedSendTo"
                    :isRequired="true" @selected="sendToDetailsChanged($event, 'sendto')" :isDisabled="viewMode || editJobBilledDisabled"
                    addLink="/Home/MasterFiles/OperationMaster/Destination?new=1" :refreshData="{ masterfile: 'SENDTO_ALL' }" />
                  <div class="row-display">
                    <CheckBox title="Diversion" :isChecked.sync="isDiversion" :isDisabled="viewMode || editJobBilledDisabled" />
                    <Dropdown placeholder="Premises Is" :items="premisesItems" itemKey="Premises Is" :selectedObject.sync="selectedPremises"
                      :isDisabled="viewMode" />
                  </div>
                  <div class="address-container">{{ sendToAddress }}</div>
                </div>
                <div v-if="openSendTo" class="send-to-details" style="margin-left: 5px">
                  <InputQuery placeholder="Drop Off" :items.sync="dropOffItems" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedDropOff"
                    :isRequired="true" @selected="sendToDetailsChanged($event, 'dropoff')" :isDisabled="viewMode"
                    addLink="/Home/MasterFiles/OperationMaster/Destination?new=1" :refreshData="{ masterfile: 'dropoff_hms' }" />
                  <div class="address-container">{{ dropOffAddress }}</div>
                </div>
                <div v-if="!openSendTo" class="collapsed-title">Send To Details</div>
              </div> -->
              <BoxContainer style="margin-top: 15px" :isCollapsible="true" title="Consignments">
                <div v-if="openConsignment && !viewMode" class="button-area">
                  <button @click="addConsignmentPopup">Add Consignment</button>
                  <button @click="deleteConsignment">Delete Consignment</button>
                  <!-- <button style="margin-left: 15px">Charges</button> -->
                  <button @click="redirectToJobCharges">Job Charges</button>
                </div>
                <div v-if="viewMode && consignmentList.length > 0" class="button-area">
                  <button @click="diversionForCN('view')">Create/View Diversion</button>
                  <button @click="diversionForCN('print')">Print Diversion</button>
                  <button @click="consignmentPrintJobNo">Print CN</button>
                </div>
                <TableBox
                  style="height: calc(100% - 35px)"
                  v-if="openConsignment"
                  title="Consignments"
                  :tableData="consignmentList"
                  :selectedRow.sync="selectedConsignments"
                  :maxSelection="1"
                  :hideColumns="[
                    'seqno',
                    'samesendto',
                    'samepickup',
                    'samedropoff',
                    'cnaction',
                    'condeleteassign',
                    'condelete',
                    'consignmentdeletereason',
                    'haubookingid',
                    'isDeletedJobChange',
                    'isDeleted',
                  ]"
                  :additionalButtons="viewMode ? [] : tableEditButton"
                  @buttonClicked="editConsignment"
                />
                <div v-if="!openConsignment" class="collapsed-title">Consignment Details</div>
                <!-- <div class="send-to-container-info" :style="{ maxHeight: openConsignment ? '350px' : '27px', minHeight: openConsignment ? '350px' : '27px',
                overflow: !openConsignment ? 'hidden' : '', height: '350px', flexDirection: 'column' }">
                <div class="title" v-if="openConsignment">Consignment</div>
                <img class="expand-icon" src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png?index=0" @click="openConsignment = !openConsignment"
                  :style="{ transform: `scaleY(${openConsignment ? -1 : 1})` }"> -->
                <!-- </div> -->
              </BoxContainer>
              <!-- <div class="send-to-container-info" :style="{ maxHeight: openConsignment ? '350px' : '27px', minHeight: openConsignment ? '350px' : '27px',
                overflow: !openConsignment ? 'hidden' : '', height: '350px', flexDirection: 'column' }">
                <div class="title" v-if="openConsignment">Consignment</div>
                <img class="expand-icon" src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png?index=0" @click="openConsignment = !openConsignment"
                  :style="{ transform: `scaleY(${openConsignment ? -1 : 1})` }">
                <div v-if="openConsignment && !viewMode" class="button-area">
                  <button @click="addConsignmentPopup">Add Consignment</button>
                  <button @click="deleteConsignment">Delete Consignment</button>
                  <button style="margin-left: 15px">Charges</button>
                </div>
                <TableBox style="height: calc(100% - 35px)" v-if="openConsignment" title="Consignments" :tableData="consignmentListWithoutDelete"
                  :selectedRow.sync="selectedConsignments" :maxSelection="1" :hideColumns="[ 'samesendto', 'samepickup', 'samedropoff', 'cnaction', 'condeleteassign', 'condelete', 'consignmentdeletereason' ]"
                  :additionalButtons="viewMode ? [] : tableEditButton" @buttonClicked="editConsignment" />
                <div v-if="!openConsignment" class="collapsed-title">Consignment Details</div>
              </div> -->
            </div>
            <!-- Voyage Information Tab -->
            <div slot="Voyage Information" class="voyage-info">
              <div class="top-section">
                <div class="left-section">
                  <InputQuery
                    placeholder="Ship Call #"
                    :items="shipCallNoItems"
                    itemKey="Ship Call No"
                    descKey="SCN - Terminal"
                    :selectedObject.sync="selectedShipCallNo"
                    :search.sync="shipCallNoFreeText"
                    :isRequired="true"
                    :isDisabled="viewMode"
                    @selected="shipCallNoSelected"
                    :allowFreeText="true"
                    validator="text,10,uppercase,alphanumeric,none"
                    :showDesc="true"
                  />
                  <Input
                    placeholder="Voy"
                    :inputValue.sync="voyNo"
                    :isRequired="true"
                    :isDisabled="viewMode"
                    validator="text,10,uppercase,alphanumeric,space"
                  />
                  <InputQuery
                    placeholder="Vessel Code"
                    :items="vesselCodeItems"
                    itemKey="Description"
                    descKey="Vessel Name"
                    :selectedObject.sync="selectedVesselCode"
                    :isDisabled="viewMode"
                  />
                  <InputQuery
                    placeholder="Tranship Port"
                    :items.sync="transhipPortItems"
                    itemKey="Description"
                    descKey="Port Location"
                    :selectedObject.sync="selectedTranshipPort"
                    :isDisabled="viewMode"
                    addLink="/Home/MasterFiles/ProfileMaster/Port?new=1"
                    :canRefresh="true"
                    @refreshClicked="transhipPortInputQueryRefreshClicked"
                  />
                  <InputQuery
                    placeholder="Load/Discharge Port"
                    :items.sync="dischargeItems"
                    itemKey="Description"
                    descKey="Port Location"
                    :selectedObject.sync="selectedDischargePort"
                    :search.sync="dischargePortFreeText"
                    :isDisabled="viewMode"
                    :allowFreeText="true"
                    addLink="/Home/MasterFiles/ProfileMaster/Port?new=1"
                    :canRefresh="true"
                    @refreshClicked="dischargeInputQueryRefreshClicked"
                  />
                  <DateTimePicker
                    placeholder="ETA Date Time"
                    :value.sync="etaDateTime"
                    :isDisabled="viewMode"
                    :maxDate="maxDate"
                    :errorMessage.sync="dateErrMsg['etaDateTime']"
                    ref="etadatetime"
                    @dateChanged="validateDates($event, 'etaDateTime')"
                  />
                  <DateTimePicker
                    placeholder="ETD Date Time"
                    :value.sync="etdDateTime"
                    :isDisabled="viewMode"
                    :maxDate="maxDate"
                    :errorMessage.sync="dateErrMsg['etdDateTime']"
                    ref="etddatetime"
                    @dateChanged="validateDates($event, 'etdDateTime')"
                  />
                  <DateTimePicker
                    placeholder="Close Date Time"
                    :value.sync="closeDateTime"
                    :isDisabled="viewMode || closeDateTimeDisable"
                    :maxDate="maxDate"
                    :errorMessage.sync="dateErrMsg['closeDateTime']"
                    ref="closedatetime"
                    @dateChanged="validateDates($event, 'closeDateTime')"
                  />
                  <DateTimePicker
                    placeholder="Demurage Date"
                    :value.sync="demurageDate"
                    :maxDate="maxDate"
                    :isDisabled="viewMode || demurageDateDisable"
                    :errorMessage.sync="dateErrMsg['demurageDate']"
                    ref="demuragedate"
                    @dateChanged="validateDates($event, 'demurageDate')"
                  />
                  <DateTimePicker
                    placeholder="Detention Date"
                    :value.sync="detentionDate"
                    :isDisabled="viewMode || detentionDateDisable"
                    :maxDate="maxDate"
                    :errorMessage.sync="dateErrMsg['detentionDate']"
                    ref="detentiondate"
                    @dateChanged="validateDates($event, 'detentionDate')"
                  />
                </div>
                <div class="right-section">
                  <Input
                    placeholder="Shipping Line"
                    :inputValue.sync="shippingLine"
                    :isDisabled="viewMode"
                    validator="text,50,uppercase,alphanumeric,space"
                  />
                  <InputQuery
                    placeholder="Shipping Agent"
                    :items="shippingAgentItems"
                    itemKey="Description"
                    descKey="Agent Name"
                    :selectedObject.sync="selectedShippingAgent"
                    :isDisabled="viewMode"
                  />
                  <div class="row-display">
                    <Input placeholder="Tel" :inputValue.sync="shipAgtTel" :isDisabled="true" />
                    <Input placeholder="Fax" :inputValue.sync="shipAgtFax" :isDisabled="true" />
                  </div>
                  <InputQuery
                    placeholder="Fwdg Agent"
                    :items="fwdgAgentItems"
                    itemKey="Description"
                    descKey="FA Name"
                    :selectedObject.sync="selectedFwdgAgent"
                    :isRequired="forwardingAgentIsRequired"
                    :isDisabled="viewMode"
                  />
                  <div class="row-display">
                    <Input placeholder="Tel" :inputValue.sync="fwdgAgtTel" :isDisabled="true" />
                    <Input placeholder="Fax" :inputValue.sync="fwdgAgtFax" :isDisabled="true" />
                  </div>
                  <Input
                    :placeholder="
                      selectedJobType ?
                        selectedJobType['Job Type Header'] == 'I' ?
                          'B/L No'
                        : 'Booking Ref No'
                      : 'Booking Ref No'
                    "
                    :inputValue.sync="bookingRefNo"
                    :isRequired="bookingRefNoRequired"
                    :isDisabled="viewMode"
                    validator="alphanumeric,35"
                  />
                  <Input
                    placeholder="Requested By"
                    :inputValue.sync="requestedBy"
                    :isDisabled="viewMode"
                    validator="text,10,uppercase,alphanumeric,space"
                  />
                  <Input
                    placeholder="Final Destination"
                    :inputValue.sync="finalDestination"
                    :isDisabled="viewMode"
                    validator="text,50,uppercase,alphanumeric,space"
                  />
                  <CheckBoxV2
                    title="Offload @ premises"
                    :isChecked.sync="premisOffload"
                    :isDisabled="viewMode || editJobBilledDisabled"
                  />
                </div>
              </div>
              <div class="bottom-section"> 
                <div class="free-input-group">
                  <Input placeholder="Free Storage" :inputValue.sync="freeStorage" :isDisabled="viewMode"/>
                  <div class="unit-toggle" :class="{ disabled: viewMode }">
                    <button
                      :class="['toggle-btn', { active: storageUnit === 'D' }]"
                      :disabled="viewMode"
                      @click="setUnit('storageUnit', 'D')"
                    >Days</button>
                    <button
                      :class="['toggle-btn', { active: storageUnit === 'H' }]"
                      :disabled="viewMode"
                      @click="setUnit('storageUnit', 'H')"
                    >Hours</button>
                  </div>
                </div>
                <div class="free-input-group">
                  <Input placeholder="Free Storage" :inputValue.sync="freeDemurrage" :isDisabled="viewMode"/>
                  <div class="unit-toggle" :class="{ disabled: viewMode }">
                    <button
                      :class="['toggle-btn', { active: demurrageUnit === 'D' }]"
                      :disabled="viewMode"
                      @click="setUnit('demurrageUnit', 'D')"
                    >Days</button>
                    <button
                      :class="['toggle-btn', { active: demurrageUnit === 'H' }]"
                      :disabled="viewMode"
                      @click="setUnit('demurrageUnit', 'H')"
                    >Hours</button>
                  </div>
                </div>
                <div class="free-input-group">
                  <Input placeholder="Free Storage" :inputValue.sync="freeDetention" :isDisabled="viewMode"/>
                  <div class="unit-toggle" :class="{ disabled: viewMode }">
                    <button
                      :class="['toggle-btn', { active: detentionUnit === 'D' }]"
                      :disabled="viewMode"
                      @click="setUnit('detentionUnit', 'D')"
                    >Days</button>
                    <button
                      :class="['toggle-btn', { active: detentionUnit === 'H' }]"
                      :disabled="viewMode"
                      @click="setUnit('detentionUnit', 'H')"
                    >Hours</button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Documents Tab -->
            <div slot="Documents" class="documents">
              <div v-if="showDocumentsLoader" class="loader">
                <span class="loader-text">Loading Documents...</span>
              </div>
              <div class="top-button-section" id="docPopup" v-if="!viewMode">
                <button @click="addDoc">
                  <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png" height="15" />
                  Add Documents
                </button>
                <button @click="editDoc">
                  <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png" height="15" />
                  Edit Documents
                </button>
                <button @click="deleteDoc">
                  <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png" height="15" />
                  Delete Documents
                </button>
              </div>

              <DocStatusUpdate
                :showPopup.sync="docStatusPopup"
                @updateClicked="documentUpdate"
                :editDetailsList.sync="editDocumentsList"
                defaultCategory="document"
                :title="`Update Documents for Job # ${jobNo}`"
              />
              <TableBox
                :tableData="documentsData"
                groupBy="ID"
                title="Documents"
                :selectedRow.sync="selectedDocuments"
                :hideColumns="['documentguid', 'statusseqno', 'ID', 'fileAtt', 'filetype', 'Action']"
              />
            </div>
            <!-- TAS & KPI Tab -->
            <div slot="TAS & KPI" class="tas-and-kpi">
              <div v-if="showTASAndKPILoader" class="loader">
                <span class="loader-text">Loading TAS & KPI...</span>
              </div>
              <StatusPage
                class="status-page-component"
                :isComponent="true"
                :statusJobNo="statusTaskJobNo"
                :statusDocuments.sync="statusTaskDocuments"
                :statusData.sync="statusTaskStatusData"
              />
            </div>
          </Tab>
        </div>
      </div>
    </PopupEntry>

    <div v-if="openConsignmentPopup" class="container-popup">
      <div class="title">{{ cnEditIndex >= 0 ? 'Edit Consignment' : 'Add Consignment' }}</div>
      <div class="content">
        <div class="container-left">
          <Input placeholder="CDA #" :inputValue.sync="cdaNo" :isDisabled="true" />
          <div class="row-display">
            <CheckBoxV2
              title="Cont No"
              :isChecked.sync="isContNo"
              @checkBoxClicked="contNoOrCount('num')"
              :isDisabled="cnEditIndex >= 0"
            />
            <Input
              placeholder="Cont #"
              :inputValue.sync="contNo"
              :isDisabled="!isContNo"
              :isRequired="isContNo && selectedJobType['Job Type Header'] == 'I'"
              :errorMessage.sync="contNoError"
              :isContainer="isContainerCheck"
              validator="alphanumeric,20,uppercase"
            />
          </div>
          <div class="row-display">
            <CheckBoxV2
              title="Container Count"
              :isChecked.sync="isContCount"
              @checkBoxClicked="contNoOrCount('count')"
              :isDisabled="cnEditIndex >= 0"
            />
            <Input
              placeholder="Cont Count"
              :inputValue.sync="contCount"
              textType="number"
              :isDisabled="!isContCount"
              :isRequired="isContCount"
              :errorMessage.sync="contCountError"
            />
          </div>
          <Input placeholder="Seal #" :inputValue.sync="sealNo" validator="text,20,uppercase,alphanumeric,space" />
          <div class="row-display">
            <Input
              placeholder="Cont. Operator"
              :inputValue.sync="contOp"
              :isRequired="true"
              :errorMessage.sync="contOpError"
              validator="text,15,uppercase,alphanumeric,space"
            />
            <Input placeholder="Ref #" :inputValue.sync="refNo" validator="text,20,uppercase,alphanumeric,space" />
          </div>
          <div class="row-display">
            <Dropdown
              placeholder="Size"
              :items="sizeItems"
              itemKey="Size"
              :selectedObject.sync="selectedSize"
              :isRequired="true"
              :errorMessage.sync="sizeError"
              :isDisabled="editCNBilledDisabled"
            />
            <Dropdown
              placeholder="Type"
              :items="typeItems"
              itemKey="Cont Type - Description"
              :selectedObject.sync="selectedType"
              :isRequired="true"
              :errorMessage.sync="typeError"
              :isDisabled="editCNBilledDisabled"
            />
          </div>
          <InputQuery
            placeholder="Handling"
            :items="handlingItems"
            itemKey="Handling Type - Description"
            descKey="Description"
            :selectedObject.sync="selectedHandling"
            :isRequired="true"
            :errorMessage.sync="handlingError"
            :isDisabled="editCNBilledDisabled"
          />
          <InputQuery
            placeholder="Delivery"
            :items="deliveryItems"
            itemKey="Delivery Type - Description"
            descKey="Description"
            :selectedObject.sync="selectedDelivery"
            :isRequired="true"
            :errorMessage.sync="deliveryError"
            :isDisabled="editCNBilledDisabled"
          />
          <InputQuery
            placeholder="Team"
            :items="teamItems"
            itemKey="Team"
            descKey="Description"
            :selectedObject.sync="selectedTeam"
          />
          <RadioButton
            :buttons="statusButtons"
            itemKey="title"
            :isHorizontal="true"
            title="Status"
            :isRequired="true"
            :errorMessage.sync="statusError"
          />
        </div>
        <div class="container-right">
          <div class="row-display">
            <Input
              placeholder="Temperature"
              :inputValue.sync="temperature"
              validator="text,10,uppercase,alphanumeric,space"
            />
            <Input placeholder="Measure" :inputValue.sync="measure" validator="text,15,uppercase,alphanumeric,space" />
          </div>
          <div class="row-display">
            <Input
              placeholder="Weight (KG)"
              :inputValue.sync="weight"
              :isRequired="true"
              :errorMessage.sync="weightError"
              validator="positiveDecimal,14,2"
            />
            <Input placeholder="Height" :inputValue.sync="height" validator="text,15,uppercase,alphanumeric,space" />
          </div>
          <Input
            placeholder="Commodity"
            :inputValue.sync="commodity"
            :isRequired="true"
            :errorMessage.sync="commodityError"
            validator="text,100,uppercase,alphanumeric,space"
          />
          <div class="row-display">
            <CheckBoxV2
              title="Required Time"
              style="white-space: nowrap; margin-right: 5px"
              :isChecked.sync="requiredDateTimeChk"
            />
            <DateTimePicker
              placeholder=""
              :isDisabled="!requiredDateTimeChk"
              :isRequired="requiredDateTimeChk"
              :value.sync="requiredTime"
              :maxDate="maxDate"
              :errorMessage.sync="dateErrMsg['requiredTime']"
              ref="requiredtime"
              @dateChanged="validateDates($event, 'requiredTime')"
            />
            <Dropdown
              style="flex: 1"
              :items="requiredTimeDescItems"
              itemKey="Description"
              placeholder="Required Time Desc."
              :selectedObject.sync="requiredTimeDescSelectedObject"
              :search.sync="requiredTimeDescSearch"
              :allowFreeText="true"
            />
          </div>
          <div style="display: flex; flex-wrap: wrap">
            <CheckBoxV2
              title="Office Hours? (D)"
              style="white-space: nowrap; margin-right: 5px"
              :isChecked.sync="isOfficeHrsD"
            />
            <CheckBoxV2
              title="Office Hours? (C)"
              style="white-space: nowrap; margin-right: 5px"
              :isChecked.sync="isOfficeHrsC"
            />
            <CheckBoxV2
              title="B2B?"
              style="white-space: nowrap; margin-right: 5px"
              :isChecked.sync="isb2b"
              :isDisabled="editCNBilledDisabled"
            />
            <CheckBoxV2
              title="Fumigation"
              style="white-space: nowrap; margin-right: 5px"
              :isChecked.sync="isFumigation"
            />
            <CheckBoxV2 title="Timbang" style="white-space: nowrap; margin-right: 5px" :isChecked.sync="isTimbang" />
          </div>
          <InputQuery
            placeholder="Billing Format"
            :items="billingFormatItems"
            itemKey="Description"
            descKey="Description"
            :selectedObject.sync="selectedBillingFormat"
            :isRequired="true"
            :errorMessage.sync="billingFormatError"
          />
          <div class="row-display">
            <Input placeholder="Haulage Tariff" :inputValue.sync="haulageTariff" :isDisabled="true" />
            <Input placeholder="Toll Tariff" :inputValue.sync="tollTariff" :isDisabled="true" />
          </div>
          <RemarksBox :text.sync="containerRemarks" :maxLength="200" />
        </div>
      </div>
      <div class="send-to-section">
        <BoxContainer title="Same as Job" :isCheckBox="true" :isChecked.sync="samePickUp">
          <InputQuery
            placeholder="Pick Up"
            :items="pickUpItems"
            itemKey="Description"
            descKey="Company"
            :selectedObject.sync="selectedPickUpCN"
            :isRequired="!samePickUp"
            :isDisabled="samePickUp"
            :errorMessage.sync="pickUpCNError"
          />
          <div class="address-container">{{ pickUpAddressCN }}</div>
        </BoxContainer>
        <BoxContainer title="Same as Job" :isCheckBox="true" :isChecked.sync="sameSendTo">
          <InputQuery
            placeholder="Send To"
            :items="sendToItems"
            itemKey="Description"
            descKey="Company"
            :selectedObject.sync="selectedSendToCN"
            :isRequired="!sameSendTo"
            :isDisabled="sameSendTo"
            :errorMessage.sync="sendToCNError"
          />
          <div class="row-display">
            <CheckBoxV2
              title="Diversion"
              :isChecked.sync="isDiversionCN"
              :isDisabled="samePickUp || editCNBilledDisabled"
            />
            <Dropdown
              placeholder="Premises Is"
              :items="premisesItems"
              itemKey="Premises Is"
              :selectedObject.sync="selectedPremisesCN"
              :isDisabled="samePickUp"
            />
          </div>
          <div class="address-container">{{ sendToAddressCN }}</div>
        </BoxContainer>
        <BoxContainer title="Same as Job" :isCheckBox="true" :isChecked.sync="sameDropOff">
          <InputQuery
            placeholder="Drop Off"
            :items="dropOffItems"
            itemKey="Description"
            descKey="Company"
            :selectedObject.sync="selectedDropOffCN"
            :isRequired="!sameDropOff"
            :isDisabled="sameDropOff"
            :errorMessage.sync="dropOffCNError"
          />
          <div class="address-container">{{ dropOffAddressCN }}</div>
        </BoxContainer>
      </div>
      <div class="button-section">
        <button @click="addConsignment">{{ cnEditIndex >= 0 ? 'Edit' : 'Add' }}</button>
        <button @click="openConsignmentPopup = false">Cancel</button>
      </div>
    </div>

    <!-- #region EROT -->
    <div v-if="showEROT" class="erot-popup">
      <div class="erot-content">
        <div class="top-section" :style="{ justifyContent: isVerification ? 'flex-start' : 'flex-end' }">
          <div v-if="isVerification" style="font-weight: bold">Scan Document</div>
          <ButtonFilter
            v-if="!isVerification"
            filterPosition="right"
            buttonText="Change Filter"
            :filterWidth="300"
            :isOpen.sync="erotFilterOpen"
          >
            <div class="filter-section">
              <Dropdown
                placeholder="Sender"
                :items="senderList"
                itemKey="From"
                :selectedObject.sync="selectedSender"
                :errorMessage.sync="senderError"
              />
              <BoxContainer title="ROTs">
                <CheckBoxV2
                  title="All ROTs"
                  @checkBoxClicked="rotCheckboxClicked('allROTChecked')"
                  :isChecked.sync="allROTChecked"
                />
                <!-- <CheckBox title="ROT Range" @checkBoxClicked="rotCheckboxClicked('rangeROTChecked')" :isChecked.sync="rangeROTChecked" /> -->
                <BoxContainer
                  title="ROT Range"
                  :isCheckBox="true"
                  :isChecked.sync="rangeROTChecked"
                  @checkBoxClicked="rotCheckboxClicked('rangeROTChecked')"
                >
                  <Dropdown
                    placeholder="Range Selection"
                    :isDisabled="!rangeROTChecked"
                    :items="filterList"
                    itemKey="Filter"
                    @selected="rangeSelected"
                    :selectedObject.sync="selectedRange"
                    :isRequired="rangeROTChecked"
                    :errorMessage.sync="selectionError"
                  />
                  <div v-if="isDateTime">
                    <DateTimePicker
                      placeholder="From"
                      :isDisabled="!rangeROTChecked"
                      :value.sync="filter1"
                      :isRequired="rangeROTChecked"
                      :errorMessage.sync="fromError"
                    />
                    <DateTimePicker
                      placeholder="To"
                      :isDisabled="!rangeROTChecked"
                      :value.sync="filter2"
                      :isRequired="rangeROTChecked"
                      :errorMessage.sync="toError"
                    />
                  </div>
                  <div v-else>
                    <Dropdown
                      placeholder="From"
                      :isDisabled="!rangeROTChecked"
                      :items="rangeSelectionListAsc"
                      itemKey="Item"
                      :selectedObject.sync="filter1"
                      :isRequired="rangeROTChecked"
                      :errorMessage.sync="fromError"
                    />
                    <Dropdown
                      placeholder="To"
                      :isDisabled="!rangeROTChecked"
                      :items="rangeSelectionListDesc"
                      itemKey="Item"
                      :selectedObject.sync="filter2"
                      :isRequired="rangeROTChecked"
                      :errorMessage.sync="toError"
                    />
                  </div>
                </BoxContainer>
              </BoxContainer>
              <button class="refresh-button" @click="refreshROTClicked">Refresh</button>
            </div>
          </ButtonFilter>
          <div v-if="!isVerification">Last Refreshed: {{ eROTLastRefreshed }}</div>
        </div>
        <div class="table-section">
          <div v-show="isVerification" class="verification-upload">
            <Input textType="file" @fileChanged="uploadFileChanged" ref="uploadInput" :placeholder="'Browse'" />
            <object :data="uploadFileBase64"></object>
          </div>
          <TableBox
            v-show="!isVerification"
            title="eROT"
            :tableData="erotListing"
            :loading="erotLoading"
            :selectedRow.sync="selectedROT"
            :hideColumns="erotHideColumns"
            :additionalButtons="erotAdditionalButtons"
            @buttonClicked="eROTTableBoxButtonClicked"
          />
        </div>
        <div class="bottom-section">
          <button v-if="!isVerification" :disabled="selectedROT.length == 0" @click="eROTAccept">Accept</button>
          <button v-if="!isVerification" :disabled="selectedROT.length == 0" @click="eROTReject">Reject</button>
          <button v-if="isVerification" :disabled="!uploadFileBase64" @click="scanDocumentClicked"
            >Scan Document</button
          >
          <button class="cancel-btn" @click="showEROT = false">Cancel</button>
        </div>
      </div>
      <div v-if="showeROTContainersPopup" class="erot-containers-popup-container">
        <div class="erot-containers-popup">
          <div class="table-box-container">
            <TableBox
              :tableData="eROTContainersPopupTableData"
              :title="eROTContainersPopupTableBoxTitle"
              :hideColumns="eROTContainersPopupTableBoxHideColumns"
            />
          </div>
          <div class="call-to-action-buttons">
            <button @click="eROTContainersPopupCloseClicked">Close</button>
          </div>
        </div>
      </div>
    </div>

    <Verification
      v-if="showVerification"
      :show.sync="showVerification"
      :sections="eROTSections"
      @confirmClicked="verificationConfirm"
      showAttachment
      :attachmentsList="eROTAttachments"
      :title="verificationTitle"
      @submittedRefreshClicked="verificationSubmittedRefreshClicked"
    >
      <div slot="Job Information"></div>
      <div slot="Send To / Container Information"></div>
      <div slot="Voyage Information"></div>
    </Verification>

    <PopupV2
      :show="showeROTReject"
      type="warning"
      title="Reject eROT"
      :buttons="eROTRejectButtons"
      @buttonClicked="eROTRejectButtonsClicked"
    >
      <div class="erot-reject-content">
        <div
          >You're about to reject an eROT with Request No:
          {{ selectedROT.length > 0 ? selectedROT[0]['Request #'] : '' }}</div
        ><br />
        <div
          >Please enter the email addresses that the notice will be sent to, the message of the email and reason for the
          eROT rejection.</div
        ><br />
        <EmailInput style="margin-bottom: 5px" title="To" :mails.sync="rejectToEmails" />
        <div class="collapsible-title-container" @click="showCC = !showCC">
          <img
            :style="{ transform: `scaleY(${showCC ? '-1' : '1'})` }"
            src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png"
          />
          <div>CC ({{ rejectCCEmails.length }})</div>
        </div>
        <EmailInput v-if="showCC" style="margin-bottom: 5px" title="CC" :mails.sync="rejectCCEmails" />
        <div class="collapsible-title-container" @click="showBCC = !showBCC">
          <img
            :style="{ transform: `scaleY(${showBCC ? '-1' : '1'})` }"
            src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png"
          />
          <div>BCC ({{ rejectBCCEmails.length }})</div>
        </div>
        <EmailInput v-if="showBCC" style="margin-bottom: 5px" title="BCC" :mails.sync="rejectBCCEmails" />
        <RemarksBox
          class="message-reason-container"
          title="Email Message"
          :freeText="true"
          :text.sync="eROTRejectMessage"
        />
        <RemarksBox
          class="message-reason-container"
          title="Reason for Rejection"
          :freeText="true"
          :text.sync="eROTRejectReason"
        />
      </div>
    </PopupV2>

    <PopupV2
      :show="eROTCNErrorPopup"
      type="warning"
      title="Error Adding Consignments"
      :buttons="eROTCNErrorButtons"
      @buttonClicked="eROTCNErrorButtonsClicked"
    >
      <div class="erotcn-error-popup-content">
        <div class="caption">
          The below field(s) are required but it is empty in one or more consignment(s).<br /><br />
          The value selected/entered will automatically populated for all the consignment that is empty.
        </div>

        <div class="content">
          <Input
            v-if="eROToperatorcodeList.length > 0"
            placeholder="Cont Op"
            :inputValue.sync="contOp"
            :isRequired="true"
            :errorMessage.sync="contOpError"
          />
          <Dropdown
            v-if="eROTcncontsizeList.length > 0"
            placeholder="Size"
            :items="sizeItems"
            itemKey="Size"
            :selectedObject.sync="selectedSize"
            :isRequired="true"
            :errorMessage.sync="sizeError"
          />
          <Dropdown
            v-if="eROTcnconttypeList.length > 0"
            placeholder="Type"
            :items="typeItems"
            itemKey="Cont Type - Description"
            :selectedObject.sync="selectedType"
            :isRequired="true"
            :errorMessage.sync="typeError"
          />
          <InputQuery
            v-if="eROTcnhandlingtypeList.length > 0"
            placeholder="Handling"
            :items="handlingItems"
            itemKey="Handling Type - Description"
            descKey="Description"
            :selectedObject.sync="selectedHandling"
            :isRequired="true"
            :errorMessage.sync="handlingError"
          />
          <InputQuery
            v-if="eROTcndeliverytypeList.length > 0"
            placeholder="Delivery"
            :items="deliveryItems"
            itemKey="Delivery Type - Description"
            descKey="Description"
            :selectedObject.sync="selectedDelivery"
            :isRequired="true"
            :errorMessage.sync="deliveryError"
          />
          <RadioButton
            v-if="eROTcnstatusList.length > 0"
            :buttons="statusButtons"
            itemKey="title"
            :isHorizontal="true"
            title="Status"
            :isRequired="true"
            :errorMessage.sync="statusError"
          />
          <Input
            v-if="eROTcommodityList.length > 0"
            placeholder="Commodity"
            :inputValue.sync="commodity"
            :isRequired="true"
            :errorMessage.sync="commodityError"
          />
          <InputQuery
            v-if="eROTbillingfmtList.length > 0"
            placeholder="Billing Format"
            :items="billingFormatItems"
            itemKey="Description"
            descKey="Description"
            :selectedObject.sync="selectedBillingFormat"
            :isRequired="true"
            :errorMessage.sync="billingFormatError"
          />
        </div>
      </div>
    </PopupV2>
    <!-- #endregion -->

    <PopupV2
      :show="showContNoPopup"
      type="info"
      title="Add Container No"
      @buttonClicked="containerNoButtonClicked"
      :buttons="contNoPopupButtons"
    >
      <div>You'll need to add {{ contCount }} container number(s)</div>
      <Input
        placeholder="Container Number"
        :inputValue.sync="contToAdd"
        :errorMessage.sync="contToAddError"
        :isDisabled="contList.length == parseInt(contCount)"
        :isContainer="isContainerCheck"
        :isRequired="true"
        validator="alphanumeric,20,uppercase"
        ref="contnoinput"
      />
      <button @click="addContainerNo" :disabled="contList.length == parseInt(contCount)">Add</button>
      <div style="margin-top: 5px">Added {{ contList.length }} of {{ contCount }} container number(s)</div>
      <div class="cont-listing" v-if="contList.length > 0">
        <div class="cont-no" v-for="(c, i) in contList" :key="i">
          <img
            class="delete-cont-no"
            @click="deleteContainerNumber(i)"
            src="https://dsmlib.logistics.systems/Icons/Delete.png"
          />
          {{ c }}
        </div>
      </div>
      <div style="color: red">{{ addContainerError }}</div>
    </PopupV2>

    <PopupV2
      :show="showJobTypePopup"
      title="Select your Job Type"
      @buttonClicked="jobTypeButtonClicked"
      :buttons="jobTypePopupButtons"
    >
      <div :style="{ height: isJobTypeDropdownFocus ? '300px' : '' }">
        <Dropdown
          placeholder="Job Type"
          :items="jobTypeItems"
          itemKey="Job Type"
          :selectedObject.sync="selectedJobType"
          :isRequired="true"
          :errorMessage.sync="jobTypeError"
          ref="jobtype"
          :isDisabled="viewMode"
          @focusChanged="jobTypePopupDropdownFocus"
        />
      </div>
    </PopupV2>

    <PopupV2 :show="showEditPopup" title="Edit Job" @buttonClicked="editPopupButtonClicked" :buttons="editPopupButtons">
      <div>{{ editCheckingMessage }}</div>
      <div>Are you sure you want to edit Job # {{ selectedJob.length > 0 ? selectedJob[0]['Job No'] : '' }}?</div>
      <Input
        placeholder="Remarks"
        :inputValue.sync="editRemarks"
        :errorMessage.sync="editRemarksError"
        :isRequired="true"
      />
    </PopupV2>

    <PopupV2
      :show="showEditCNPopup"
      title="Edit Job"
      @buttonClicked="editCNPopupButtonClicked"
      :buttons="editPopupButtons"
    >
      <div>{{ editCNCheckingMessage }}</div>
      <div>Are you sure you want to edit Consignment # {{ editCNData ? editCNData['Consignment No'] : '' }}?</div>
      <Input
        placeholder="Remarks"
        :inputValue.sync="editCNRemarks"
        :errorMessage.sync="editCNRemarksError"
        :isRequired="true"
      />
    </PopupV2>

    <PopupV2
      :show="showDeletePopup"
      title="Delete Job"
      @buttonClicked="deletePopupButtonClicked"
      :buttons="deletePopupButtons"
    >
      <div>Are you sure you want to delete Job # {{ selectedJob.length > 0 ? selectedJob[0]['Job No'] : '' }}?</div>
      <div v-if="selectedJob.length > 0 ? selectedJob[0]['Job Assigned'] > 0 : false"
        ><br />Consignment under this Job ('{{ selectedJob.length > 0 ? selectedJob[0]['Job No'] : '' }}') has been
        assigned. Continue to delete?</div
      >

      <Input placeholder="Remarks" :inputValue.sync="deleteRemarks" :errorMessage.sync="deleteRemarksError" />
    </PopupV2>

    <PopupV2
      :show="showDeleteCNPopup"
      title="Delete Consignment"
      @buttonClicked="deleteCNPopupButtonClicked"
      :buttons="deletePopupButtons"
    >
      <div
        >Are you sure you want to delete Consignment #
        {{ selectedConsignments.length > 0 ? selectedConsignments[0]['Consignment No'] : '' }}?</div
      >
      <div v-if="selectedConsignments.length > 0 ? selectedConsignments[0]['Assigned'] > 0 : false"
        ><br />Consignment has been assigned. Continue to delete?</div
      >

      <Input
        placeholder="Remarks"
        :inputValue.sync="deleteCNRemarks"
        :errorMessage.sync="deleteCNRemarksError"
        :isRequired="true"
      />
    </PopupV2>

    <PopupV2
      :show="showCreateDiversion"
      height="650px"
      width="75%"
      style="display: flex"
      :title="diversiontTitle"
      @buttonClicked="diversionButtonClicked"
      :buttons="diversionButtons"
    >
      <div style="height: 100%; width: 100%">
        <div style="height: 100%; width: 100%">
          <!-- loc 1 -->
          <dir style="display: flex; width: 100%; flex-direction: row; padding-left: 0px; margin: 0px">
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <InputQuery
                  placeholder="Diversion Loc 1"
                  :isDisabled="diversionDetails.length >= 1"
                  :items.sync="diversionLocation"
                  itemKey="Destination Code"
                  descKey="Opr Area Code"
                  :selectedObject.sync="selectedDiversionLoc1"
                />
              </div>
              <RemarksBox
                title="Diversion Loc 1"
                :isDisabled="diversionDetails.length >= 1"
                style="height: 100px"
                :maxLength="200"
                :text.sync="diversionLoc1"
              />
            </div>
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <CheckBoxV2
                  :isChecked.sync="internalDiversionLoc1"
                  :isDisabled="diversionDetails.length >= 1"
                  style="margin-left: 5px; width: 100%; place-content: center"
                  title="Internal"
                />
                <div style="display: flex">
                  <button v-if="diversionDetails.length == 1" @click="deleteButtonClicked('1')">
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Cross.png" />
                  </button>
                  <button
                    @click="printButtonClicked(internalDiversionLoc1 ? '1' : '0', cnnoLoc1, '1')"
                    style="margin-left: 5px"
                  >
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Print.png" />
                  </button>
                </div>
              </div>
              <RemarksBox
                :isDisabled="diversionDetails.length >= 1"
                style="height: 100px"
                title="Remarks"
                :maxLength="200"
                :text.sync="remarksDiversionLoc1"
              />
            </div>
          </dir>
          <!-- loc 2 -->
          <dir style="display: flex; width: 100%; flex-direction: row; padding-left: 0px; margin: 0px">
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <InputQuery
                  :isDisabled="diversionDetails.length >= 2 || diversionDetails.length == 0"
                  placeholder="Diversion Loc 2"
                  :items.sync="diversionLocation"
                  itemKey="Destination Code"
                  descKey="Opr Area Code"
                  :selectedObject.sync="selectedDiversionLoc2"
                />
              </div>
              <RemarksBox
                title="Diversion Loc 2"
                :isDisabled="diversionDetails.length >= 2 || diversionDetails.length == 0"
                style="height: 100px"
                :maxLength="200"
                :text.sync="diversionLoc2"
              />
            </div>
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <CheckBoxV2
                  :isChecked.sync="internalDiversionLoc2"
                  :isDisabled="diversionDetails.length >= 2 || diversionDetails.length == 0"
                  style="margin-left: 5px; width: 100%; place-content: center"
                  title="Internal"
                />
                <div style="display: flex">
                  <button v-if="diversionDetails.length == 2" @click="deleteButtonClicked('2')">
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Cross.png" />
                  </button>
                  <button
                    :disabled="!selectedDiversionLoc2 && diversionDetails.length == 0"
                    @click="printButtonClicked(internalDiversionLoc2 ? '1' : '0', cnnoLoc2, '2')"
                    style="margin-left: 5px"
                  >
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Print.png" />
                  </button>
                </div>
              </div>
              <RemarksBox
                :isDisabled="diversionDetails.length >= 2 || diversionDetails.length == 0"
                style="height: 100px"
                title="Remarks"
                :maxLength="200"
                :text.sync="remarksDiversionLoc2"
              />
            </div>
          </dir>
          <!-- loc 3 -->
          <dir style="display: flex; width: 100%; flex-direction: row; padding-left: 0px; margin: 0px">
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <InputQuery
                  :isDisabled="diversionDetails.length >= 3 || diversionDetails.length <= 1"
                  placeholder="Diversion Loc 3"
                  :items.sync="diversionLocation"
                  itemKey="Destination Code"
                  descKey="Opr Area Code"
                  :selectedObject.sync="selectedDiversionLoc3"
                />
              </div>
              <RemarksBox
                title="Diversion Loc 3"
                :isDisabled="diversionDetails.length >= 3 || diversionDetails.length <= 1"
                style="height: 100px"
                :maxLength="200"
                :text.sync="diversionLoc3"
              />
            </div>
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <CheckBoxV2
                  :isDisabled="diversionDetails.length >= 3 || diversionDetails.length <= 1"
                  :isChecked.sync="internalDiversionLoc3"
                  style="margin-left: 5px; width: 100%; place-content: center"
                  title="Internal"
                />
                <div style="display: flex">
                  <button v-if="diversionDetails.length == 3" @click="deleteButtonClicked('3')">
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Cross.png" />
                  </button>
                  <button
                    :disabled="!selectedDiversionLoc3 && diversionDetails.length <= 1"
                    @click="printButtonClicked(internalDiversionLoc3 ? '1' : '0', cnnoLoc3, '3')"
                    style="margin-left: 5px"
                  >
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Print.png" />
                  </button>
                </div>
              </div>
              <RemarksBox
                :isDisabled="diversionDetails.length >= 3 || diversionDetails.length <= 1"
                style="height: 100px"
                title="Remarks"
                :maxLength="200"
                :text.sync="remarksDiversionLoc3"
              />
            </div>
          </dir>
          <!-- loc 4 -->
          <dir style="display: flex; width: 100%; flex-direction: row; padding-left: 0px; margin: 0px">
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <InputQuery
                  :isDisabled="
                    (diversionDetails.length <= 2 && diversionDetails.length > 0) ||
                    cnnoLoc4 != '' ||
                    diversionDetails.length == 0
                  "
                  placeholder="Diversion Loc 4"
                  :items.sync="diversionLocation"
                  itemKey="Destination Code"
                  descKey="Opr Area Code"
                  :selectedObject.sync="selectedDiversionLoc4"
                />
              </div>
              <RemarksBox
                title="Diversion Loc 4"
                :isDisabled="
                  (diversionDetails.length <= 2 && diversionDetails.length > 0) ||
                  cnnoLoc4 != '' ||
                  diversionDetails.length == 0
                "
                style="height: 100px"
                :maxLength="200"
                :text.sync="diversionLoc4"
              />
            </div>
            <div style="width: 100%; padding: 5px">
              <div style="display: flex; width: 100%">
                <CheckBoxV2
                  :isDisabled="
                    (diversionDetails.length <= 2 && diversionDetails.length != 0) ||
                    cnnoLoc4 != '' ||
                    diversionDetails.length == 0
                  "
                  :isChecked.sync="internalDiversionLoc4"
                  style="margin-left: 5px; width: 100%; place-content: center"
                  title="Internal"
                />
                <div style="display: flex">
                  <button v-if="diversionDetails.length == 4" @click="deleteButtonClicked('4')">
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Cross.png" />
                  </button>
                  <button
                    :disabled="!selectedDiversionLoc4"
                    @click="printButtonClicked(internalDiversionLoc4 ? '1' : '0', cnnoLoc4, '4')"
                    style="margin-left: 5px"
                  >
                    <img height="15" src="https://dsmlib.logistics.systems/Icons/Print.png" />
                  </button>
                </div>
              </div>
              <RemarksBox
                :isDisabled="
                  (diversionDetails.length <= 2 && diversionDetails.length != 0) ||
                  cnnoLoc4 != '' ||
                  diversionDetails.length == 0
                "
                style="height: 100px"
                title="Remarks"
                :maxLength="200"
                :text.sync="remarksDiversionLoc4"
              />
            </div>
          </dir>
        </div>
      </div>
    </PopupV2>

    <PopupV2
      icon="https://dsmlib.logistics.systems/Icons/Print.png"
      :title="printDiversionTitle"
      :show="showPrintDiversion"
      height="300px"
      width="400px"
      :buttons="printDiversionButtons"
      @buttonClicked="printDiversionPopupClicked"
    >
      <div style="padding: 10px; width: 100%; overflow: hidden">
        <!-- <div style="display: flex; padding: 5px"> -->
        <div style="padding: 5px" v-if="showIndividualPrintDiversion">{{
          'Divert ' + printDiversionTitleOri + ' to ' + printDiversionTitleDivert
        }}</div>
        <br />
        <br />
        <CheckBoxV2
          style="margin-left: 5px; width: 100%; place-content: center"
          :isChecked.sync="useOriDest"
          title="Pickup from original destination"
        />
        <!-- <button @click="menuClicked({ title: 'Print Diversion' })" title="Print">
            <img height="25" src="https://dsmlib.logistics.systems/Icons/PrintFilled.png"/>
          </button> -->
        <!-- </div> -->
      </div>
    </PopupV2>

    <PopupV2
      type="warning"
      :show="showDeleteDivPopup"
      title="Delete Diversion"
      @buttonClicked="deleteDivButtonClicked"
      :buttons="deletePopupButtons"
    >
      <div>Are you sure you want to delete diversion record ?</div>
      <div>Note: Delete action is not reversible!</div>
      <br />
      <Input
        placeholder="Delete Reaason"
        :inputValue.sync="deleteDivRemarks"
        :isRequired="true"
        :errorMessage.sync="deleteDivError"
      />
    </PopupV2>

    <PopupV2
      :show="confirmSavePopup"
      type="warning"
      title="Saving Job"
      :buttons="savePopupButtons"
      @buttonClicked="confirmSavePopupClicked"
    >
      <RadioButtonSet
        title="Save Job as"
        :buttons="saveRadioButton"
        labelKey="label"
        :selected.sync="selectedSaveBy"
        :isRequired="true"
        :isDisabled="viewMode"
        :isHorizontal="true"
        style="margin-bottom: 5px"
      />
      <div v-if="!saveAsConfirm" :style="{ textAlign: 'left', minHeight: reasonOpen ? '200px' : '' }">
        <Dropdown
          :isRequired="true"
          placeholder="Reason"
          :items="reasonsList"
          :selectedObject.sync="selectedUnconfirmReason"
          itemKey="Reason"
          @focusChanged="reasonOpen = $event"
          :errorMessage.sync="selectedUnconfirmReasonError"
        />
        <Input
          :isRequired="selectedUnconfirmReason ? selectedUnconfirmReason['Reason'].includes('OTHERS') : false"
          placeholder="Remarks"
          :inputValue.sync="unconfirmRemarks"
          :errorMessage.sync="unconfirmRemarksError"
        />
      </div>
    </PopupV2>

    <PopupV2
      :show.sync="showPrintPermissionPopup"
      type="error"
      title="Could Not Print"
      :buttons="printPermissionPopupButtons"
      width="45%"
      @buttonClicked="printPermissionPopupButtonClicked"
    >
      The following consignments could not be printed<br />
      <br />
      <table border="1">
        <tr>
          <th>Consignment No.</th>
          <th>Reason</th>
        </tr>
        <tr v-for="consignment in printPermissionPopupConsignmentReasons" :key="consignment['cnno']">
          <td>{{ consignment['cnno'] }}</td>
          <td>{{ consignment['retmsg'] }}</td>
        </tr>
      </table>
    </PopupV2>

    <div v-if="designerV2IsShown" class="designer-v2-container">
      <div class="designer-v2-component-container">
        <DesignerV2
          :show.sync="designerV2IsShown"
          :viewMode="true"
          :reportFile="isDivert ? designerV2ReportFileDiversion : designerV2ReportFile"
          reportFolder="ROTForm"
          :reportData="designerV2ReportData"
          :downloadName="designerV2DownloadName"
          :showBackground.sync="designerV2ShowBackground"
          @afterprint="designerV2AfterPrint"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StatusPage from '@/pages/Home/StatusPage.vue';

export default {
  components: {
    StatusPage,
  },
  computed: {
    designerV2DownloadName: function () {
      if (!this.selectedJob || this.selectedJob.length == 0) {
        return 'CN';
      }

      return `CN_${this.selectedJob[0]['Job No']}`;
    },
    requestNoIsRequired: function () {
      if (this.settingsSystemRequestNo === null) {
        return false; // optional by default
      }

      return this.settingsSystemRequestNo === 1 || this.settingsSystemRequestNo === '1';
    },
    forwardingAgentIsRequired: function () {
      if (this.settingsSystemOPFwdgAgt === null) {
        return true; // required by default
      }

      return this.settingsSystemOPFwdgAgt === 1 || this.settingsSystemOPFwdgAgt === '1';
    },
    consignmentListWithoutDelete: function () {
      return this.consignmentList.filter((consignment) => {
        return consignment['CN State'] != 'Cancel';
      });
    },
    consignmentListFiltered: function () {
      // total number of consignments by filter out deleted/cancelled consignments
      return this.consignmentList.filter((consignment) => {
        return consignment['CN State'] !== 'Cancel' && consignment.isDeletedJobChange !== 'deletedJobChange';
      });
    },
    saveAsConfirm: function () {
      return this.selectedSaveBy?.keyValue === '1';
    },
  },
  data: function () {
    return {
      lastRefreshed: '',
      loginDetails: null,

      showEROT: false,
      showeROTContainersPopup: false,
      isVerification: false,
      uploadFileBase64: '',
      uploadFile: null,

      menu: [
        // most start out as disabled, will be enabled in mounted once loading of masterfiles are complete
        {
          title: 'New Job',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png',
          enabled: false,
          key: 'MnuNew',
        },
        {
          title: 'Edit Job',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          enabled: false,
          key: 'MnuEdit',
        },
        {
          title: 'Delete Job',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png',
          enabled: false,
          key: 'MnuDelete',
        },
        { title: 'View Job', icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png', enabled: false },
        { title: 'Print CN', icon: 'https://dsmlib.logistics.systems/Icons/Print.png', enabled: false },
        { title: 'eROT', icon: 'https://dsmlib.logistics.systems/Icons/eROT.png', enabled: false },
        { title: 'Scan Document', icon: 'https://dsmlib.logistics.systems/Icons/ScanDocument.png', enabled: false },
        {
          title: 'View/Create Diversion',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png',
          enabled: false,
        },
        { title: 'Print Diversion', icon: 'https://dsmlib.logistics.systems/Icons/Print.png', enabled: false },
        {
          title: 'Job Charges',
          icon: 'https://dsmlib.logistics.systems/Icons/money.png',
          enabled: false,
          key: 'MnuJobCharges',
        },
      ],

      filterIsDisabled: true,
      filterIsOpen: false,
      filterDate: true,
      filterSearch: false,
      diverpickupori: '0',
      diverinternal: '',
      cnno: '',
      diverseqno: '',

      jobTypeItems: [],
      allJobTypes: [],
      selectedFilterJobType: null,
      searchByItems: [],
      selectedFilterSearchBy: null,
      searchByErrorMessage: '',
      searchCriteriaItems: [{ name: 'EQUALS' }, { name: 'STARTS WITH' }, { name: 'CONTAINS' }, { name: 'ENDS WITH' }],
      selectedFilterSearchCriteria: null,
      hms_Default_Trip: '',
      searchCriteriaErrorMessage: '',
      searchInputValue: '',
      searchInputErrorMessage: '',

      fromDate: new Date(),
      fromDateErrorMessage: '',
      toDate: new Date(),
      toDateErrorMessage: '',
      jobData: [],
      jobDataType: {
        '#': 'number',
        'Job DateTime': 'datetime',
        'Total 20': 'number',
        'Total 40': 'number',
        'Closing Time': 'datetime',
        ETA: 'datetime',
        'Job Assigned': 'number',
        Printed: 'number',
      },
      selectedJob: [],
      tableBoxColumnOrderViews: [],
      columnOrderViewsByReportName: {},
      tableBoxColumnOrderID: null,
      jobTableBoxIsLoading: false,
      filterText: '',

      popupShow: false,
      popupTitle: '',
      createdBy: '',
      updatedBy: '',
      requiredError: [],
      successMessages: [],
      errorMessages: [],
      viewMode: false,
      eROTDisable: false,
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2079, 0, 1),
      dateErrMsg: {
        jobDateTime: '',
        etaDateTime: '',
        etdDateTime: '',
        closeDateTime: '',
        demurageDate: '',
        detentionDate: '',
        requiredTime: '',
      },

      showMilestoneLoader: false,
      showMilestones: true,
      milestonesItem: null,

      settingsSystemRequestNo: null,
      settingsSystemOPFwdgAgt: null,

      tabsItems: [
        { title: 'Quick Entry', disabled: false },
        { title: 'Job Information', disabled: false },
        { title: 'Send To / Container Information', disabled: false },
        { title: 'Voyage Information', disabled: false },
        { title: 'Documents', disabled: false },
        { title: 'TAS & KPI', disabled: true },
      ],
      tabIndex: 0,

      //#region Job Info Data
      jobNo: '',
      urgent: false,
      jobDateTime: null,
      shipperCaption: 'Shipper',
      shipperItems: [],
      selectedShipper: null,
      shipperError: '',
      custRefNo: '',
      projectNo: '',
      requestNo: '',
      requestNoError: '',
      prevrefjobno: '',

      billToItems: [],
      selectedBillTo: null,
      billToError: '',
      billToDetails: null,
      outstanding: '',
      status: '',
      creditLimit: '',
      crTerm: '',
      chequeItems: [],
      selectedCheque: null,
      paymentError: '',
      contact: '',
      tel: '',
      fax: '',
      selectedJobType: null,
      jobTypeError: '',
      tripItems: [],
      selectedTrip: null,
      tripError: '',
      coeff: '',
      coeffError: '',
      coeffDisable: false,
      keepCharges: false,
      keepChargesDisable: false,

      checkJobTypeChange: true,
      //#endregion

      //#region Job Charges
      showJobChargesPopup: false,
      jobChargesButtons: [
        // { text: 'View Job Charges', color: 'green', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],
      //#endregion

      //#region Send To / Container Data
      openSendTo: true,
      openConsignment: true,

      pickUpItems: [],
      selectedPickUp: null,
      pickUpError: '',
      pickUpAddress: '',
      isDiversion: false,
      premisesItems: [],
      selectedPremises: null,
      sendToItems: [],
      selectedSendTo: null,
      sendToError: '',
      sendToAddress: '',
      dropOffItems: [],
      selectedDropOff: null,
      dropOffError: '',
      dropOffAddress: '',

      consignmentList: [],
      tableEditButton: [{ text: 'Edit', index: 0, width: 60 }],
      selectedConsignments: [],
      consignmentToDelete: [],

      cdaNo: '',
      contNo: '',
      isContNo: true,
      contNoError: '',
      contCount: '',
      isContCount: false,
      contCountError: '',
      sealNo: '',
      contOp: '',
      contOpError: '',
      refNo: '',
      sizeItems: [],
      selectedSize: null,
      sizeError: '',
      typeItems: [],
      selectedType: null,
      typeError: '',
      handlingItems: [],
      selectedHandling: null,
      handlingError: '',
      deliveryItems: [],
      selectedDelivery: null,
      deliveryError: '',
      teamItems: [],
      selectedTeam: null,
      statusButtonsOri: [
        { title: 'Laden', checked: false },
        { title: 'Empty', checked: false },
      ],
      statusButtons: [
        { title: 'Laden', checked: false },
        { title: 'Empty', checked: false },
      ],
      statusError: '',
      containerRemarks: '',
      temperature: '',
      measure: '',
      weight: '',
      weightError: '',
      height: '',
      commodity: '',
      commodityError: '',
      requiredDateTimeChk: false,
      requiredTime: null,
      requiredTimeDescItems: [
        { Description: '-' },
        { Description: 'Before' },
        { Description: 'After' },
        { Description: 'Exactly' },
        { Description: 'ASAP' },
        { Description: 'Call B4Dly' },
        { Description: 'Morning' },
        { Description: 'Night' },
      ],
      requiredTimeDescSelectedObject: null,
      requiredTimeDescSearch: '',
      isOfficeHrsD: false,
      isOfficeHrsC: false,
      isb2b: false,
      isFumigation: false,
      isTimbang: false,
      billingFormatItems: [],
      selectedBillingFormat: null,
      billingFormatError: '',
      haulageTariff: '',
      tollTariff: '',

      openConsignmentPopup: false,

      samePickUp: true,
      sameSendTo: true,
      sameDropOff: true,

      selectedSendToCN: null,
      sendToCNError: '',
      sendToAddressCN: '',
      selectedPickUpCN: null,
      pickUpCNError: '',
      pickUpAddressCN: '',
      selectedDropOffCN: null,
      dropOffCNError: '',
      dropOffAddressCN: '',

      isDiversionCN: false,
      selectedPremisesCN: null,

      cnEditIndex: -1,
      //#endregion

      //#region Voyage Info Data
      shipCallNoItems: [],
      selectedShipCallNo: null,
      shipCallNoFreeText: '',
      shipCallError: '',
      voyNo: '',
      voyNoError: '',
      vesselCodeItems: [],
      selectedVesselCode: null,
      transhipPortItems: [],
      selectedTranshipPort: null,
      dischargeItems: [],
      selectedDischargePort: null,
      dischargePortFreeText: '',
      etaDateTime: null,
      etdDateTime: null,
      closeDateTime: null,
      closeDateTimeDisable: false,
      demurageDate: null,
      demurageDateDisable: false,
      detentionDate: null,
      detentionDateDisable: false,

      shippingLine: '',
      shippingAgentItems: [],
      selectedShippingAgent: null,
      shipAgtTel: '',
      shipAgtFax: '',
      fwdgAgentItems: [],
      selectedFwdgAgent: null,
      fwdgAgentError: '',
      fwdgAgtTel: '',
      fwdgAgtFax: '',
      bookingRefNo: '',
      bookingRefNoError: '',
      bookingRefNoRequired: false,
      requestedBy: '',
      finalDestination: '',
      premisOffload: false,

      freeStorage: '',
      storageUnit: 'D',
      freeDemurrage: '',
      demurrageUnit: 'D', 
      freeDetention: '', 
      detentionUnit: 'D',
      //#endregion

      //#region Documents Data
      showDocumentsLoader: false,
      docStatusPopup: false,

      editDocumentsList: [],

      documentsData: [],
      selectedDocuments: [],
      documentsToDelete: [],
      //#endregion

      //#region TAS & KPI Data
      showTASAndKPILoader: false,
      statusTaskJobNo: '',
      statusTaskDocuments: [],
      statusTaskStatusData: [],
      //#endregion

      //#region Container No popup
      showContNoPopup: false,
      contToAdd: '',
      contToAddError: '',
      contList: [],
      resolveContainerNo: null,
      contNoPopupButtons: [{ text: 'Confirm Containers' }, { text: 'Cancel', color: 'lightgray', textColor: 'black' }],
      addContainerError: '',
      //#endregion

      //#region Job Type popup
      showJobTypePopup: false,
      jobTypePopupButtons: [{ text: 'Confirm Job Type' }, { text: 'Cancel', color: 'lightgray', textColor: 'black' }],
      isJobTypeDropdownFocus: false,
      //#endregion

      //#region Edit Popup
      showEditPopup: false,
      showEditCNPopup: false,
      editStatus: '',
      editCNStatus: '',
      editJobDisabled: false,
      editJobBilledDisabled: false,
      editJobPaidDisabled: false,
      editCNDisabled: false,
      editCNBilledDisabled: false,
      editCNPaidDisabled: false,
      editPopupButtons: [{ text: 'Yes' }, { text: 'No', color: 'lightgray', textColor: 'white' }],
      editCheckingMessage: '',
      editCNCheckingMessage: '',
      editCNData: null,
      editRemarks: '',
      editRemarksError: '',
      editCNRemarks: '',
      editCNRemarksError: '',

      //#endregion

      //#region Delete Popup
      showDeletePopup: false,
      showDeleteCNPopup: false,
      deletePopupButtons: [
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],
      deleteRemarks: '',
      deleteRemarksError: '',
      deleteCNRemarks: '',
      deleteCNRemarksError: '',
      //#endregion

      //#region eROT
      senderError: '',
      erotFilterOpen: false,
      filterList: [],
      selectedRange: null,
      selectionError: '',
      filter1: null,
      fromError: '',
      filter2: null,
      toError: '',
      senderList: [],
      selectedSender: null,

      erotListing: [],
      selectedROT: [],
      erotLoading: false,
      erotHideColumns: ['Containers', 'eROTAtt', 'WebAtt1', 'WebAtt2', 'eROTFMS'],
      erotAdditionalButtons: [{ text: 'Containers', index: 0, width: 110 }],

      allROTChecked: true,
      rangeROTChecked: false,
      isDateTime: false,

      rangeSelectionListAsc: [],
      rangeSelectionListDesc: [],

      showVerification: false,
      verificationTitle: '',
      eROTSections: [],
      eROTLastRefreshed: '',

      eROTRequestNo: '',
      eROTFullDetails: null,

      eROTDetectedData: null,
      eROTSelectedData: null,

      eROTAttachments: [],

      showeROTReject: false,
      eROTRejectButtons: [
        { text: 'Reject', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],

      rejectToEmails: [],
      rejectCCEmails: [],
      rejectBCCEmails: [],

      showCC: false,
      showBCC: false,

      eROTRejectMessage: '',
      eROTRejectReason: '',

      eROTCNErrorPopup: false,
      eROTCNErrorButtons: [{ text: 'Confirm' }, { text: 'Cancel', color: 'lightgray', textColor: 'black' }],

      eROTcncontsizeList: [],
      eROTcnconttypeList: [],
      eROTcndeliverytypeList: [],
      eROTcnhandlingtypeList: [],
      eROTbillingfmtList: [],
      eROToperatorcodeList: [],
      eROTcnstatusList: [],
      eROTcommodityList: [],

      eROTContainersPopupTableData: [],
      eROTContainersPopupTableBoxTitle: '',
      eROTContainersPopupTableBoxHideColumns: ['id'],
      //#endregion

      designerV2IsShown: false,
      designerV2ReportFile: [], // initialised in mounted(), it's an array because DesignerV2 supports multiple templates in one report
      designerV2ReportFileDiversion: [], // initialised in mounted(), it's an array because DesignerV2 supports multiple templates in one report
      designerV2ReportData: {},
      designerV2ShowBackground: false,

      showPrintPermissionPopup: false,
      printPermissionPopupButtons: [{ text: 'OK' }],
      printPermissionPopupConsignmentReasons: [],

      haulageJobPageSignalHub: null, // signalR Hub, for listening to events

      //#region Confirm Save Popup
      confirmSavePopup: false,
      savePopupButtons: [{ text: 'Save' }, { text: 'Cancel', color: 'lightgray' }],
      confirmSavePopupResolve: null,

      saveRadioButton: [
        { label: 'Confirm Job', keyValue: '1' },
        { label: 'Unconfirm Job', keyValue: '2' },
      ],

      selectedSaveBy: {
        keyValue: '1',
        label: 'Confirm Job',
      },

      reasonOpen: false,

      reasonsList: [],
      selectedUnconfirmReason: null,
      selectedUnconfirmReasonError: '',
      unconfirmRemarks: '',
      unconfirmRemarksError: '',
      //#endregion

      regexDecimal: {
        regex: /\d*\.?\d*/g,
        live: true,
      },

      nonISOContType: null,
      isContainerCheck: false,

      showCreateDiversion: false,
      showPrintDiversion: false,
      showIndividualPrintDiversion: false,
      diversiontTitle: '',
      diversionLocation: [],
      diversionDetails: [],
      selectedDiversionLoc1: null,
      selectedDiversionLoc2: null,
      selectedDiversionLoc3: null,
      selectedDiversionLoc4: null,
      diversionLoc1: '',
      cnnoLoc1: '',
      diversionLoc2: '',
      cnnoLoc2: '',
      diversionLoc3: '',
      cnnoLoc3: '',
      diversionLoc4: '',
      cnnoLoc4: '',
      internalDiversionLoc1: false,
      internalDiversionLoc2: false,
      internalDiversionLoc3: false,
      internalDiversionLoc4: false,
      remarksDiversionLoc1: '',
      remarksDiversionLoc2: '',
      remarksDiversionLoc3: '',
      remarksDiversionLoc4: '',
      showDeleteDivPopup: false,
      isDiversionForCN: false,
      isDivert: false,
      deleteDivRemarks: '',
      deleteDivError: '',
      sequence: '',
      cndiversionList: [],
      deleteDiversionError: '',
      printDiversionTitle: '',
      printDiversionTitleOri: '',
      printDiversionTitleDivert: '',
      jobDetailForDiversion: [],
      useOriDest: false,
      diversionButtons: [
        { text: 'Update' },
        { text: 'Cancel', color: 'indianred' },
        // { text: 'Print CDA', color: 'lightgray' },
      ],
      printDiversionButtons: [
        // { text: 'Print' },
        { text: 'Print', color: 'lightgray' },
        { text: 'Cancel', color: 'indianred' },
      ],
    };
  },
  props: {},
  methods: {
    menuClicked: async function (e) {
      this.filterIsOpen = false;
      switch (e['title']) {
        case 'New Job':
        case 'New Job (eROT)': {
          this.menuNewClicked(e);
          break;
        }
        case 'Edit Job':
          if (this.selectedJob.length == 0) {
            await this.$showAlert('error', 'No Job Selected', 'Please select a job to edit');
          } else if (this.selectedJob.length > 1) {
            this.$showAlert('error', 'More than 1 record Selected', 'Please select a record to edit');
          } else {
            this.menuEditClicked();
          }
          break;
        case 'Delete Job': {
          if (this.selectedJob.length === 0) {
            await this.$showAlert('error', 'No Job Selected', 'Please select a job to delete');
            return;
          }

          if (this.selectedJob.length > 1) {
            await this.$showAlert('error', 'More than 1 record Selected', 'Please select a record to delete');
            return;
          }

          if (this.selectedJob[0]['Job State'] === 'Cancelled') {
            await this.$showAlert('error', 'Job is Cancelled', 'You cannot delete a job that is already cancelled.');
            return;
          }

          if (this.selectedJob[0]['Job Assigned'] > 0) {
            const jobAssignedAlert = await this.$showAlert(
              'warning',
              'Job already assigned',
              `${this.selectedJob[0]['Job Assigned']} trip has already been assigned.\nAre you sure you want to delete this?`,
              [{ text: 'Yes' }, { text: 'No', color: 'gray', textColor: 'white' }],
            );

            if (jobAssignedAlert === 'No') {
              return;
            }
          }

          const checkAccountJSON = {
            checktype: 'DELETE JOB',
            jobno: this.selectedJob[0]['Job No'],
            cnno: '',
            contno: '',
            chargescode: '',
            system: 'HMS',
            chkpayment: '0',
          };

          const CheckAccount = await this.$apiCallV2('/HaulageJob/CheckAccounts', checkAccountJSON);

          if (CheckAccount[0]['Results'] == 0) {
            if (CheckAccount[0]['ErrMsg'] == '') {
              this.showDeletePopup = true;
            } else {
              await this.$showAlert('error', 'Job Billed or Paid', CheckAccount[0]['ErrMsg']);
            }
          } else {
            await this.$showAlert('error', 'Check Accounts', CheckAccount[0]['ErrMsg']);
          }
          break;
        }
        case 'View Job':
          if (this.selectedJob.length == 0) {
            await this.$showAlert('error', 'No Job Selected', 'Please select a job to view');
          } else if (this.selectedJob.length > 1) {
            this.$showAlert('error', 'More than 1 record Selected', 'Please select a record to view');
          } else {
            this.menuViewClicked();
          }
          break;
        case 'Print CN': {
          if (this.selectedJob.length == 0) {
            this.$showAlert('error', 'No Job Selected', 'Please select a job to print');
            break;
          }
          const jobNo = this.selectedJob.map((job) => job['Job No']);
          await this.printCN(jobNo);
          break;
        }
        case 'eROT':
          this.showEROT = true;
          this.isVerification = false;
          this.selectedSender = this.senderList.getSelected('ALL', 'From'); // Set All as the default sender
          this.refreshROTClicked();
          break;
        case 'Scan Document':
          this.showEROT = true;
          this.isVerification = true;
          break;
        case 'View/Create Diversion':
          if (this.selectedJob.length == 0) {
            await this.$showAlert('error', 'No Job Selected', 'Please select a job to view/create Diversion');
          } else if (this.selectedJob.length > 1) {
            this.$showAlert('error', 'More than 1 record Selected', 'Please select a record to view/create Diversion');
          } else {
            this.diversionDetails = [];
            if (this.isDiversionForCN && this.popupShow) {
              this.diversiontTitle = `Diversion for ${this.selectedConsignments['0']['Consignment No']}`;
              this.diversionDetails = await this.$apiCallV2(
                `/HaulageJob/GetHMSDiversion?jobno=${this.selectedJob[0]['Job No']}&cnno=${this.selectedConsignments['0']['Consignment No']}`,
              );
            } else {
              this.diversiontTitle = `Diversion for ${this.selectedJob[0]['Job No']}`;
              this.diversionDetails = await this.$apiCallV2(
                `/HaulageJob/GetHMSDiversion?jobno=${this.selectedJob[0]['Job No']}&cnno=${this.selectedJob[0]['Consignment No'] ? this.selectedJob[0]['Consignment No'] : ''}`,
              );
            }
            if (this.diversionDetails['0']?.['Results'] == '1') {
              await this.$showAlert('error', 'Unable to View/Create Diversion', this.diversionDetails['0']?.['ErrMsg']);
              break;
            }
            if (this.diversionDetails.length == 4) {
              this.diversionButtons = [
                // { text: 'Update', disabled: true },
                { text: 'Cancel', color: 'indianred' },
              ];
            } else {
              this.diversionButtons = [{ text: 'Update' }, { text: 'Cancel', color: 'indianred' }];
            }
            if (this.diversionDetails.length != 0) {
              this.selectedDiversionLoc1 =
                this.diversionDetails.length > 0 ?
                  this.diversionLocation.find((i) => {
                    return i['Destination Code'] == this.diversionDetails[0]['Diversion Dest'];
                  })
                : null;
              this.selectedDiversionLoc2 =
                this.diversionDetails.length > 1 ?
                  this.diversionLocation.find((i) => {
                    return i['Destination Code'] == this.diversionDetails[1]['Diversion Dest'];
                  })
                : null;
              this.selectedDiversionLoc3 =
                this.diversionDetails.length > 2 ?
                  this.diversionLocation.find((i) => {
                    return i['Destination Code'] == this.diversionDetails[2]['Diversion Dest'];
                  })
                : null;
              this.selectedDiversionLoc4 =
                this.diversionDetails.length > 3 ?
                  this.diversionLocation.find((i) => {
                    return i['Destination Code'] == this.diversionDetails[3]['Diversion Dest'];
                  })
                : null;
              this.diversionLoc1 = this.diversionDetails.length > 0 ? this.diversionDetails[0]['DiverAddress'] : '';
              this.diversionLoc2 = this.diversionDetails.length > 1 ? this.diversionDetails[1]['DiverAddress'] : '';
              this.diversionLoc3 = this.diversionDetails.length > 2 ? this.diversionDetails[2]['DiverAddress'] : '';
              this.diversionLoc4 = this.diversionDetails.length > 3 ? this.diversionDetails[3]['DiverAddress'] : '';
              this.remarksDiversionLoc1 = this.diversionDetails.length > 0 ? this.diversionDetails[0]['Remarks'] : '';
              this.remarksDiversionLoc2 = this.diversionDetails.length > 1 ? this.diversionDetails[1]['Remarks'] : '';
              this.remarksDiversionLoc3 = this.diversionDetails.length > 2 ? this.diversionDetails[2]['Remarks'] : '';
              this.remarksDiversionLoc4 = this.diversionDetails.length > 3 ? this.diversionDetails[3]['Remarks'] : '';
              this.internalDiversionLoc1 =
                this.diversionDetails.length > 0 ? this.diversionDetails[0]['DeliveryMode'] == 1 : false;
              this.internalDiversionLoc2 =
                this.diversionDetails.length > 1 ? this.diversionDetails[1]['DeliveryMode'] == 1 : false;
              this.internalDiversionLoc3 =
                this.diversionDetails.length > 2 ? this.diversionDetails[2]['DeliveryMode'] == 1 : false;
              this.internalDiversionLoc4 =
                this.diversionDetails.length > 3 ? this.diversionDetails[3]['DeliveryMode'] == 1 : false;
              this.cnnoLoc1 = this.diversionDetails.length > 0 ? this.diversionDetails[0]['Consignment No'] : '';
              this.cnnoLoc2 = this.diversionDetails.length > 1 ? this.diversionDetails[1]['Consignment No'] : '';
              this.cnnoLoc3 = this.diversionDetails.length > 2 ? this.diversionDetails[2]['Consignment No'] : '';
              this.cnnoLoc4 = this.diversionDetails.length > 3 ? this.diversionDetails[3]['Consignment No'] : '';
            }
            this.showCreateDiversion = true;
          }
          break;
        case 'Print Diversion':
          this.isDivert = true;
          this.showPrintDiversion = false;
          this.showCreateDiversion = false;
          if (this.selectedJob.length == 0) {
            await this.$showAlert('error', 'No Job Selected', 'Please select a job to print');
            break;
          } else if (this.selectedJob.length > 1) {
            this.$showAlert('error', 'More than 1 record Selected', 'Please select a record to print');
          } else {
            if (this.jobDetailForDiversion == null || this.jobDetailForDiversion.length == 0)
              // await this.getJobDetailsForDiversion(this.selectedConsignmentNo.trim() != '');
              await this.getJobDetailsForDiversion(this.selectedJob != '');
            if (
              this.jobDetailForDiversion == null ||
              this.jobDetailForDiversion['ConsignmentNote']['0']['CNDiversion'] == undefined
            ) {
              this.$showAlert(
                'info',
                'Record Check',
                `No diversion for selected CDA ${this.selectedJob['0']['Job No']}`,
              );
              break;
            }

            if (
              this.isDiversionForCN &&
              this.popupShow &&
              this.jobDetailForDiversion['ConsignmentNote']['0']['CNDiversion']['ConsignmentNo'] !=
                this.selectedConsignmentNo
            ) {
              this.$showAlert('info', 'Record Check', `No diversion for selected CDA ${this.selectedConsignmentNo}`);
              break;
            }

            this.$fullscreenLoading('Validating Print Permission');
            const validatePrintBody = {
              // // the rest of the body is populated in the controller
              consignments: this.jobDetailForDiversion['ConsignmentNote'].map((consignmentNote) => {
                return {
                  cnno: consignmentNote['ConsignmentNo'],
                };
              }),
            };

            const validatePrintRes = await this.$apiCallV2('/HaulageJob/ValidatePrint', validatePrintBody);
            this.printPermissionPopupConsignmentReasons = validatePrintRes['consignments'].filter((consignment) => {
              return !consignment['allowprint'];
            });

            if (this.printPermissionPopupConsignmentReasons.length > 0) {
              // if there is at least one consignment that can't be printed
              this.showPrintPermissionPopup = true; // show PopupV2
              this.$fullscreenLoading();
              return; // exit function
            }

            this.$fullscreenLoading('Preparing to Print');
            await this.formatDiversionNotePrintDetails(this.jobDetailForDiversion); // will modify the jobDetails object via reference
            this.designerV2ReportData = this.jobDetailForDiversion;
            this.designerV2IsShown = true; // there is a watcher for this data field that sets the SignalR hub to start listening to an event
            this.$fullscreenLoading();
            this.diverpickupori = '0';
            this.diverinternal = '';
            this.diverseqno = '';
            this.cnno = '';
            this.useOriDest = false;
          }
          break;
        case 'Job Charges':
          if (this.selectedJob.length == 0) {
            this.$showAlert('error', 'No Job Selected', 'Please select a record to view Job Charges');
          } else if (this.selectedJob.length > 1) {
            this.$showAlert('error', 'More than 1 record Selected', 'Please select a record to view Job Charges');
          } else {
            // this.showJobChargesPopup = true;
            const route = this.$router.resolve(
              `/Home/${this.$route.params['user']}/FINAR/Job%20Charges?jobNo=${this.selectedJob[0]['Job No'].trim()}`,
            );
            window.open(route.href, '_blank');
          }
          break;
      }
    },

    async menuNewClicked(e) {
      this.popupShow = true;
      this.popupTitle = e['title'];

      this.jobNo = '***********';
      this.createdBy = '';
      this.updatedBy = '';

      //default value
      this.coeff = this.coeff || '1';
      this.selectedCheque = this.selectedCheque ?? this.chequeItems[0];
      this.selectedTrip =
        this.hms_Default_Trip !== '' ?
          this.tripItems.find((t) => t.Trip === this.hms_Default_Trip)
        : this.tripItems.find((t) => t.Trip === '1');
      this.selectedPremises = this.premisesItems[0];

      const hms_ChangeJTypeCoeff = await this.$apiCallV2('/Master/GetSettingsSystem?settingsItem=HMS_ChangeJTypeCoeff');

      if (hms_ChangeJTypeCoeff[0]?.['SettingsValue'] != '1') {
        //1 = true means user can change coeff value
        this.coeffDisable = true; //disable if not "1"
      }

      //disable field for new action
      this.keepChargesDisable = true;
    },
    menuEditClicked: async function () {
      //edit checking
      //reset the edit disabled boolean
      this.editJobDisabled = false;
      this.editJobBilledDisabled = false;
      this.editJobPaidDisabled = false;
      this.editCNDisabled = false;
      this.editCNBilledDisabled = false;
      this.editCNPaidDisabled = false;
      //edit make to true
      this.keepChargesDisable = false;

      const hms_ChangeJTypeCoeff = await this.$apiCallV2('/Master/GetSettingsSystem?settingsItem=HMS_ChangeJTypeCoeff');

      if (hms_ChangeJTypeCoeff[0]?.['SettingsValue'] != '1') {
        //1 = true means user can change coeff value
        this.coeffDisable = true; //disable if not "1"
      }

      if (this.selectedJob[0]['Job State'] == 'Cancelled') {
        this.$showAlert('error', 'Job is Cancelled', 'You cannot edit a job that is already cancelled.');
        return;
      } else if (this.selectedJob[0]['Job Assigned'] > 0) {
        const jobAssigned = await this.$showAlert(
          'warning',
          'Job already assigned',
          `${this.selectedJob[0]['Job Assigned']} trip has already been assigned.\nAre you sure you want to edit this?`,
          [{ text: 'Yes' }, { text: 'No', color: 'gray', textColor: 'white' }],
        );
        if (jobAssigned == 'No') {
          return;
        }
      } else if (this.selectedJob[0]['Printed'] > 0) {
        const jobPrinted = await this.$showAlert(
          'warning',
          'Job invoice statement already printed',
          'You will have to reprint the invoice(s) if you edit this job.\nDo you still want to edit this?',
          [{ text: 'Yes' }, { text: 'No', color: 'gray', textColor: 'white' }],
        );
        if (jobPrinted == 'No') {
          return;
        }
      }
      const checkAccountJSON = {
        checktype: 'EDIT JOB',
        jobno: this.selectedJob[0]['Job No'],
        cnno: '',
        contno: '',
        chargescode: '',
        system: 'HMS',
        chkpayment: '0',
      };
      const CheckAccount = await this.$apiCallV2('/HaulageJob/CheckAccounts', checkAccountJSON);
      if (CheckAccount[0]['Results'] == 0) {
        if (CheckAccount[0]['ErrMsg'] != '') {
          this.editCheckingMessage = CheckAccount[0]['ErrMsg'];
          this.editStatus = CheckAccount[0]['editstatus'];
          this.editRemarks = '';
          this.editRemarksError = '';
          this.showEditPopup = true;
        } else {
          await this.getJobDetails('Edit Job', this.selectedJob[0]['Job No']);
        }
      } else {
        this.$showAlert('error', 'Check Accounts', CheckAccount[0]['ErrMsg']);
      }
    },

    async menuViewClicked() {
      await this.getJobDetails('View Job', this.selectedJob[0]['Job No']);
      this.tabsItems[5]['disabled'] = false;
      this.viewMode = true;
    },

    printCN: async function (jobNo, cnNos) {
      const jobNos = Array.isArray(jobNo) ? jobNo : [jobNo];

      this.$fullscreenLoading('Getting Job Details');
      const allFormattedJobDetails = [];
      const unprintableJobReasons = [];

      for (const singleJobNo of jobNos) {
        this.$fullscreenLoading(`Getting Job Details for Job: ${singleJobNo}`);
        const jobDetails = (await this.$apiCallV2(`/HaulageJob/JobDetails?jobno=${singleJobNo}`))['JobDetails']['Job'];

        if (Array.isArray(cnNos) && cnNos.length > 0) {
          jobDetails.ConsignmentNote = jobDetails.ConsignmentNote.filter((c) => cnNos.includes(c.ConsignmentNo));
        }

        this.$fullscreenLoading('Validating Print Permission');
        const validatePrintRequestBody = {
          // // the rest of the body is populated in the controller
          consignments: jobDetails['ConsignmentNote'].map((consignmentNote) => ({
            cnno: consignmentNote['ConsignmentNo'],
          })),
        };
        const validatePrintResponse = await this.$apiCallV2('/HaulageJob/ValidatePrint', validatePrintRequestBody);
        this.$fullscreenLoading();

        const unprintableConsignments = validatePrintResponse['consignments'].filter(
          (consignment) => !consignment['allowprint'],
        );

        if (unprintableConsignments.length > 0) {
          unprintableJobReasons.push(...unprintableConsignments);

          if (unprintableConsignments.length === validatePrintResponse['consignments'].length) {
            continue;
          } else {
            const unprintableConsignmentNos = unprintableConsignments.map((c) => c.cnno);
            jobDetails.ConsignmentNote = jobDetails.ConsignmentNote.filter(
              (consignment) => !unprintableConsignmentNos.includes(consignment.ConsignmentNo),
            );
          }
        }

        this.$fullscreenLoading('Preparing to Print');
        await this.formatConsignmentNotePrintDetails(jobDetails); // will modify the jobDetails object via reference
        allFormattedJobDetails.push(jobDetails);
      }
      if (allFormattedJobDetails.length > 0) {
        this.designerV2ReportFile = new Array(allFormattedJobDetails.length).fill(this.designerV2ReportFile[0]);
        this.designerV2ReportData = allFormattedJobDetails;
        this.designerV2IsShown = true; // there is a watcher for this data field that sets the SignalR hub to start listening to an event
        this.$fullscreenLoading();
      }

      if (unprintableJobReasons.length > 0) {
        this.printPermissionPopupConsignmentReasons = unprintableJobReasons;
        this.showPrintPermissionPopup = true;
      }
    },
    printPermissionPopupButtonClicked: function (_buttonText) {
      this.showPrintPermissionPopup = false;
    },
    formatConsignmentNotePrintDetails: async function (jobDetails) {
      // temporarily use EHL's format for FMH, for demonstration purposes
      const destinationDetailsCache = {};
      jobDetails['_vessel'] =
        jobDetails['Vessel No'] ?
          `${jobDetails['Vessel No'].trim()}  ${jobDetails['Vessel Name']?.trim?.()}`
        : jobDetails['Vessel Name']?.trim?.();

      for (const consignment of jobDetails['ConsignmentNote']) {
        // iterate through ConsignmentNote array inside jobDetails
        consignment['_Discharge Port'] = consignment['Discharge Port'];
        // if Discharge Port of ConsignmentNote is not null, then use that, else use Port of Discharge from jobDetails

        consignment['_Consignment No'] = `${consignment['ConsignmentNo']} /${jobDetails['ContDetail'].length}`;
        const qrDetail = `{"CNNO":"${consignment['ConsignmentNo']}"} `;
        consignment['QR'] = await this.$getQRURL(qrDetail, { size: 150, margin: 10 });
        // append total consignments to each consignmentNo

        if (!destinationDetailsCache[consignment['SendTo']]) {
          // if the destination details does not exist in the cache
          destinationDetailsCache[consignment['SendTo']] = (
            await this.$apiCallV2(
              // call API to get details and store into cache
              '/Master/GetListMaster',
              {
                masterfile: 'SENDTO_DETAILS',
                // destinationcode: jobDetails["ConsignmentNote"][0]["SendTo"],
                destinationcode: consignment['SendTo'],
              },
            )
          )[0];
        }

        const destinationDetails = destinationDetailsCache[consignment['SendTo']];
        consignment['_destination Company'] = destinationDetails['Company']; // append required destination data
        consignment['_destination Addr1'] = destinationDetails['Addr1'];
        consignment['_destination Addr2'] = destinationDetails['Addr2'];
        consignment['_destination Addr3'] = destinationDetails['Addr3'];
        consignment['_destination Addr4'] = destinationDetails['Addr4'];
        consignment['_destination PostCode'] = destinationDetails['PostCode'];
        consignment['_destination City'] = destinationDetails['City'];
        consignment['_destination State'] = destinationDetails['State'];
        consignment['_destination Attn'] = destinationDetails['Attn'];
        consignment['_destination Phone'] =
          destinationDetails['Phone'] ?
            `${destinationDetails['Phone'].trim()}     ${destinationDetails['Phone2']?.trim?.()}`
          : destinationDetails['Phone2']?.trim?.();

        consignment['_requiredTime'] =
          consignment['RequiredTime'] ?
            new Date(consignment['RequiredTime']).formatString(`${this.$store.state['preferredDateFormat']} HHmm`)
          : '';

        const parsedPrintCount = parseInt(consignment['PrintCount']);
        consignment['_printCount'] =
          isNaN(parsedPrintCount) || parsedPrintCount === 0 ? '' : `REPRINT *${parsedPrintCount}*`;
        // artifically increase print count by 1, and then display on the CN to be printed
        // when the user clicks print, call API to actually increase count by 1 on the database
      }

      if (jobDetails['Job Type'] === 'I') {
        // if an import job was selected
        jobDetails['_Shpr/Csgn Value'] = jobDetails['Consignee Name'];
        jobDetails['_BL No/Shpg Agt Ref Label'] = 'B/L No';
        jobDetails['_BL No/Shpg Agt Ref Value'] = jobDetails['BL No'];
        jobDetails['_ETA Value'] =
          jobDetails['POD ETA'] ?
            new Date(jobDetails['POD ETA']).formatString(`${this.$store.state['preferredDateFormat']} HHmm`)
          : '';
      } else {
        // if an export job was selected
        jobDetails['_Shpr/Csgn Value'] = jobDetails['Shipper Name'];
        jobDetails['_BL No/Shpg Agt Ref Label'] = 'Shpg Agt Ref';
        jobDetails['_BL No/Shpg Agt Ref Value'] = jobDetails['Booking Ref No'];
        jobDetails['_ETA Value'] =
          jobDetails['POL ETA'] ?
            new Date(jobDetails['POL ETA']).formatString(`${this.$store.state['preferredDateFormat']} HHmm`)
          : '';
      }

      jobDetails['_vessel Details'] =
        `${jobDetails['Vessel No'] ? jobDetails['Vessel No'] : ''} ${jobDetails['Vessel Name']}`;
      jobDetails['_printTime'] = new Date().formatString(`${this.$store.state['preferredDateFormat']} HH:mm`);
      jobDetails['UserID'] = this.loginDetails['LoginUserId'];
    },
    formatDiversionNotePrintDetails: function (jobDetails) {
      // temporarily use EHL's format for FMH, for demonstration purposes
      jobDetails['_vessel'] =
        jobDetails['Vessel No'] ?
          `${jobDetails['Vessel No'].trim()}  ${jobDetails['Vessel Name']?.trim?.()}`
        : jobDetails['Vessel Name']?.trim?.();

      for (const consignment of jobDetails['ConsignmentNote']) {
        // iterate through ConsignmentNote array inside jobDetails
        consignment['_Discharge Port'] = consignment['Discharge Port'];
        // if Discharge Port of ConsignmentNote is not null, then use that, else use Port of Discharge from jobDetails

        consignment['_Consignment No'] = `${consignment['ConsignmentNo']} /${jobDetails['ConsignmentNote'].length}`;
        consignment['_divert Pickup'] = this.cndiversionList['DiverPickup'];
        consignment['_divert Info'] = this.cndiversionList['DiversionInfo'];
        consignment['_destination Company'] = this.cndiversionList['DestCompany']; // append required destination data
        consignment['_destination Addr1'] = this.cndiversionList['DestAddr1'];
        consignment['_destination Addr2'] = this.cndiversionList['DestAddr2'];
        consignment['_destination Addr3'] = this.cndiversionList['DestAddr3'];
        consignment['_destination Addr4'] = this.cndiversionList['DestAddr4'];
        consignment['_destination PostCode'] = this.cndiversionList['DestPostCod'];
        consignment['_destination City'] = this.cndiversionList['DestCity'];
        consignment['_destination State'] = this.cndiversionList['DestState'];
        consignment['_destination Attn'] = this.cndiversionList['DestAttn'];
        consignment['_destination Phone'] =
          this.cndiversionList['DestPhone'] ?
            `${this.cndiversionList['DestPhone'].trim()}     ${this.cndiversionList['DestPhone2']?.trim?.()}`
          : this.cndiversionList['DestPhone2']?.trim?.();

        consignment['_requiredTime'] =
          consignment['RequiredTime'] ?
            new Date(consignment['RequiredTime']).formatString(`${this.$store.state['preferredDateFormat']} HHmm`)
          : '';

        const parsedPrintCount = parseInt(consignment['PrintCount']);
        consignment['_printCount'] =
          isNaN(parsedPrintCount) || parsedPrintCount === 0 ? '' : `REPRINT *${parsedPrintCount}*`;
        // artifically increase print count by 1, and then display on the CN to be printed
        // when the user clicks print, call API to actually increase count by 1 on the database
      }

      if (jobDetails['Job Type'] === 'I') {
        // if an import job was selected
        jobDetails['_Shpr/Csgn Value'] = jobDetails['Consignee Name'];
        jobDetails['_BL No/Shpg Agt Ref Label'] = 'B/L No';
        jobDetails['_BL No/Shpg Agt Ref Value'] = jobDetails['BL No'];
        jobDetails['_ETA Value'] =
          jobDetails['POD ETA'] ?
            new Date(jobDetails['POD ETA']).formatString(`${this.$store.state['preferredDateFormat']} HHmm`)
          : '';
      } else {
        // if an export job was selected
        jobDetails['_Shpr/Csgn Value'] = jobDetails['Shipper Name'];
        jobDetails['_BL No/Shpg Agt Ref Label'] = 'Shpg Agt Ref';
        jobDetails['_BL No/Shpg Agt Ref Value'] = jobDetails['Booking Ref No'];
        jobDetails['_ETA Value'] =
          jobDetails['POL ETA'] ?
            new Date(jobDetails['POL ETA']).formatString(`${this.$store.state['preferredDateFormat']} HHmm`)
          : '';
      }
      jobDetails['_vessel Details'] =
        `${jobDetails['Vessel No'] ? jobDetails['Vessel No'] : ''} ${jobDetails['Vessel Name']}`;
      jobDetails['_printTime'] = new Date().formatString(`${this.$store.state['preferredDateFormat']} HH:mm`);
      jobDetails['UserID'] = this.loginDetails['LoginUserId'];
    },
    designerV2AfterPrint: async function () {
      // won't know if it successfully printed or the user cancelled it
      this.designerV2IsShown = false; // hide DesignerV2, watcher will stop the hub from listening to the ConsignmentNotePrinted event
      for (const reportData of this.designerV2ReportData) {
        //loop through all the report data
        const updatePrintCountRequestBody = {
          // the rest of the body is populated in the controller
          consignments: reportData['ConsignmentNote'].map((consignmentNote) => {
            return {
              jobno: consignmentNote['JobNo'],
              cnno: consignmentNote['ConsignmentNo'],
              cnremark: '', // leave as blank for now
              lastprintcount: parseInt(consignmentNote['PrintCount']) || 0,
            };
          }),
        };
        const updatePrintCountResponse = await this.$apiCallV2(
          '/HaulageJob/UpdatePrintCount',
          updatePrintCountRequestBody,
        );
        // call API to increase print count for all printed consignments

        if (updatePrintCountResponse !== '') {
          // something went wrong when trying to update print count
          let updatePrintCountErrorMessage = 'An error occured when trying to update print count';
          if (
            Array.isArray(updatePrintCountResponse) && // if API returned a error message
            updatePrintCountResponse[0] &&
            updatePrintCountResponse[0]['ErrMsg']
          ) {
            updatePrintCountErrorMessage = updatePrintCountResponse[0]['ErrMsg']; // use that instead
          }

          this.$showAlert('error', 'Failed to update print count', updatePrintCountErrorMessage, [{ text: 'OK' }]);
        }

        await this.$apiCallV2(
          // call endpoint defined in HaulageJobPageHubController.cs
          `/HaulageJobPageHub/ConsignmentNotePrinted` + // this will emit a SignalR event named "ConsignmentNotePrinted"
            `?coRefname=${this.loginDetails['CoRefname']}` + // which will be listened to by other users that also have the print CN preview open
            `&coCode=${this.loginDetails['CoCode']}` + // if the event was sent by another user in the same company,
            `&jobNo=${this.designerV2ReportData['Job No']}`, // that user will then be forced to get the latest print count and reload the print CN preview
        );
      }
    },
    consignmentNotePrintedEventHandler: async function (coRefname, coCode, jobNo) {
      if (
        coRefname !== this.loginDetails['CoRefname'] || // if event is not sent from a user of the same company
        coCode !== this.loginDetails['CoCode'] ||
        jobNo !== this.designerV2ReportData['Job No'] // or if the user was not previewing the same consignments
      ) {
        return; // don't do anything
      }

      this.designerV2IsShown = false; // hide DesignerV2, watcher will stop the hub from listening to the ConsignmentNotePrinted event

      this.$fullscreenLoading('Getting Job Details');
      const jobDetails = (await this.$apiCallV2(`/HaulageJob/JobDetails?jobno=${this.selectedJob[0]['Job No']}`))[
        'JobDetails'
      ]['Job'];

      this.$fullscreenLoading('Preparing to Print');
      await this.formatConsignmentNotePrintDetails(jobDetails); // will modify the jobDetails object via reference
      this.designerV2ReportData = jobDetails;
      this.designerV2IsShown = true; // show DesignerV2, watcher will set the hub to start listening to the ConsignmentNotePrinted event
      this.$fullscreenLoading();
    },
    refreshClicked: async function (_e) {
      let error = false;
      if (this.filterDate) {
        if (!this.fromDate) {
          this.fromDateErrorMessage = 'Enter from date!';
          error = true;
        }

        if (!this.toDate) {
          this.toDateErrorMessage = 'Enter to date!';
          error = true;
        }
      }

      if (this.filterSearch) {
        if (!this.selectedFilterSearchBy) {
          this.searchByErrorMessage = 'Select a search field!';
          error = true;
        }

        if (!this.selectedFilterSearchCriteria) {
          this.searchCriteriaErrorMessage = 'Search a search criteria!';
          error = true;
        }

        if (!this.searchInputValue.trim()) {
          this.searchInputErrorMessage = 'Enter a search keyword!';
          error = true;
        }
      }

      if (error) {
        return;
      }

      this.filterIsDisabled = true;
      this.filterIsOpen = false;

      const dataToPost = { module: 'HMS' };
      if (this.filterDate) {
        dataToPost['stjobdate'] = this.fromDate?.formatString('yyyy-MM-dd') ?? '';
        dataToPost['edjobdate'] = this.toDate?.formatString('yyyy-MM-dd') ?? '';
      }

      if (this.filterSearch) {
        dataToPost['jobtype'] = this.selectedFilterJobType?.['Job Type'] ?? '';
        dataToPost['searchfield'] = this.selectedFilterSearchBy['Search Criteria'];
        dataToPost['searchcriteria'] = this.selectedFilterSearchCriteria['name'];
        dataToPost['searchvalue'] = this.searchInputValue.trim();
      }

      this.filterText = 'Filter by ';
      if (this.filterSearch) {
        if (this.selectedFilterJobType?.['Job Type']) {
          this.filterText += `${this.selectedFilterJobType['Job Type']} jobs, `;
        }

        this.filterText += `${this.selectedFilterSearchBy['Search Criteria']} ${this.selectedFilterSearchCriteria['name']} ${this.searchInputValue.trim()}`;
      } else {
        this.filterText += 'date';
      }
      if (this.filterDate) {
        this.filterText += `, from ${this.fromDate.formatString('yyyy-MM-dd')} to ${this.toDate.formatString('yyyy-MM-dd')}`;
      }

      // if(this.filterDate && this.filterSearch){
      //   this.filterText = `Filter by ${this.selectedFilterJobType['Job Type']} from ${this.fromDate ? this.fromDate.formatString('yyyy-MM-dd') : ""} to ${this.toDate ? this.toDate.formatString('yyyy-MM-dd') : ""}`
      // } else if(this.filterDate && !this.filterSearch){
      //   this.filterText = `Filter by date from ${this.fromDate ? this.fromDate.formatString('yyyy-MM-dd') : ""} to ${this.toDate ? this.toDate.formatString('yyyy-MM-dd') : ""}`
      // } else if (!this.filterDate && this.filterSearch){
      //   this.filterText = `Filter by ${this.selectedFilterJobType['Job Type']}`
      // }

      this.jobData = [];
      // this.selectedJob = [];
      this.jobTableBoxIsLoading = true;
      this.tableBoxColumnOrderViews = [];
      this.tableBoxColumnOrderID = null;
      let result = null;
      const getListJobTrackingPromise = await this.$apiCallV2('/HaulageJob/GetListJobTracking', dataToPost).then(
        (res) => {
          result = res;
          this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');
          this.jobTableBoxIsLoading = false;
          this.filterIsDisabled = false;
        },
      ); // start the API call

      const columnOrderID = {
        formname: 'Haulage_Job',
        formctrlname: 'Haulage Job',
      };

      if (!this.columnOrderViewsByReportName['Haulage Job']) {
        this.columnOrderViewsByReportName['Haulage Job'] = await this.$apiCallV2(
          '/TableBox/GetColumnOrder',
          columnOrderID,
        );
      }
      this.tableBoxColumnOrderViews = this.columnOrderViewsByReportName['Haulage Job'];
      this.tableBoxColumnOrderID = columnOrderID;
      this.jobData = result;

      return getListJobTrackingPromise; // return the promise for the API call instead of awaiting
    },

    //#region For View and edit
    getJobDetails: async function (title, jobno) {
      this.jobTypeItems = this.allJobTypes;
      this.$fullscreenLoading('Getting Job Details');
      const viewJobData = this.$jsonNullToString(
        this.$deepTrimJsonV3((await this.$apiCallV2(`/HaulageJob/JobDetails?jobno=${jobno}`))['JobDetails']['Job']),
      );
      const filteredJobTypeList = this.jobTypeItems.filter(
        (j) =>
          j['Job Type Header'].trim() == viewJobData['Job Type'].trim() ||
          j['Job Type'].trim().toUpperCase() == 'IMP-EXP',
      );
      this.$nextTick(() => {
        this.jobTypeItems = filteredJobTypeList;
      });

      //Createdby and Updatedby
      this.createdBy = `${viewJobData['Created By'] ? viewJobData['Created By'].trim() : ''} ${viewJobData['Created Date'] ? new Date(viewJobData['Created Date']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      this.updatedBy = `${viewJobData['Updated By'] ? viewJobData['Updated By'].trim() : ''} ${viewJobData['Last Update'] ? new Date(viewJobData['Last Update']).formatString('dd/MM/yyyy HH:mm') : ''}`;

      const cnList = viewJobData['ConsignmentNote'];
      this.$fullscreenLoading();

      this.popupShow = true;
      this.popupTitle = `${title} (${viewJobData['Job No']})`;

      let shipperKey = 'Consignee';
      if (viewJobData['Job Type'] == 'E') {
        shipperKey = 'Shipper';
      }

      //#region Job Info Data
      this.jobNo = viewJobData['Job No']; // = '';
      this.urgent = viewJobData['Urgent'] ? viewJobData['Urgent'].trim() == 1 : false; // = false;
      this.jobDateTime = viewJobData['Job Time'] ? new Date(viewJobData['Job Time']) : null; // = null;
      // this.selectedShipper = this.shipperItems.getSelected(viewJobData[shipperKey].trim(), 'Customer Code');
      this.selectedShipper =
        viewJobData[shipperKey] ?
          this.shipperItems.find((s) => s['Customer Code'].trim() == viewJobData[shipperKey].trim())
        : null; // = null;
      this.custRefNo = viewJobData['Cust Ref No'] ? viewJobData['Cust Ref No'] : ''; // = '';
      this.projectNo = viewJobData['Project No'] ? viewJobData['Project No'] : ''; // = '';
      this.requestNo = viewJobData['Request No'] ? viewJobData['Request No'] : ''; // = '';
      this.prevrefjobno = viewJobData['Prev Job No'] ?? '';
      this.selectedJobType =
        viewJobData['CN Job Type'] ?
          this.jobTypeItems.find((j) => j['Job Type'].trim() == viewJobData['CN Job Type'].trim())
        : null; // = null;
      this.selectedCheque =
        viewJobData['Payment Type'] ?
          this.chequeItems.find((c) => c['Payment Type'].trim() == viewJobData['Payment Type'].trim())
        : null; // = null;

      this.selectedTrip =
        viewJobData['Trip'] ? this.tripItems.find((s) => s['Trip'].trim() == viewJobData['Trip'].trim()) : null; // = null;
      this.coeff = viewJobData['Coeff']; // = '';
      this.keepCharges = viewJobData['Lock Charges'] == '1'; // = false;

      this.$nextTick(() => {
        this.selectedBillTo =
          viewJobData['Bill To'] ?
            this.billToItems.find((b) => b['Customer Code'].trim() == viewJobData['Bill To'].trim())
          : null;
        this.billToSelected(this.selectedBillTo);
      });
      //#endregion

      //#region Send To / Container Data
      this.selectedSendTo =
        cnList[0]['SendTo'] ?
          this.sendToItems.find((s) => s['Destination Code'].trim() == cnList[0]['SendTo'].trim())
        : null; // = null;
      this.isDiversion = cnList[0]['Diversion'].trim() == '1'; // = false;

      // this.selectedPremises = cnList[0]['PremisesIs'] ? this.premisesItems[parseInt(cnList[0]['PremisesIs']) - 1] : null; // = null; //why -1?
      // this.selectedPremises = cnList[0]['PremisesIs'] ? this.premisesItems[parseInt(cnList[0]['PremisesIs'])] : null; // = null;
      this.selectedPremises =
        cnList[0]['PremisesIs'] ? this.premisesItems.find((s) => s['#'] == cnList[0]['PremisesIs']) : null;
      this.selectedPickUp =
        cnList[0]['PickUp'] ?
          this.pickUpItems.find((s) => s['Destination Code'].trim() == cnList[0]['PickUp'].trim())
        : null; // = null;

      this.selectedDropOff =
        cnList[0]['DropOff'] ?
          this.dropOffItems.find((s) => s['Destination Code'].trim() == cnList[0]['DropOff'].trim())
        : null; // = null;

      this.consignmentList = [];
      this.selectedConsignments = [];

      const consignmentNote = cnList.map((c) => {
        return {
          'CN State': c['CN State'],
          'Is Diversion':
            c['CNDiversion'] != undefined ?
              '<div style="background-color: blue; padding: 5px; border-radius:5px; color: white">Yes</div>'
            : '<div style="background-color: red; padding: 5px; border-radius:5px; color: black">No</div>', //this.isDiversionCN ? '1' : '0',
          'Third Party': c['Third Party'],
          Printed: c['Printed'],
          Billed: c['Billed Count'],
          Assigned: c['Assigned Count'],
          'Consignment No': c['ConsignmentNo'], //this.cdaNo,
          seqno: c[''], //'',
          Diversion: c['Diversion'] ? c['Diversion'].trim() : '0', //this.isDiversionCN ? '1' : '0',
          'Premises Is': c['PremisesIs'] ? c['PremisesIs'].trim() : '', //this.getValueFromObject(this.selectedPremisesCN, '#') ? this.getValueFromObject(this.selectedPremisesCN, '#') : '1',
          'Cont Size': this.getValueFromObject(c, 'ContSize'), //this.getValueFromObject(this.selectedSize, 'Size'),
          'Cont Type': this.getValueFromObject(c, 'ContType'), //this.getValueFromObject(this.selectedType, 'Cont Type'),
          'Delivery Type': this.getValueFromObject(c, 'DeliveryType'), //this.getValueFromObject(this.selectedDelivery, 'Delivery Type'),
          'Handling Type': this.getValueFromObject(c, 'HandlingType'), //this.getValueFromObject(this.selectedHandling, 'Handling Type'),
          B2B: parseInt(this.getValueFromObject(c, 'B2BCont')), //this.isb2b ? '1' : '0',
          Timbang: parseInt(this.getValueFromObject(c, 'PackageCode')), //this.isTimbang ? '1' : '0',
          'Billing Format': this.getValueFromObject(c, 'BillingFormat'), //this.getValueFromObject(this.selectedBillingFormat, 'Billing Fmt'),
          'Cont No': this.getValueFromObject(c, 'ContainerNo'), //this.isContNo ? this.contNo : this.contList[i],
          'Cont Operator': this.getValueFromObject(c, 'ContOperator'), //this.contOp,
          'Seal No': this.getValueFromObject(c, 'SealNo'), //this.sealNo,
          'Ref No': this.getValueFromObject(c, 'RefNo'), //this.refNo,
          'Cont Height': this.getValueFromObject(c, 'ContHeight'), //this.height,
          'Cont Weight': this.getValueFromObject(c, 'ContWeight'), //this.weight,
          'Cont Measure': this.getValueFromObject(c, 'ContMeasure'), //this.measure,
          'Cont Status':
            c['Status'] ?
              c['Status'] == 'E' ?
                'Empty'
              : 'Laden'
            : '', //this.statusButtons.filter(s => s['checked'])[0]['title'],
          Commodity: this.getValueFromObject(c, 'Commodity'), //this.commodity,
          'Required Date': c['RequiredTime'] ? new Date(c['RequiredTime']).formatString('yyyy-MM-dd') : '', //this.requiredTime ? this.$dateTime.getDateTime(this.requiredTime, 'yyyy-MM-dd') : '',
          'Required Time': c['RequiredTime'] ? new Date(c['RequiredTime']).formatString('HHmm') : '', //this.requiredTime ? this.$dateTime.getDateTime(this.requiredTime, 'HHmm') : '',
          'Required Desc': c['ReqTimeDesc'] ? c['ReqTimeDesc'] : '',
          Remarks: this.getValueFromObject(c, 'Remarks'), //this.containerRemarks,
          Fumigation: parseInt(this.getValueFromObject(c, 'Fumigation')), //this.isFumigation ? '1' : '0',
          'Office Hours Delivery': parseInt(this.getValueFromObject(c, 'OfficeHours')), //this.isOfficeHrsD ? '1' : '0',
          'Office Hours Collection': parseInt(this.getValueFromObject(c, 'CNLastMvt')), //this.isOfficeHrsC ? '1' : '0',
          Temperature: this.getValueFromObject(c, 'Temperature'), //this.temperature,
          Team: this.getValueFromObject(c, 'Team'), //this.getValueFromObject(this.selectedTeam, 'Team'),
          cnaction: '', //'N',
          'Haulage Rate': Number(this.getValueFromObject(c, 'HaulageRate')).toFixed(2), //this.haulageTariff,
          'Toll Rate': Number(this.getValueFromObject(c, 'TollRate')).toFixed(2), //this.tollTariff,
          'Send To': this.getValueFromObject(c, 'SendTo'), //this.getValueFromObject(this.selectedSendToCN, 'Destination Code'),
          Area: this.getValueFromObject(c, 'Area'), //this.getValueFromObject(this.selectedSendToCN, 'Tariff Area'),
          'Pick Up': this.getValueFromObject(c, 'PickUp'), //this.getValueFromObject(this.selectedPickUpCN, 'Destination Code'),
          'Drop Off': this.getValueFromObject(c, 'DropOff'), //this.getValueFromObject(this.selectedDropOffCN, 'Destination Code'),
          samesendto:
            c['SendTo'] && this.selectedSendTo['Destination Code'] ?
              c['SendTo'] == this.selectedSendTo['Destination Code']
            : false,
          samepickup:
            c['PickUp'] && this.selectedPickUp['Destination Code'] ?
              c['PickUp'] == this.selectedPickUp['Destination Code']
            : false,
          samedropoff:
            c['DropOff'] && this.selectedDropOff['Destination Code'] ?
              c['DropOff'] == this.selectedDropOff['Destination Code']
            : false,
          //cnList[0]['PickUp'] ? this.pickUpItems.find(s => s['Destination Code'].trim() == cnList[0]['PickUp'].trim()) : null;
          // 'samesendto': this.getValueFromObject(c, 'tochange'), //this.sameSendTo,
          // 'samepickup': this.getValueFromObject(c, 'tochange'), //this.samePickUp,
          // 'samedropoff': this.getValueFromObject(c, 'tochange'), //this.sameDropOff,
          'Discharge Date': c['Discharge Date'],
          'Demurrgae Date': c['Demurrage Date'],
          'Detention Date': c['Detention Date'],
        };
      });
      this.$nextTick(() => (this.consignmentList = consignmentNote));
      //#endregion

      //#region Voyage Info Data
      this.selectedShipCallNo =
        viewJobData['Ship Call No'] ?
          this.shipCallNoItems.find((s) => s['Ship Call No'].trim() == viewJobData['Ship Call No'].trim())
        : null; // = null;
      if (!this.selectedShipCallNo) {
        this.shipCallNoFreeText = viewJobData['Ship Call No'];
      }
      this.voyNo = viewJobData['Voy No']; // = '';
      this.selectedVesselCode =
        viewJobData['Vessel No'] ?
          this.vesselCodeItems.find((s) => s['Vessel ID'].trim() == viewJobData['Vessel No'].trim())
        : null; // = null;
      this.selectedTranshipPort =
        viewJobData['Transhipment Port'] ?
          this.transhipPortItems.find((s) => s['Port Code'].trim() == viewJobData['Transhipment Port'].trim())
        : null; // = null;
      this.selectedDischargePort =
        viewJobData['LoadDischargePort'] ?
          this.dischargeItems.find((s) => s['Port Code'].trim() == viewJobData['LoadDischargePort'].trim())
        : null; // = null;
      if (!this.selectedDischargePort) {
        this.dischargePortFreeText = viewJobData['LoadDischargePort'];
      }
      this.etaDateTime =
        viewJobData['Job Type'] == 'I' ?
          viewJobData['POD ETA'] ?
            new Date(viewJobData['POD ETA'])
          : null
        : viewJobData['POL ETA'] ? new Date(viewJobData['POL ETA'])
        : null; // = null;
      this.etdDateTime =
        viewJobData['Job Type'] == 'E' ?
          viewJobData['POL ETD'] ?
            new Date(viewJobData['POL ETD'])
          : null
        : viewJobData['POD ETD'] ? new Date(viewJobData['POD ETD'])
        : null; // = null;
      this.closeDateTime = viewJobData['Closing Time'] ? new Date(viewJobData['Closing Time']) : null; // = null;
      this.demurageDate = viewJobData['Demurrage Date'] ? new Date(viewJobData['Demurrage Date']) : null; // = null;
      this.detentionDate = viewJobData['Detention Date'] ? new Date(viewJobData['Detention Date']) : null; // = null;
      this.shippingLine = viewJobData['Ship Line']; // = '';
      this.selectedShippingAgent =
        viewJobData['Shipping Agt'] ?
          this.shippingAgentItems.find((s) => s['Agent Code'].trim() == viewJobData['Shipping Agt'].trim())
        : null; // = null;
      // this.selectedFwdgAgent = viewJobData['Frt Forwarder'] ? this.fwdgAgentItems.find(s => s['Agent Code'].trim() == viewJobData['Frt Forwarder'].trim()) : null; // = null;
      this.selectedFwdgAgent =
        viewJobData['Forwarding Agent'] ?
          this.fwdgAgentItems.find((s) => s['FA Code'].trim() == viewJobData['Forwarding Agent'].trim())
        : null; // = null;
      // this.bookingRefNo = viewJobData[bookingRefKey]; // = '';
      this.bookingRefNo = viewJobData['Job Type'] == 'I' ? viewJobData['BL No'] : viewJobData['Booking Ref No']; // = '';
      this.requestedBy = viewJobData['Requested By']; // = '';
      this.finalDestination = viewJobData['Final Dest']; // = '';
      this.premisOffload = viewJobData['OffLoad'] == '1'; // = false;

      this.freeStorage = viewJobData['Free Storage Days'] ?? '';
      this.freeDemurrage = viewJobData['Free Demurrage Days'] ?? '';
      this.freeDetention = viewJobData['Free Detention Days'] ?? '';
      this.storageUnit = viewJobData['Storage Unit'] ?? 'D';
      this.demurrageUnit = viewJobData['Demurrage Unit'] ?? 'D';
      this.detentionUnit = viewJobData['Detention Unit'] ?? 'D';
      //#endregion

      //#region Documents
      this.showDocumentsLoader = true;
      this.$apiCallV2(`/HaulageJob/GetJobDocuments?jobno=${jobno}`).then((results) => {
        const jobDocs = this.$jsonNullToStringV2(this.$deepTrimJsonV3(results));

        // Documents tab
        jobDocs.forEach((d) => {
          const due = d['Due DateTime'] ? new Date(d['Due DateTime']).formatString('yyyy-MM-dd HH:mm') : '';
          const received =
            d['Received DateTime'] ? new Date(d['Received DateTime']).formatString('yyyy-MM-dd HH:mm') : '';
          const start = d['Start DateTime'] ? new Date(d['Start DateTime']).formatString('yyyy-MM-dd HH:mm') : '';

          this.documentsData.push({
            'Doc Code': d['Doc Code'],
            'Doc Ref #': d['Reference No'],
            Attachment: d['AttImageName'],
            Remarks: d['Remarks'],
            Status: d['Status Count'] > 0 ? d['Status Code'] : 'N/A',
            'Start Date': d['Status Count'] > 0 ? start : 'N/A',
            'Received Date': d['Status Count'] > 0 ? received : 'N/A',
            'Due Date': d['Status Count'] > 0 ? due : 'N/A',
            'Assign To': d['Status Count'] > 0 ? d['Assign To'] : 'N/A',
            Sets: d['Status Count'] > 0 ? d['Sets'] : 'N/A',
            Page: d['Status Count'] > 0 ? d['Pages'] : 'N/A',

            documentguid: d['DocumentGUID'],
            statusseqno: '',
            ID: `${d['Doc Code']}-${d['Reference No']}`,
            fileAtt: d['AttImage'],
            filetype: d['AttImageType'],
            Action: '',
          });
        });
        this.showDocumentsLoader = false;

        // TAS & KPI tab
        if (title === 'View Job') {
          // only populate if it is in view mode, since this tab will be disabled in new & edit mode
          this.statusTaskJobNo = jobno;
          this.statusTaskDocuments = jobDocs; // reuse the results from the same API call
        }
      });
      //#endregion

      //#region Job Milestones
      this.showMilestoneLoader = true;
      this.$apiCallV2(`/HaulageJob/JobMilestones?jobno=${jobno}`).then((jobMilestones) => {
        this.milestonesItem = {
          milestones: jobMilestones['JobMilestones']['Job']['TAS'],
          legend: jobMilestones['Legend'],
        };
        this.showMilestoneLoader = false;
      });
      //#endregion
    },

    appendStatusIcon: function (statusList) {
      const allStatus = statusList.sort((a, b) => {
        return a['#'] < b['#'] ? 1 : -1;
      });
      const statusWithIcons = allStatus.map((s) => {
        switch (s['Progress']) {
          case 'Completed':
            return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusComplete.png' }, s);
          case 'Due':
            return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusDue.png' }, s);
          case 'Due In 2 days':
            return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusDueIn2Days.png' }, s);
          case 'Pending':
            return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusPending.png' }, s);
          case 'Cancelled':
            return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusCancelled.png' }, s);
          default:
            return Object.assign({ '': '' }, s);
        }
      });

      return statusWithIcons;
    },
    //#endregion

    checkRequiredFields: function () {
      this.requiredError = [];
      this.validateDates();
      if (this.dateErrMsg['jobDateTime']) {
        this.requiredError.push({ key: 'jobdatetime', value: this.dateErrMsg['jobDateTime'] });
      }
      if (this.dateErrMsg['etaDateTime']) {
        this.requiredError.push({ key: 'etadatetime', value: this.dateErrMsg['etaDateTime'] });
      }
      if (this.dateErrMsg['etdDateTime']) {
        this.requiredError.push({ key: 'etddatetime', value: this.dateErrMsg['etdDateTime'] });
      }
      if (this.dateErrMsg['closeDateTime']) {
        this.requiredError.push({ key: 'closedatetime', value: this.dateErrMsg['closeDateTime'] });
      }
      if (this.dateErrMsg['demurageDate']) {
        this.requiredError.push({ key: 'demuragedate', value: this.dateErrMsg['demurageDate'] });
      }
      if (this.dateErrMsg['detentionDate']) {
        this.requiredError.push({ key: 'detentiondate', value: this.dateErrMsg['detentionDate'] });
      }

      //#region Job Info checking
      if (!this.selectedShipper) {
        this.requiredError.push({ key: 'shipper', value: 'Shipper is Required!' });
        this.shipperError = 'Shipper is Required!';
      }
      if (this.requestNoIsRequired && !this.requestNo) {
        this.requiredError.push({ key: 'requestno', value: 'Request No is Required!' });
        this.requestNoError = 'Request No is Required!';
      }
      if (!this.selectedBillTo) {
        this.requiredError.push({ key: 'billto', value: 'Bill To is Required!' });
        this.billToError = 'Bill To is Required!';
      }
      if (!this.selectedCheque) {
        this.requiredError.push({ key: 'payment', value: 'Payment is Required!' });
        this.paymentError = 'Payment is Required!';
      }
      if (!this.selectedJobType) {
        this.requiredError.push({ key: 'jobtype', value: 'Job Type is Required!' });
        this.jobTypeError = 'Job Type is Required!';
      }
      if (!this.selectedTrip) {
        this.requiredError.push({ key: 'trip', value: 'Trip is Required!' });
        this.tripError = 'Trip is Required!';
      }
      if (!this.coeff) {
        this.requiredError.push({ key: 'coeff', value: 'Coeff is Required!' });
        this.coeffError = 'Coeff is Required!';
      }
      //#endregion

      //#region Send To checking
      if (!this.selectedPickUp) {
        this.requiredError.push({ key: 'pickup', value: 'Pick Up is Required!' });
        this.pickUpError = 'Pick Up is Required!';
      }
      if (!this.selectedSendTo) {
        this.requiredError.push({ key: 'sendto', value: 'Send To is Required!' });
        this.sendToError = 'Send To is Required!';
      }
      if (!this.selectedDropOff) {
        this.requiredError.push({ key: 'dropoff', value: 'Drop Off is Required!' });
        this.dropOffError = 'Drop Off is Required!';
      }
      //#endregion

      //#region Voyage Info checking
      if (!this.selectedShipCallNo && !this.shipCallNoFreeText) {
        this.requiredError.push({ key: 'shipcall', value: 'Ship Call is Required!' });
        this.shipCallError = 'Ship Call No is Required!';
      }
      if (!this.voyNo) {
        this.requiredError.push({ key: 'voyno', value: 'Voy No is Required!' });
        this.voyNoError = 'Voy No is Required!';
      }
      if (this.forwardingAgentIsRequired && !this.selectedFwdgAgent) {
        this.requiredError.push({ key: 'fwdgagt', value: 'Forwarding Agent is Required!' });
        this.fwdgAgentError = 'Forwarding Agent is Required!';
      }
      if (!this.bookingRefNo && this.bookingRefNoRequired) {
        this.requiredError.push({ key: 'bookingrefno', value: 'Booking Ref No is Required!' });
        this.bookingRefNoError = 'Booking Ref No is Required!';
      }
      //#endregion
    },
    checkContDup: async function () {
      const currentConsignments = this.consignmentList.filter((c) => {
        return (
          c['Cont No'] &&
          c['CN State'] != 'Cancel' 
        );
      });

      const contNoMap = {};
      const dupCont = [];

      currentConsignments.forEach((c) => {
        const contNo = c['Cont No'].trim();

        if (contNoMap[contNo]) {
          dupCont.push(contNo);
        } else {
          contNoMap[contNo] = true;
        }
      });

      const dupConts = [...new Set(dupCont)];

      if (dupConts.length > 0) {
        this.tabIndex = 2;

        this.$showAlert(
          'warning',
          'Container # Check',
          `The following container number(s) are duplicated in this job:\n\n${dupConts.join('\n')}`,
        );

        return false;
      }

      const contNoCheck = [...new Set(currentConsignments.map((c) => c['Cont No'].trim()))];

      if (contNoCheck.length == 0) {
        return true;
      }

      this.$fullscreenLoading('Checking Container No');

      const APICheck = [];

      for (const contNo of contNoCheck) {
        const checkContainer = await this.$apiCallV2('/HaulageJob/CheckContainerExists', {
          containerno: contNo,
          jobdate: this.jobDateTime ? this.jobDateTime.formatString('yyyy-MM-dd') : new Date().formatString('yyyy-MM-dd'),
        });

        if (checkContainer && checkContainer[0] && checkContainer[0]['Results'] == 1) {
          APICheck.push({
            contNo,
            errMsg: checkContainer[0]['ErrMsg'],
          });
        }
      }

      this.$fullscreenLoading();

      if (APICheck.length > 0) {
        const msg = APICheck
          .map((d) => {
            return `Container # ${d.contNo}\n${d.errMsg
              .split(';')
              .map((s) => s.trim())
              .filter((s) => s)
              .join('\n')}`;
          })
          .join('\n\n');

        const forceUseContNo = await this.$showAlert(
          'warning',
          'Container # Frequency Check',
          `NOTE: The following container number(s) are associated with consignment(s) dating not more than a week ago.\n\n${msg}\n\nDo you still want to continue using these container number(s)?`,
          [
            { text: 'Yes' },
            { text: 'No', color: 'gray', textColor: 'white' },
          ],
        );

        if (forceUseContNo == 'No') {
          this.tabIndex = 2;
          return false;
        }
      }
      return true;
    },
    requiredClicked: function (e) {
      if (e == 'jobdatetime') {
        this.tabIndex = 1;
      } else if (
        e == 'etadatetime' ||
        e == 'etddatetime' ||
        e == 'closedatetime' ||
        e == 'demuragedate' ||
        e == 'detentiondate'
      ) {
        this.tabIndex = 3;
      } else {
        this.tabIndex = 0;
      }
      this.$nextTick(() => this.$refs[e].setFocus());
    },

    formatDocuments: function () {
      const adding = this.documentsData.filter((d) => d['Action']);
      const deleting = this.documentsToDelete;

      let addingStr = JSON.stringify(adding.concat(deleting));
      addingStr = addingStr.replace(/"N\/A"/g, '""'); //replace all key values that is "N/A" to empty string instead of below code which replace any N/A
      // addingStr = addingStr.split('N/A').join('');

      const formatted = JSON.parse(addingStr);
      formatted.forEach((f) => {
        f['Start Date'] = f['Start Date'].split(':').join('');
        f['Received Date'] = f['Received Date'].split(':').join('');
        f['Due Date'] = f['Due Date'].split(':').join('');
      });
      return formatted;
    },

    saveClicked: async function () {
      this.errorMessages = [];
      this.checkRequiredFields();
      if (!(await this.checkContDup())) {
        return;
      }

      if (this.requiredError.length > 0) {
        return;
      }

      if (this.popupTitle[0] == 'N' || (this.popupTitle[0] == 'E' && this.selectedJob[0]['Job State'] != 'Confirmed')) {
        this.confirmSavePopup = true;
        const confirmData = await new Promise((r) => (this.confirmSavePopupResolve = r));
        this.confirmSavePopup = false;

        if (confirmData == 'cancel') {
          return;
        }
      }

      const postData = {};

      postData['base'] = this.loginDetails['BaseName'];
      postData['action'] = this.popupTitle[0]; // N is for new and E for edit
      postData['contsize'] = this.consignmentList.length > 0 ? this.consignmentList[0]['Cont Size'] : '';
      postData['conttype'] = this.consignmentList.length > 0 ? this.consignmentList[0]['Cont Type'] : '';
      postData['system'] = 'hms';
      postData['confirmbooking'] = this.saveAsConfirm;
      postData['erot'] = this.popupTitle.includes('(eROT)') ? '1' : '0'; // 1 from erot
      postData['documents'] = await this.formatDocuments();

      postData['unconfirmreason'] =
        this.selectedUnconfirmReason ? this.selectedUnconfirmReason['Reason'].split('-')[0].trim() : '';
      postData['unconfirmremarks'] = this.unconfirmRemarks;

      //#region Job Info Data
      postData['jobno'] = this.popupTitle[0] == 'N' ? '' : this.jobNo.trim();
      postData['urgent'] = this.urgent ? '1' : '0';
      postData['jobdate'] = this.jobDateTime ? this.jobDateTime.formatString('yyyy-MM-dd') : '';
      postData['jobtime'] = this.jobDateTime ? this.jobDateTime.formatString('HHmm') : '';
      postData['customer'] = this.getValueFromObject(this.selectedShipper, 'Customer Code');
      postData['custrefno'] = this.custRefNo.trim();
      postData['projectno'] = this.projectNo.trim();
      // postData['requestno'] = this.eROTRequestNo ? this.eROTRequestNo : this.requestNo.trim();
      postData['requestno'] = this.requestNo.trim();
      postData['requestnotag'] = this.eROTRequestNo; // From auto request no in erot listing
      postData['billto'] = this.getValueFromObject(this.selectedBillTo, 'Customer Code');
      // postData['jobno'] = this.outstanding; // - no key
      // postData['jobno'] = this.status; // - no key
      // postData['jobno'] = this.creditLimit; // - no key
      // postData['jobno'] = this.crTerm; // - no key
      postData['paymenttype'] = this.getValueFromObject(this.selectedCheque, 'Payment Type');
      // postData['jobno'] = this.contact; // - no key
      // postData['jobno'] = this.tel; // - no key
      // postData['jobno'] = this.fax; // - no key
      postData['jobtype'] = this.getValueFromObject(this.selectedJobType, 'Job Type');
      postData['trip'] = this.getValueFromObject(this.selectedTrip, 'Trip');
      postData['coeff'] = this.coeff.trim();
      postData['lockcharges'] = this.keepCharges ? '1' : '0';
      //#endregion

      //#region Send To / Container Info
      postData['consignments'] = JSON.parse(JSON.stringify(this.consignmentList)).map((consignment) => {
        const mappedConsignment = {
          cnstate: consignment['CN State'],
          thirdparty: consignment['Third Party'],
          printed: consignment['Printed'],
          billed: consignment['Billed'],
          assigned: consignment['Assigned'],
          consignmentno: consignment['Consignment No'],
          seqno: consignment['seqno'],
          diversion: consignment['Diversion'],
          premisesis: consignment['Premises Is'],
          cncontsize: consignment['Cont Size'],
          cnconttype: consignment['Cont Type'],
          cndeliverytype: consignment['Delivery Type'],
          cnhandlingtype: consignment['Handling Type'],
          b2bcont: consignment['B2B'],
          timbang: consignment['Timbang'],
          billingfmt: consignment['Billing Format'],
          containerno: consignment['Cont No'],
          operatorcode: consignment['Cont Operator'],
          sealno: consignment['Seal No'],
          pickupref: consignment['Ref No'],
          contheight: consignment['Cont Height'],
          contweight: consignment['Cont Weight'],
          contmeasure: consignment['Cont Measure'],
          cnstatus: consignment['Cont Status'],
          commodity: consignment['Commodity'],
          requireddate: consignment['Required Date'],
          requiredtime: consignment['Required Time'],
          requireddatetimedesc: consignment['Required Desc'],
          cnremarks: consignment['Remarks'],
          fumigation: consignment['Fumigation'],
          officehrsd: consignment['Office Hours Delivery'],
          officehrsc: consignment['Office Hours Collection'],
          temperature: consignment['Temperature'],
          team: consignment['Team'],
          cnaction: consignment['cnaction'],
          haulagerate: consignment['Haulage Rate'],
          tollrate: consignment['Toll Rate'],
          cnsendto: consignment['Send To'],
          cnarea: consignment['Area'],
          cnpickup: consignment['Pick Up'],
          cndropoff: consignment['Drop Off'],
          samesendto: consignment['samesendto'],
          samepickup: consignment['samepickup'],
          samedropoff: consignment['samedropoff'],
        };
        // handle saving cancelled records
        if (consignment['CN State'] === 'Cancel') {
          mappedConsignment.condelete = consignment['condelete'] ? consignment['condelete'] : '';
          mappedConsignment.condeleteassign = consignment['condeleteassign'] ? consignment['condeleteassign'] : '';
          mappedConsignment.consignmentdeletereason =
            consignment['consignmentdeletereason'] ? consignment['consignmentdeletereason'] : '';
          mappedConsignment.isDeletedJobChange = consignment['isDeletedJobChange'];
          mappedConsignment.isDeleted = consignment['isDeleted'];
        }
        return mappedConsignment;
      });

      if (postData['consignments'].every((consignment) => consignment.cnstate === 'Cancel')) {
        const alertNoConsignments = `There are no consigments. This job will be set as canceled. Do you wish to proceed?`;
        const noConsignments = await this.$showAlert('warning', 'No Consignment', alertNoConsignments, [
          { text: 'Yes' },
          { text: 'No', color: 'lightgray' },
        ]);
        if (noConsignments == 'No') {
          return;
        }
      }

      // If a consignment is deleted (in that session) -> ['isDeleted'] == 'deleted'
      // If a consignment is deleted due to change job type -> ['isDeletedJobChange'] == 'deletedJobChange'
      // If a consignment is added (in that session) -> ['cnaction'] == 'N'
      postData['consignments'].forEach((c) => {
        if (c['isDeleted'] !== 'deleted' && c['cnaction'] !== 'N' && c['isDeletedJobChange'] !== 'deletedJobChange') {
          c['cnaction'] = 'E'; // set E to consignments that is not newly deleted/cancelled or newly added.
        }
      });

      postData['consignments'] = postData['consignments'].filter((c) => {
        // don't post consignments that is deleted in the past
        return !(
          c['isDeleted'] !== 'deleted' &&
          c['cnstate'] === 'Cancel' &&
          c['isDeletedJobChange'] !== 'deletedJobChange'
        );
      });

      // Sort the array to process newly added consignments first
      // to avoid issues where the backend sets the job as cancelled job when all consignments are deleted but the newly added consignments are not processed yet
      postData['consignments'].sort((a, b) => {
        if (a.cnaction === 'N' && b.cnaction !== 'N') {
          return -1;
        } else if (a.cnaction !== 'N' && b.cnaction === 'N') {
          return 1;
        }
        return 0;
      });

      // postData['consignments'].forEach((c, i) => {
      //   if (!c['cnaction']) {
      //     if (c['cnstate'] == 'Cancel') {
      //       //removed from list because cancelled consignment not needed to send to API
      //       postData['consignments'].splice(i, 1);
      //     }
      //     c['cnaction'] = 'E';
      //   }
      // });

      // this.consignmentToDelete.forEach(c => {
      //   c['cnaction'] = 'D';
      //   postData['consignments'].push(c);
      // });
      //#endregion

      //#region Voyage Info
      postData['shipcallno'] =
        this.selectedShipCallNo ?
          this.getValueFromObject(this.selectedShipCallNo, 'Ship Call No')
        : this.shipCallNoFreeText;
      postData['voyno'] = this.voyNo.trim();
      postData['vesselcode'] = this.getValueFromObject(this.selectedVesselCode, 'Vessel ID');
      postData['vesselname'] = this.getValueFromObject(this.selectedVesselCode, 'Vessel Name');
      postData['transhipport'] = this.getValueFromObject(this.selectedTranshipPort, 'Port Code');
      postData['transhipportdesc'] = this.getValueFromObject(this.selectedTranshipPort, 'Port Location');
      postData['loaddischargeport'] =
        this.selectedDischargePort ?
          this.getValueFromObject(this.selectedDischargePort, 'Port Code')
        : this.dischargePortFreeText.trim();
      postData['loaddischargeportdesc'] = this.getValueFromObject(this.selectedDischargePort, 'Port Location');
      postData['etadate'] = this.etaDateTime ? this.etaDateTime.formatString('yyyy-MM-dd') : '';
      postData['etatime'] = this.etaDateTime ? this.etaDateTime.formatString('HHmm') : '';
      postData['etddate'] = this.etdDateTime ? this.etdDateTime.formatString('yyyy-MM-dd') : '';
      postData['etdtime'] = this.etdDateTime ? this.etdDateTime.formatString('HHmm') : '';
      postData['closedate'] = this.closeDateTime ? this.closeDateTime.formatString('yyyy-MM-dd') : '';
      postData['closetime'] = this.closeDateTime ? this.closeDateTime.formatString('HHmm') : '';
      postData['demurragedate'] = this.demurageDate ? this.demurageDate.formatString('yyyy-MM-dd') : '';
      postData['detentiondate'] = this.detentionDate ? this.detentionDate.formatString('yyyy-MM-dd') : '';

      postData['shippingline'] = this.shippingLine.trim();
      postData['shippingagent'] = this.getValueFromObject(this.selectedShippingAgent, 'Agent Code');
      // postData['key'] = this.shipAgtTel.trim(); // - no key
      // postData['key'] = this.shipAgtFax.trim(); // - no key
      postData['forwardingagent'] = this.getValueFromObject(this.selectedFwdgAgent, 'FA Code');
      // postData['key'] = this.fwdgAgtTel.trim(); // - no key
      // postData['key'] = this.fwdgAgtFax.trim(); // - no key
      postData['prev_refjobno'] = this.prevrefjobno ?? '';
      postData['bookingrefno'] = this.bookingRefNo ? this.bookingRefNo.trim() : '';
      postData['requestedby'] = this.requestedBy.trim();
      postData['finaldestination'] = this.finalDestination.trim();
      postData['offloadatpremis'] = this.premisOffload ? '1' : '0';

      postData['freestorageval'] = this.freeStorage;
      postData['freedemurrage'] = this.freeDemurrage;
      postData['freedetention'] = this.freeDetention;
      postData['storageunit'] = this.storageUnit;
      postData['demurrageunit'] = this.demurrageUnit;
      postData['detentionunit'] = this.detentionUnit;
      //#endregion

      this.$fullscreenLoading(this.popupTitle[0] == 'N' ? 'Saving Job' : 'Editing Job');
      const result = await this.$apiCallV2('/HaulageJob/SaveHMSJob', postData);
      this.$fullscreenLoading();
      if (result[0]['Results'] == 0) {
        this.jobNo = result[0]['Job No'];
        if (this.popupTitle[0] == 'N') {
          this.successMessages.push(`Successfully created a new Haulage Job (Job # - ${result[0]['Job No']})`);
        } else {
          this.successMessages.push(`Successfully edited your Job (Job # - ${result[0]['Job No']})`);
        }

        this.refreshClicked();
        this.documentsData = [];
        await this.getJobDetails('View Job', result[0]['Job No']);

        // Change to view mode
        this.viewMode = true;
        this.popupTitle = `View Job (${result[0]['Job No']})`;
        if (this.tabIndex == 2 && this.openConsignment) {
          // Making sure that the edit button in the consignment table box is removed
          this.openConsignment = false;
          this.$nextTick(() => (this.openConsignment = true));
        }

        //#region Save eROT selection
        if (this.eROTDetectedData && this.eROTSelectedData) {
          this.eROTSelectedData['shipperConsignee'] = this.getValueFromObject(this.selectedShipper, 'Customer Code');
          this.eROTSelectedData['billTo'] = this.getValueFromObject(this.selectedBillTo, 'Customer Code');
          this.eROTSelectedData['pickup'] = this.getValueFromObject(this.selectedSendTo, 'Destination Code');
          this.eROTSelectedData['sendto'] = this.getValueFromObject(this.selectedPickUp, 'Destination Code');
          this.eROTSelectedData['dropoff'] = this.getValueFromObject(this.selectedDropOff, 'Destination Code');
          this.eROTSelectedData['forwardingAgent'] = this.getValueFromObject(this.selectedFwdgAgent, 'Agent Code');
          this.eROTSelectedData['shippingAgent'] = this.getValueFromObject(this.selectedShippingAgent, 'Agent Code');

          const keyToRemove = Object.keys(this.eROTDetectedData).filter((k) => !this.eROTDetectedData[k]);
          keyToRemove.forEach((k) => {
            delete this.eROTDetectedData[k];
            delete this.eROTSelectedData[k];
          });

          this.$fullscreenLoading('Save User Selection');
          await this.$apiCallV2('/UserSelection/SaveUserSelection', {
            coRefname: this.loginDetails['CoRefname'],
            selections: JSON.stringify(this.eROTSelectedData),
            scans: JSON.stringify(this.eROTDetectedData),
          });
          this.$fullscreenLoading();
        }
        //#endregion
      } else {
        this.errorMessages.push(
          `There was an error ${this.popupTitle[0] == 'N' ? 'creating' : 'editing'} your ${this.popupTitle[0] == 'N' ? 'new' : ''} job: ${result[0]['ErrMsg']}`,
        );
      }
    },
    clearData: function () {
      this.popupShow = false;
      this.isDiversionForCN = false;
      this.popupTitle = '';
      this.tabIndex = 0;
      this.tabsItems[5]['disabled'] = true;

      this.eROTDisable = false;
      this.bookingRefNoRequired = false;
      this.editJobDisabled = false;
      this.editJobBilledDisabled = false;
      this.editJobPaidDisabled = false;
      this.editCNDisabled = false;
      this.editCNBilledDisabled = false;
      this.editCNPaidDisabled = false;

      this.statusButtons.forEach((s) => (s['checked'] = false));

      this.coeffDisable = false;
      this.keepChargesDisable = false;
      this.closeDateTimeDisable = false;
      this.demurageDateDisable = false;
      this.detentionDateDisable = false;

      //#region Job Milestones
      this.showMilestones = true;
      this.milestonesItem = null;
      //#endregion

      //#region Job Info Data
      this.jobNo = '';
      this.urgent = false;
      this.jobDateTime = null;
      this.shipperCaption = 'Shipper';
      this.selectedShipper = null;
      this.shipperError = '';
      this.custRefNo = '';
      this.projectNo = '';
      this.requestNo = '';
      this.requestNoError = '';
      this.prevrefjobno = '';
      this.selectedBillTo = null;
      this.billToError = '';
      this.billToDetails = null;
      this.outstanding = '';
      this.status = '';
      this.creditLimit = '';
      this.crTerm = '';
      this.selectedCheque = null;
      this.paymentError = '';
      this.contact = '';
      this.tel = '';
      this.fax = '';
      this.selectedJobType = null;
      this.selectedJob = [];
      this.jobTypeError = '';
      this.selectedTrip = null;
      this.tripError = '';
      this.coeff = '';
      this.coeffError = '';
      this.keepCharges = false;
      this.jobTypeItems = this.allJobTypes;
      //#endregion

      //#region Send To / Container Data
      this.openSendTo = true;
      this.openConsignment = true;
      this.selectedSendTo = null;
      this.sendToAddress = '';
      this.sendToError = '';
      this.isDiversion = false;
      this.selectedPremises = null;
      this.selectedPickUp = null;
      this.pickUpAddress = '';
      this.pickUpError = '';
      this.selectedDropOff = null;
      this.dropOffAddress = '';
      this.dropOffError = '';
      this.consignmentList = [];
      this.selectedConsignments = [];
      this.selectedConsignmentNo = '';
      this.consignmentToDelete = [];
      this.cdaNo = '';
      this.contNo = '';
      this.sealNo = '';
      this.contOp = '';
      this.contOpError = '';
      this.refNo = '';
      this.selectedSize = null;
      this.sizeError = '';
      this.selectedType = null;
      this.typeError = '';
      this.selectedHandling = null;
      this.handlingError = '';
      this.selectedDelivery = null;
      this.deliveryError = '';
      this.selectedTeam = null;
      // this.statusButtons = [
      //   { title: 'Laden', checked: false },
      //   { title: 'Empty', checked: false }
      // ];
      this.statusError = '';
      this.containerRemarks = '';
      this.temperature = '';
      this.measure = '';
      this.weight = '';
      this.height = '';
      this.commodity = '';
      this.commodityError = '';
      this.requiredDateTimeChk = false;
      this.requiredTime = null;
      this.requiredTimeDescSelectedObject = null;
      this.requiredTimeDescSearch = '';
      this.isOfficeHrsD = false;
      this.isOfficeHrsC = false;
      this.isb2b = false;
      this.isFumigation = false;
      this.isTimbang = false;
      this.selectedBillingFormat = null;
      this.billingFormatError = '';
      this.haulageTariff = '';
      this.tollTariff = '';
      this.openConsignmentPopup = false;
      this.samePickUp = true;
      this.sameSendTo = true;
      this.sameDropOff = true;
      this.selectedSendToCN = null;
      this.selectedPickUpCN = null;
      this.selectedDropOffCN = null;
      //#endregion

      //#region Voyage Info Data
      this.selectedShipCallNo = null;
      this.shipCallNoFreeText = '';
      this.shipCallError = '';
      this.voyNo = '';
      this.voyNoError = '';
      this.selectedVesselCode = null;
      this.selectedTranshipPort = null;
      this.selectedDischargePort = null;
      this.dischargePortFreeText = '';
      this.etaDateTime = null;
      this.etdDateTime = null;
      this.closeDateTime = null;
      this.demurageDate = null;
      this.detentionDate = null;
      this.shippingLine = '';
      this.selectedShippingAgent = null;
      this.shipAgtTel = '';
      this.shipAgtFax = '';
      this.selectedFwdgAgent = null;
      this.fwdgAgentError = '';
      this.fwdgAgtTel = '';
      this.fwdgAgtFax = '';
      this.bookingRefNo = '';
      this.bookingRefNoError = '';
      this.requestedBy = '';
      this.finalDestination = '';
      this.premisOffload = false;

      this.freeStorage = '';
      this.storageUnit = 'D';
      this.freeDemurrage = '';
      this.demurrageUnit = 'D';
      this.freeDetention = '';
      this.detentionUnit = 'D';
      //#endregion

      //#region Documents Data
      this.docStatusPopup = false;

      this.editDocumentsList = [];

      this.documentsData = [];
      this.selectedDocuments = [];
      this.documentsToDelete = [];
      //#endregion

      //#region TAS & KPI Data
      this.statusTaskJobNo = '';
      this.statusTaskDocuments = [];
      this.statusTaskStatusData = [];
      //#endregion

      this.requiredError = [];
      this.successMessages = [];
      this.errorMessages = [];
      this.dateErrMsg = {
        jobDateTime: '',
        etaDateTime: '',
        etdDateTime: '',
        closeDateTime: '',
        demurageDate: '',
        detentionDate: '',
        requiredTime: '',
      };
      this.viewMode = false;

      this.showJobTypePopup = false;

      this.eROTRequestNo = '';
      this.eROTFullDetails = null;

      this.eROTDetectedData = null;
      this.eROTSelectedData = null;
    },

    popupEntryPrintClicked: function () {
      this.popupShow = false;
      // this.selectedJob = [];
      // let temp = this.jobData.find(job => job['Job No'] == this.jobNo);
      // this.selectedJob.push(temp);

      this.printCN(this.jobNo);
    },
    getValueFromObject: function (data, key) {
      const result = data ? data[key] : '';
      return result ? result.toString().trim() : '';
    },

    //#region Job Info functions
    billToSelected: async function (e) {
      this.billToDetails = null;
      if (!e) {
        return;
      }
      const outstanding = (await this.$apiCallV2(`/HaulageJob/GetAROutstanding?cust=${e['Customer Code'].trim()}`))[0];

      this.billToDetails = {};
      this.billToDetails['creditLimit'] = outstanding['CreditLimit'];
      this.billToDetails['creditTerms'] =
        `${outstanding['CreditTerm']} ${outstanding['CreditTypeDesc'] ? outstanding['CreditTypeDesc'].trim() : ''}`;
      this.billToDetails['status'] = { text: outstanding['CusStatus'], color: outstanding['CusStatusColor'] };
      this.billToDetails['outstanding'] = {
        perc: outstanding['PerOutstanding'],
        color: outstanding['PerOutstandingColor'],
        value: outstanding['Outstanding'],
      };
      this.billToDetails['currency'] = outstanding['Currency'] ? outstanding['Currency'].trim() : '';

      this.selectedCheque = this.chequeItems.getSelected(e['Payment Type'], 'Payment Type');
    },
    checkJobTypeChanges: async function (newVal, oldVal) {
      if (
        newVal['Job Type Header'] != oldVal['Job Type Header'] &&
        this.consignmentList.length > 0 &&
        newVal['Job Type'] != 'IMP-EXP' &&
        oldVal['Job Type'] != 'IMP-EXP'
      ) {
        const newType = newVal['Job Type Header'] == 'I' ? 'Import' : 'Export';
        const oldType = oldVal['Job Type Header'] == 'I' ? 'Import' : 'Export';

        //let clearEmtpyContNo = false;
        let alertContent = `You're changing the job type from <b>${oldType}</b> to <b>${newType}</b>.`;
        // if (oldType == 'Export' && newType == 'Import') { // Changing from Import -> Export
        //   clearEmtpyContNo = true;
        //   alertContent += '<br>If you change the job type, your consignment list with empty container number will be cleared.'
        // }
        alertContent += '<br><br>Are you sure you want to change the Job Type?';
        const confirmChange = await this.$showAlert('warning', 'Job Type Change', alertContent, [
          { text: 'Change Job Type' },
          { text: 'Cancel', color: 'lightgray' },
        ]);

        if (confirmChange == 'Change Job Type') {
          // User confirms to change the job type
          if (oldType == 'Export' && newType == 'Import') {
            // user can choose to delete consignments with empty container number or not
            let emptyCont = this.consignmentList.filter((c) => !c['Cont No']);
            emptyCont = emptyCont.filter((c) => {
              return !(c['CN State'] === 'Cancel');
            });
            if (emptyCont.length > 0) {
              const alertContentDelete = `Do you want to delete ${emptyCont.length} consignments with <b>empty container number</b>?`;
              const confirmDelete = await this.$showAlert('warning', 'Delete Consignments', alertContentDelete, [
                { text: 'Yes' },
                { text: 'No', color: 'lightgray' },
              ]);
              if (confirmDelete == 'Yes') {
                // User decided to delete consignments with empty cont no.
                this.consignmentList = this.consignmentList.filter((e) => !(e.cnaction === 'N' && !e['Cont No']));
                emptyCont.forEach((e) => {
                  if (e.cnaction !== 'N') {
                    e['CN State'] = 'Cancel';
                    e.isDeletedJobChange = 'deletedJobChange'; // add hidden value to indicate this record is deleted due to change of job type
                    e.cnaction = 'D';
                    e.condelete = 'D';
                    e.condeleteassign = 'D';
                    e.consignmentdeletereason = 'Change job type EXPORT -> IMPORT';
                  }
                });
              }
            }
          }
        } else {
          // User click on cancel
          this.checkJobTypeChange = false;
          this.$nextTick(() => (this.selectedJobType = oldVal));
        }
      }
    },
    //#endregion

    //#region Send To / Container Info functions
    addConsignmentPopup: async function () {
      if (!this.selectedJobType) {
        this.cnEditIndex = -1;
        this.showJobTypePopup = true;
      } else {
        //add consignment default
        this.cnEditIndex = -1;
        this.selectedSize = this.selectedSize ?? this.sizeItems.getSelected('GP', 'Size');
        this.selectedSize = this.selectedSize ?? this.sizeItems[0]; //if unable to find "GP"
        this.selectedType = this.selectedType ?? this.typeItems.getSelected('GP', 'Cont Type');
        this.selectedHandling = this.selectedHandling ?? this.handlingItems.getSelected('N', 'Handling Type');
        const defaultDelType = await this.$apiCallV2(`/Master/GetSettingsSystem?settingsItem=HMSDefaultDelType`);
        if (defaultDelType) {
          this.selectedDelivery =
            this.selectedDelivery ??
            this.deliveryItems.getSelected(defaultDelType[0]['SettingsValue'], 'Delivery Type');
        } else {
          this.selectedDelivery = this.selectedDelivery ?? this.deliveryItems[0];
        }

        this.statusButtons = JSON.parse(JSON.stringify(this.statusButtonsOri)); //ori only changed when selectedjobtype changed therefore here replace with ori
        if (this.selectedBillTo?.['Billing Format']) {
          this.selectedBillingFormat = this.billingFormatItems.getSelected(
            this.selectedBillTo['Billing Format'],
            'Billing Fmt',
          );
        }
        this.openConsignmentPopup = true;
      }
    },
    addConsignment: async function () {
      let addError = false;
      //#region Validating
      if (!this.contOp) {
        this.contOpError = 'Cont Op is required!';
        addError = true;
      }
      if (this.isContNo && this.selectedJobType['Job Type Header'] == 'I' && !this.contNo) {
        this.contNoError = 'Container No is required!';
        addError = true;
      }
      if (this.isContCount && !this.contCount) {
        this.contCountError = 'Container Count is required!';
        addError = true;
      } else if (this.contCount > 999) {
        //max number set to avoid too many added
        this.contCountError = 'Container Count cannot more than 999';
        addError = true;
      }
      if (!this.selectedSize) {
        this.sizeError = 'Container Size is required!';
        addError = true;
      }
      if (!this.selectedType) {
        this.typeError = 'Container Type is required!';
        addError = true;
      }
      if (!this.selectedHandling) {
        this.handlingError = 'Handling is required!';
        addError = true;
      }
      if (!this.selectedDelivery) {
        this.deliveryError = 'Delivery  is required!';
        addError = true;
      }
      if (this.statusButtons.filter((s) => s['checked']).length == 0) {
        this.statusError = 'Status is required!';
        addError = true;
      }
      if (!this.commodity) {
        this.commodityError = 'Commodity is required!';
        addError = true;
      }
      if(!this.weight){
        this.weightError = "Weight is required!";
        addError = true;
      }
      if (!this.selectedBillingFormat) {
        this.billingFormatError = 'Billing format is required!';
        addError = true;
      }
      if (!this.samePickUp && !this.selectedPickUpCN) {
        this.pickUpCNError = 'Pick Up is required!';
        addError = true;
      }
      if (!this.sameSendTo && !this.selectedSendToCN) {
        this.sendToCNError = 'Send To is required!';
        addError = true;
      }
      if (!this.sameDropOff && !this.selectedDropOffCN) {
        this.dropOffCNError = 'Drop Off is required!';
        addError = true;
      }
      if (!this.requiredDateTimeChk) {
        this.dateErrMsg['requiredTime'] = '';
      } else if (!this.requiredTime) {
        this.dateErrMsg['requiredTime'] = 'Required Time is required!';
        addError = true;
      } else if (this.dateErrMsg['requiredTime']) {
        addError = true;
      }
      //#endregion

      if (!addError) {
        if (this.isContNo) {
          // prompt warning if empty container number
          if (this.selectedJobType['Job Type Header'] == 'I' && !this.contNo) {
            const alertEmptyContainerNo = `This is an Import job. Do you wish to add consignment without container number?`;
            const addEmptyContainerNoError = await this.$showAlert(
              'warning',
              'Empty Container Number',
              alertEmptyContainerNo,
              [{ text: 'Yes' }, { text: 'No', color: 'lightgray' }],
            );
            if (addEmptyContainerNoError == 'No') {
              return;
            }
          }
        }
        // let temp = this.consignmentList;
        // this.consignmentList = [];
        const count = this.isContNo ? 1 : parseInt(this.contCount);
        if (this.isContCount && this.selectedJobType['Job Type Header'] == 'I') {
          this.showContNoPopup = true;

          const addCont = await this.addContainerNumber();
          if (addCont == 'Cancel') {
            return;
          }
        }
        //#region Checking Container No
        if (this.isContNo) {
          //ignore checking if contno is empty
          if (this.contNo) {
            //check current consignment list first
            const currentContCheck = this.consignmentList.find(
              (f, index) => f['Cont No'] == this.contNo && f['CN State'] != 'Cancel' && index != this.cnEditIndex,
            );
            if (currentContCheck) {
              this.$showAlert('warning', 'Container # Check', `Container # ${this.contNo} already in this job.`);
              return;
            }

            this.$fullscreenLoading('Checking Container No');
            const checkContainer = await this.$apiCallV2('/HaulageJob/CheckContainerExists', {
              containerno: this.contNo,
              jobdate:
                this.jobDateTime ? this.jobDateTime.formatString('yyyy-MM-dd') : new Date().formatString('yyyy-MM-dd'),
            });
            this.$fullscreenLoading();

            if (checkContainer[0]['Results'] == 1) {
              const forceUseContNo = await this.$showAlert(
                'warning',
                'Container # Frequency Check',
                `NOTE: This container number is associated with a consignment dating not more than a week ago.\n\n${checkContainer[0][
                  'ErrMsg'
                ]
                  .split(';')
                  .map((s) => s.trim())
                  .join('\n')}\n\nDo you still want to continue using this continer number?`,
                [{ text: 'Yes' }, { text: 'No', color: 'gray', textColor: 'white' }],
              );

              if (forceUseContNo == 'No') {
                return;
              }
            }
          }
        }
        const temp = this.consignmentList;
        this.consignmentList = [];
        //#endregion
        if (this.cnEditIndex < 0) {
          for (let i = 0; i < count; i++) {
            temp.push({
              'CN State': '',
              'Is Diversion':
                '<div style="background-color: red; padding: 5px; border-radius:5px; color: black">No</div>',
              'Third Party': '',
              Printed: '0',
              Billed: '0',
              Assigned: '0',
              'Consignment No': this.cdaNo,
              seqno: '',
              Diversion: this.isDiversionCN ? '1' : '0',
              'Premises Is': this.getValueFromObject(this.selectedPremisesCN, '#') || '1',
              'Cont Size': this.getValueFromObject(this.selectedSize, 'Size'),
              'Cont Type': this.getValueFromObject(this.selectedType, 'Cont Type'),
              'Delivery Type': this.getValueFromObject(this.selectedDelivery, 'Delivery Type'),
              'Handling Type': this.getValueFromObject(this.selectedHandling, 'Handling Type'),
              B2B: this.isb2b ? '1' : '0',
              Timbang: this.isTimbang ? '1' : '0',
              'Billing Format': this.getValueFromObject(this.selectedBillingFormat, 'Billing Fmt'),
              'Cont No':
                this.isContNo ? this.contNo
                : this.contList.length > 0 ? this.contList[i]
                : '',
              'Cont Operator': this.contOp,
              'Seal No': this.sealNo,
              'Ref No': this.refNo,
              'Cont Height': this.height,
              'Cont Weight': this.weight,
              'Cont Measure': this.measure,
              'Cont Status': this.statusButtons.filter((s) => s['checked'])[0]['title'],
              Commodity: this.commodity,
              'Required Date': this.requiredDateTimeChk && this.requiredTime ? this.requiredTime.formatString('yyyy-MM-dd') : '',
              'Required Time': this.requiredDateTimeChk && this.requiredTime ? this.requiredTime.formatString('HHmm') : '',
              'Required Desc': this.requiredTimeDescSearch,
              Remarks: this.containerRemarks,
              Fumigation: this.isFumigation ? '1' : '0',
              'Office Hours Delivery': this.isOfficeHrsD ? '1' : '0',
              'Office Hours Collection': this.isOfficeHrsC ? '1' : '0',
              Temperature: this.temperature,
              Team: this.getValueFromObject(this.selectedTeam, 'Team'),
              cnaction: 'N',
              'Haulage Rate': this.haulageTariff,
              'Toll Rate': this.tollTariff,
              'Send To': this.getValueFromObject(this.selectedSendToCN, 'Destination Code'),
              Area: this.getValueFromObject(this.selectedSendToCN, 'Tariff Area'),
              'Pick Up': this.getValueFromObject(this.selectedPickUpCN, 'Destination Code'),
              'Drop Off': this.getValueFromObject(this.selectedDropOffCN, 'Destination Code'),
              samesendto: this.sameSendTo,
              samepickup: this.samePickUp,
              samedropoff: this.sameDropOff,
            });
          }
        } else {
          const tempData = temp[this.cnEditIndex];
          // let cnaction = temp[this.cnEditIndex]['cnaction']
          temp.splice(this.cnEditIndex, 1, {
            'CN State': tempData['CN State'],
            'Is Diversion': tempData['Is Diversion'],
            'Third Party': tempData['Third Party'],
            Printed: tempData['Printed'],
            Billed: tempData['Billed'],
            Assigned: tempData['Assigned'],
            'Consignment No': this.cdaNo,
            seqno: '',
            Diversion: this.isDiversionCN ? '1' : '0',
            'Premises Is':
              this.getValueFromObject(this.selectedPremisesCN, '#') ?
                this.getValueFromObject(this.selectedPremisesCN, '#')
              : '1',
            'Cont Size': this.getValueFromObject(this.selectedSize, 'Size'),
            'Cont Type': this.getValueFromObject(this.selectedType, 'Cont Type'),
            'Delivery Type': this.getValueFromObject(this.selectedDelivery, 'Delivery Type'),
            'Handling Type': this.getValueFromObject(this.selectedHandling, 'Handling Type'),
            B2B: this.isb2b ? '1' : '0',
            Timbang: this.isTimbang ? '1' : '0',
            'Billing Format': this.getValueFromObject(this.selectedBillingFormat, 'Billing Fmt'),
            'Cont No': this.isContNo ? this.contNo : this.contList[this.cnEditIndex],
            'Cont Operator': this.contOp,
            'Seal No': this.sealNo,
            'Ref No': this.refNo,
            'Cont Height': this.height,
            'Cont Weight': this.weight,
            'Cont Measure': this.measure,
            'Cont Status': this.statusButtons.filter((s) => s['checked'])[0]['title'],
            Commodity: this.commodity,
            'Required Date': this.requiredDateTimeChk && this.requiredTime ? this.requiredTime.formatString('yyyy-MM-dd') : '',
            'Required Time': this.requiredDateTimeChk && this.requiredTime ? this.requiredTime.formatString('HHmm') : '',
            'Required Desc': this.requiredTimeDescSearch,
            Remarks: this.containerRemarks,
            Fumigation: this.isFumigation ? '1' : '0',
            'Office Hours Delivery': this.isOfficeHrsD ? '1' : '0',
            'Office Hours Collection': this.isOfficeHrsC ? '1' : '0',
            Temperature: this.temperature,
            Team: this.getValueFromObject(this.selectedTeam, 'Team'),
            cnaction: tempData['cnaction'] == 'N' ? 'N' : 'E',
            'Haulage Rate': this.haulageTariff,
            'Toll Rate': this.tollTariff,
            'Send To': this.getValueFromObject(this.selectedSendToCN, 'Destination Code'),
            Area: this.getValueFromObject(this.selectedSendToCN, 'Tariff Area'),
            'Pick Up': this.getValueFromObject(this.selectedPickUpCN, 'Destination Code'),
            'Drop Off': this.getValueFromObject(this.selectedDropOffCN, 'Destination Code'),
            samesendto: this.sameSendTo,
            samepickup: this.samePickUp,
            samedropoff: this.sameDropOff,
          });

          this.selectedConsignments = [];
        }

        this.$nextTick(() => {
          this.consignmentList = temp;
          this.openConsignmentPopup = false;
        });
      }
    },
    editConsignment: async function (_button, data) {
      const tempData = JSON.parse(JSON.stringify(data));
      if (tempData) {
        delete tempData['_rowid'];
      }

      const tempConsignmentList = JSON.parse(JSON.stringify(this.consignmentList));
      tempConsignmentList.forEach((f) => {
        delete f['_rowid'];
      });
      // this.cnEditIndex = this.consignmentList.findIndex(c => JSON.stringify(c) == JSON.stringify(data));
      this.cnEditIndex = tempConsignmentList.findIndex((c) => JSON.stringify(c) == JSON.stringify(tempData));
      if (!this.selectedJobType) {
        this.showJobTypePopup = true;
      } else {
        if (data['CN State'] == 'Cancel' || data['CN State'] == 'Hold') {
          this.$showAlert('error', 'Unable to Edit Consignment', `${data['CN State']} consignment cannot be edited.`);
          return;
        }
        if (data['Third Party']) {
          const thirdParty = await this.$showAlert(
            'warning',
            'Edit Consignment',
            'Consignment already assigned to 3rd party haulier.\nAre you sure you want to edit consignment?',
            [{ text: 'Yes' }, { text: 'No', color: 'gray', textColor: 'white' }],
          );
          if (thirdParty == 'No') {
            return;
          }
        }
        if (data['Printed'] > 0) {
          const consignmentPrinted = await this.$showAlert(
            'warning',
            'Edit Consignment',
            'Invoice Statement already printed for consignment.\nYou will have to reprint the invoice(s) if you edit this consignment\nDo you still want to edit this?',
            [{ text: 'Yes' }, { text: 'No', color: 'gray', textColor: 'white' }],
          );
          if (consignmentPrinted == 'No') {
            return;
          }
        }

        this.editCNDisabled = false;
        this.editCNBilledDisabled = false;
        this.editCNPaidDisabled = false;
        this.editCNData = null;

        let CheckAccount = [];
        if (this.popupTitle[0] == 'E') {
          //if is edit existing job only check account
          const checkAccountJSON = {
            checktype: 'EDIT CN',
            jobno: this.selectedJob[0]['Job No'],
            cnno: data['Consignment No'],
            contno: data['Cont No'],
            chargescode: '',
            system: 'HMS',
            chkpayment: '0',
          };

          CheckAccount = await this.$apiCallV2('/HaulageJob/CheckAccounts', checkAccountJSON);
        } else if (this.popupTitle[0] == 'N') {
          //if is new job, ignore check account API
          CheckAccount.push({
            Results: '0',
            ErrMsg: '',
          });
        }

        if (CheckAccount[0]['Results'] == 0) {
          if (CheckAccount[0]['ErrMsg'] != '') {
            this.editCNData = data;
            this.editCNCheckingMessage = CheckAccount[0]['ErrMsg'];
            this.editCNStatus = CheckAccount[0]['editstatus'];
            this.editCNRemarks = '';
            this.editCNRemarksError = '';
            this.showEditCNPopup = true;
          } else {
            this.populateCNEditDetails(data);
            this.openConsignmentPopup = true;
          }
        } else {
          this.$showAlert('error', 'Check Accounts', CheckAccount[0]['ErrMsg']);
        }

        // this.populateCNEditDetails(data);
        // this.openConsignmentPopup = true;
      }
    },
    populateCNEditDetails: function (data) {
      this.cdaNo = data['Consignment No'];
      this.contNo = data['Cont No'];
      this.isContNo = true;
      this.isContCount = false;
      this.sealNo = data['Seal No'];
      this.contOp = data['Cont Operator'];
      this.refNo = data['Ref No'];
      this.selectedSize = this.sizeItems.find((s) => s['Size'] == data['Cont Size']);
      this.selectedType = this.typeItems.find((t) => t['Cont Type'] == data['Cont Type']);
      this.selectedHandling = this.handlingItems.find((h) => h['Handling Type'] == data['Handling Type']);
      this.selectedDelivery = this.deliveryItems.find((d) => d['Delivery Type'] == data['Delivery Type']);
      this.selectedTeam = this.teamItems.find((t) => t['Team'] == data['Team']);
      if (data['Cont Status']) {
        this.statusButtons.find((s) => s['title'] == data['Cont Status'])['checked'] = true;
      }
      this.containerRemarks = data['Remarks'];
      this.temperature = data['Temperature'];
      this.measure = data['Cont Measure'];
      this.weight = data['Cont Weight'];
      this.height = data['Cont Height'];
      this.commodity = data['Commodity'];
      this.requiredTimeDescSelectedObject =
        this.requiredTimeDescItems.find((item) => {
          return item['Description'] === data['Required Desc'];
        }) ?? null;
      this.requiredTimeDescSearch = data['Required Desc'];
      this.requiredTime =
        data['Required Date'] ?
          new Date(
            `${data['Required Date']} ${data['Required Time'].substring(0, 2)}:${data['Required Time'].substring(2)}`,
          )
        : null;
      this.requiredDateTimeChk = Boolean(this.requiredTime);
      this.isOfficeHrsD = data['Office Hours Delivery'] == '1';
      this.isOfficeHrsC = data['Office Hours Collection'] == '1';
      this.isb2b = data['B2B'] == '1';
      this.isFumigation = data['Fumigation'] == '1';
      this.isTimbang = data['Timbang'] == '1';
      this.selectedBillingFormat = this.billingFormatItems.find((b) => b['Billing Fmt'] == data['Billing Format']);
      this.haulageTariff = data['Haulage Rate'];
      this.tollTariff = data['Toll Rate'];

      this.samePickUp = data['samepickup'];
      this.sameSendTo = data['samesendto'];
      this.sameDropOff = data['samedropoff'];

      this.selectedSendToCN = this.sendToItems.find((s) => s['Destination Code'] == data['Send To']);
      this.selectedPickUpCN = this.pickUpItems.find((p) => p['Destination Code'] == data['Pick Up']);
      this.selectedDropOffCN = this.dropOffItems.find((d) => d['Destination Code'] == data['Drop Off']);
    },
    deleteConsignment: async function () {
      if (this.selectedConsignments.length == 0) {
        this.$showAlert('error', 'No Consignments', 'Please select at least one consignment to delete.');
        return;
      }

      if (this.selectedConsignments[0]['CN State'] == 'Cancel') {
        this.$showAlert('error', 'Unable to Delete Consignment', 'Consignment already cancelled.');
        return;
      }
      if (this.selectedConsignments[0]['cnaction'] == 'N') {
        //if is new action, delete no need to do checking
        const temp = JSON.parse(JSON.stringify(this.consignmentList));
        this.consignmentList = [];
        const index = temp.findIndex((t) => JSON.stringify(t) == JSON.stringify(this.selectedConsignments[0]));
        //let index = temp.findIndex(t => t['Cont No'] == this.selectedConsignments[0]['Cont No']);
        temp.splice(index, 1);
        this.selectedConsignments = [];

        this.$nextTick(() => (this.consignmentList = temp));
        return;
      }
      const checkAccountJSON = {
        checktype: 'DELETE CN',
        jobno: this.selectedJob[0]['Job No'],
        // 'cnno': data[],
        contno: '',
        chargescode: '',
        system: 'HMS',
        chkpayment: '0',
      };

      const CheckAccount = await this.$apiCallV2('/HaulageJob/CheckAccounts', checkAccountJSON);
      if (CheckAccount[0]['Results'] == 0) {
        if (CheckAccount[0]['ErrMsg'] == '') {
          this.deleteCNRemarks = '';
          this.deleteCNRemarksError = '';
          this.showDeleteCNPopup = true;
          // let toDelete = await this.$showAlert(
          //   'warning',
          //   'Deleting Containers',
          //   `Are you you want to delete ${this.selectedConsignments.length} consignment(s)?`,
          //   [
          //     { text: 'Delete', color: 'red', textColor: 'white' },
          //     { text: 'Cancel', color: 'lightgray', textColor: 'black' }
          //   ]);

          // if (toDelete == 'Delete') {
          //   let temp = JSON.parse(JSON.stringify(this.consignmentList));
          //   this.consignmentList = [];
          //   // this.selectedConsignments.forEach((c) => {
          //   //   this.consignmentToDelete.push(c);
          //   //   let index = temp.indexOf(c);
          //   //   temp.splice(index, 1);
          //   // });
          //   let index = temp.findIndex(t => JSON.stringify(t) == JSON.stringify(this.selectedConsignments[0]));
          //   temp.splice(index, 1);

          //   this.selectedConsignments = [];
          //   this.consignmentList = temp;
          //   // this.$nextTick(() => {
          //   //   this.consignmentList = temp;
          //   //   this.selectedConsignments = [];
          //   // });
          // }
        } else {
          this.$showAlert('error', 'Consignment Billed or Paid', CheckAccount[0]['ErrMsg']);
        }
      } else {
        this.$showAlert('error', 'Check Accounts', CheckAccount[0]['ErrMsg']);
      }

      // let toDelete = await this.$showAlert(
      //   'warning',
      //   'Deleting Containers',
      //   `Are you you want to delete ${this.selectedConsignments.length} consignment(s)?`,
      //   [
      //     { text: 'Delete', color: 'red', textColor: 'white' },
      //     { text: 'Cancel', color: 'lightgray', textColor: 'black' }
      //   ]);

      // if (toDelete == 'Delete') {
      //   let temp = this.consignmentList;
      //   this.consignmentList = [];
      //   this.selectedConsignments.forEach((c) => {
      //     this.consignmentToDelete.push(c);
      //     let index = temp.indexOf(c);
      //     temp.splice(index, 1);
      //   });

      //   this.$nextTick(() => {
      //     this.consignmentList = temp;
      //     this.selectedConsignments = [];
      //   });
      // }
    },
    redirectToJobCharges: function () {
      if (this.selectedJob.length == 0) {
        this.$showAlert('error', 'No Job Selected', 'Please select a record to view Job Charges');
      } else {
        const route = this.$router.resolve(
          `/Home/${this.$route.params['user']}/FINAR/Job%20Charges?jobNo=${this.selectedJob[0]['Job No'].trim()}`,
        );
        window.open(route.href, '_blank');
      }
    },
    sendToDetailsChanged: async function (e, key) {
      if (e) {
        const tempPU = this.selectedPickUp;
        const tempST = this.selectedSendTo;
        const tempDO = this.selectedDropOff;
        const temp = this.consignmentList;
        let changed = null;
        let isDifferent = false;
        this.consignmentList = [];

        let obj = null;
        switch (key) {
          case 'pickup':
            isDifferent = tempPU && tempPU !== e;
            break;
          case 'sendto':
            isDifferent = tempST && tempST !== e;
            break;
          case 'dropoff':
            isDifferent = tempDO && tempDO !== e;
            break;
        }

        if (isDifferent && temp.length > 0) {
          changed = await this.$showAlert(
            'warning',
            'Change Destination',
            `Are you sure you want to change ${key} destination (${e['Destination Code']}) of ${temp.length} consignments?`,
            [{ text: 'Change' }, { text: 'Cancel', color: 'lightgrey', textColor: 'black' }],
          );
        }

        switch (key) {
          case 'pickup':
            if (changed == 'Change') {
              obj = e;
            } else {
              this.selectedPickUp = tempPU;
              obj = tempPU;
            }
            break;
          case 'sendto':
            if (changed == 'Change') {
              obj = e;
            } else {
              this.selectedSendTo = tempST;
              obj = tempST;
            }

            temp.forEach((t) => {
              if (!t['Haulage Rate'] || t[`same${key}`]) {
                t['Haulage Rate'] = obj[`20' Rate`] ? obj[`20' Rate`].toFixed(2) : '0.00';
              }
              if (!t['Toll Rate'] || t[`same${key}`]) {
                t['Toll Rate'] = obj[`Toll`] ? obj[`Toll`].toFixed(2) : '0.00';
              }
            });
            break;
          case 'dropoff':
            if (changed == 'Change') {
              obj = e;
            } else {
              this.selectedDropOff = tempDO;
              obj = tempDO;
            }
            break;
        }
        temp.forEach((t) => {
          switch (key) {
            case 'pickup':
              if (!t['Pick Up'] || t[`same${key}`]) {
                t['Pick Up'] = this.getValueFromObject(obj, 'Destination Code');
              }
              break;
            case 'sendto':
              if (!t['Send To'] || t[`same${key}`]) {
                t['Send To'] = this.getValueFromObject(obj, 'Destination Code');
                t['Area'] = this.getValueFromObject(obj, 'Tariff Area');
              }
              break;
            case 'dropoff':
              if (!t['Drop Off'] || t[`same${key}`]) {
                t['Drop Off'] = this.getValueFromObject(obj, 'Destination Code');
              }
              break;
          }
        });
        this.$nextTick(() => (this.consignmentList = temp));
      }
    },
    diversionChanged: function (e) {
      this.consignmentList = this.consignmentList.map((t) => {
        if (t['samesendto']) {
          return { ...t, Diversion: e ? '1' : '0' };
        }
        return t;
      });
    },
    premisesisChanged: async function (e) {
      if (!e) {
        e = 'empty';
      }
      const tempPremise = this.selectedPremises;
      const temp = this.consignmentList;
      this.consignmentList = [];
      let changed = null;

      if (tempPremise != e && temp.length > 0) {
        changed = await this.$showAlert(
          'warning',
          'Change Premises Is',
          `Are you sure you want to change premises is of ${temp.length} consignments?`,
          [{ text: 'Change' }, { text: 'Cancel', color: 'lightgrey', textColor: 'black' }],
        );
      }
      let obj = null;
      if (changed == 'Change') {
        obj = e;
      } else {
        this.selectedPremises = tempPremise;
        obj = tempPremise;
      }
      temp.forEach((t) => {
        if (t['samesendto']) {
          t['Premises Is'] = this.getValueFromObject(obj, '#') ? this.getValueFromObject(obj, '#') : '0';
        }
      });
      this.$nextTick(() => (this.consignmentList = temp));
    },
    addContainerNumber: function () {
      const prom = new Promise((res) => {
        this.resolveContainerNo = res;
      });

      return prom;
    },

    contNoOrCount: function (type) {
      if (type == 'num' && !this.isContNo) {
        this.isContCount = true;
      } else if (type == 'num' && this.isContNo) {
        this.isContCount = false;
      } else if (type == 'count' && !this.isContCount) {
        this.isContNo = true;
      } else if (type == 'count' && this.isContCount) {
        this.isContNo = false;
      }

      if (!this.isContNo) {
        this.contNo = '';
      } else if (!this.isContCount) {
        this.contCount = '';
      }
    },
    clearConsignmentPopup: function () {
      this.cdaNo = '';
      this.contNo = '';
      this.isContNo = true;
      this.contNoError = '';
      this.contCount = '';
      this.isContCount = false;
      this.contCountError = '';
      this.sealNo = '';
      this.contOp = '';
      this.refNo = '';
      this.selectedSize = null;
      this.selectedType = null;
      this.selectedHandling = null;
      this.selectedDelivery = null;
      this.selectedTeam = null;
      this.statusButtons.forEach((s) => (s['checked'] = false));
      this.containerRemarks = '';
      this.temperature = '';
      this.measure = '';
      this.weight = '';
      this.height = '';
      this.commodity = '';
      this.requiredDateTimeChk = false;
      this.requiredTime = null;
      this.isOfficeHrsD = false;
      this.isOfficeHrsC = false;
      this.isb2b = false;
      this.isFumigation = false;
      this.isTimbang = false;
      this.selectedBillingFormat = null;
      this.haulageTariff = '';
      this.tollTariff = '';

      this.contOpError = '';
      this.sizeError = '';
      this.typeError = '';
      this.handlingError = '';
      this.deliveryError = '';
      this.statusError = '';
      this.weightError = '';
      this.commodityError = '';
      this.billingFormatError = '';

      this.samePickUp = true;
      this.sameSendTo = true;
      this.sameDropOff = true;

      this.selectedSendToCN = null;
      this.selectedPickUpCN = null;
      this.selectedDropOffCN = null;

      this.sendToAddressCN = '';
      this.pickUpAddressCN = '';
      this.dropOffAddressCN = '';

      this.sendToCNError = '';
      this.pickUpCNError = '';
      this.dropOffCNError = '';

      this.isDiversionCN = false;
      this.selectedPremisesCN = null;

      //#region Containter Number Popup
      this.contToAdd = '';
      this.contToAddError = '';
      this.contList = [];
      this.resolveContainerNo = null;
      this.addContainerError = '';
      //#endregion
    },

    getAddress: function (val, name) {
      let address = '';
      if (val) {
        address += `${val['Addr1'] ? val['Addr1'].trim() : ''}\n`;
        address += `${val['Addr2'] ? val['Addr2'].trim() : ''}\n`;
        address += `${val['Addr3'] ? val['Addr3'].trim() : ''}\n`;
        address += `${val['Addr4'] ? val['Addr4'].trim() : ''}\n`;
        address += `${val['PostCode'] ? val['PostCode'].trim() : ''}, ${val['City'] ? val['City'].trim() : ''}\n`;
        address += `${val['State'] ? val['State'].trim() : ''}, ${val['Country'] ? val['Country'].trim() : ''}`;
      }

      this[name] = address;
    },
    //#endregion

    //#region Voyage Info functions

    //#endregion

    //#region Documents functions
    addDoc: function () {
      this.docStatusPopup = true;
    },
    editDoc: function () {
      if (this.selectedDocuments.length == 0) {
        this.$showAlert('error', 'No document selected', 'Please select at least one document to edit');
      } else {
        const uniqueID = [...new Set(this.selectedDocuments.map((s) => s['ID']))];
        if (uniqueID.length > 1) {
          this.$showAlert('error', 'Multiple Document Selected', 'Please select at most one unique document to edit');
        } else {
          this.editDocumentsList = this.documentsData.filter((d) => d['ID'] == uniqueID[0]);
          this.docStatusPopup = true;
        }
      }
    },
    deleteDoc: async function () {
      const deleteAll = [];
      const uniqueSelected = [
        ...new Set(
          this.selectedDocuments.map((s) => {
            return s['ID'];
          }),
        ),
      ];

      if (uniqueSelected.length == 0) {
        this.$showAlert('error', 'No document selected', 'Please select at least one document to delete');
        return;
      }

      uniqueSelected.forEach((u) => {
        const selectedCount = this.selectedDocuments.filter((s) => {
          return s['ID'] == u;
        });
        const allCount = this.documentsData.filter((s) => {
          return s['ID'] == u;
        });

        const deleteData = {
          docCode: selectedCount[0]['Doc Code'],
          refNo: selectedCount[0]['Doc Ref #'],
          allItems: allCount,
          selectedItems: selectedCount,
          allSelected: selectedCount.length == allCount.length,
        };
        deleteAll.push(deleteData);
      });

      if (deleteAll.length > 0) {
        for (const d of deleteAll) {
          this.deleteItems = d;

          const selectedNames = d['selectedItems']
            .map((s) => {
              return s['Attachment'];
            })
            .join(`<br />`);
          const deleteResult = await this.$showAlert(
            'warning',
            'Deleting Doc Code',
            `You are about to delete ${d['selectedItems'].length} of ${d['allItems'].length} documents for<br />Doc Code ${d['docCode']}<br />(Doc Ref #: ${d['refNo']})<br /><br />Selected Files:<br />${selectedNames}`,
            [
              {
                text: `Delete ${d['selectedItems'].length} of ${d['allItems'].length} Documents for<br />Doc Code ${d['docCode']}<br />(Doc Ref #: ${d['refNo']})`,
                textColor: 'white',
                color: 'rgb(255, 167, 58)',
              },
              {
                text: `Delete All Documents for<br />Doc Code ${d['docCode']}<br />(Doc Ref #: ${d['refNo']})`,
                textColor: 'white',
                color: 'red',
              },
              { text: 'Cancel', textColor: 'white', color: '#aaa' },
            ],
          );

          if (deleteResult == 'Cancel') {
            return;
          } else if (deleteResult.includes('Delete All')) {
            this.deleteItems['allItems'].forEach((d) => {
              const index = this.documentsData.findIndex((dd) => JSON.stringify(dd) == JSON.stringify(d));

              if (d['documentguid']) {
                // To send to API for delete
                d['Action'] = 'D';
                this.documentsToDelete.push(d);
              }

              this.documentsData.splice(index, 1);
            });
          } else {
            this.deleteItems['selectedItems'].forEach((d) => {
              const index = this.documentsData.findIndex((dd) => JSON.stringify(dd) == JSON.stringify(d));

              if (d['documentguid']) {
                // To send to API for delete
                d['Action'] = 'D';
                this.documentsToDelete.push(d);
              }

              this.documentsData.splice(index, 1);
            });
          }

          const temp = this.documentsData;
          this.documentsData = [];
          this.$nextTick(() => (this.documentsData = temp));

          this.selectedDocuments = [];
        }
      }
    },
    documentUpdateROT: function (e) {
      const details = e['details'];
      const hasStatus = details['statuses'];

      if (hasStatus == 'N/A') {
        // Doc without status

        const fixedData = {
          'Doc Code': details['docCode'],
          'Doc Ref #': details['docRef'],
          Attachment: details['docRef'],
          Remarks: details['remarks'],
          Status: 'N/A',
          'Start Date': 'N/A',
          'Received Date': 'N/A',
          'Due Date': 'N/A',
          'Assign To': 'N/A',
          Sets: 'N/A',
          Page: 'N/A',

          documentguid: '',
          statusseqno: '',
          ID: `${details['docCode']}-${details['docRef']}`,
          fileAtt: details['fileAtt'],
          filetype: details['filetype'],
          Action: 'N',
        };
        this.documentsData = this.documentsData.concat(fixedData);
      }
      this.selectedDocuments = [];
    },
    documentUpdate: async function (e) {
      const editDetails = this.editDocumentsList;
      const details = e['details'];
      const hasStatus = details['statuses'];

      const allData = [];

      if (hasStatus == 'N/A') {
        // Doc without status
        const att = Array.from(details['attachment']);

        if (editDetails.length > 0) {
          // For edit
          if (details['docRef'] != editDetails[0]['Doc Ref #']) {
            // Changes in docref#
            editDetails.forEach((ed) => {
              const index = this.documentsData.findIndex((d) => JSON.stringify(d) == JSON.stringify(ed));
              ed['Action'] = ed['Action'] == 'N' ? ed['Action'] : 'E';
              ed['Doc Ref #'] = details['docRef'];
              ed['ID'] = `${details['docCode']}-${details['docRef']}`;

              this.documentsData.splice(index, 1, ed);
            });
          }
        }

        const fixedData = {
          'Doc Code': details['docCode'],
          'Doc Ref #': details['docRef'],
          Attachment: '',
          Remarks: '',
          Status: 'N/A',
          'Start Date': 'N/A',
          'Received Date': 'N/A',
          'Due Date': 'N/A',
          'Assign To': 'N/A',
          Sets: 'N/A',
          Page: 'N/A',

          documentguid: '',
          statusseqno: '',
          ID: `${details['docCode']}-${details['docRef']}`,
          fileAtt: '',
          filetype: '',
          Action: 'N',
        };

        if (att.length > 0) {
          // if has attachment
          for (const a of att) {
            const attBase64 = await a.toBase64(true);
            allData.push({
              'Doc Code': details['docCode'],
              'Doc Ref #': details['docRef'],
              Attachment: a.name,
              Remarks: '',
              Status: 'N/A',
              'Start Date': 'N/A',
              'Received Date': 'N/A',
              'Due Date': 'N/A',
              'Assign To': 'N/A',
              Sets: 'N/A',
              Page: 'N/A',

              documentguid: '',
              statusseqno: '',
              ID: `${details['docCode']}-${details['docRef']}`,
              fileAtt: attBase64,
              filetype: a.type,
              Action: 'N',
            });
          }
        } else if (editDetails.length == 0 && details) {
          // without attachment and not edit
          allData.push(fixedData);
        }

        const temp = this.documentsData;
        this.documentsData = [];
        this.$nextTick(() => (this.documentsData = temp.concat(allData)));
      } else {
        // Doc with status
        const statusChecked = hasStatus.filter((s) => s['checked']);
        for (const s of statusChecked) {
          allData.push({
            'Doc Code': details['docCode'],
            'Doc Ref #': details['docRef'],
            Attachment: s['attachment'] ? s['attachment'][0].name : '',
            Remarks: s['remarks'],
            Status: s['docStatus'],
            'Start Date': s['start'] ? s['start'].formatString('yyyy-MM-dd HH:mm') : '',
            'Received Date': s['received'] ? s['received'].formatString('yyyy-MM-dd HH:mm') : '',
            'Due Date': s['due'] ? s['due'].formatString('yyyy-MM-dd HH:mm') : '',
            'Assign To': s['assignTo'],
            Sets: s['sets'],
            Page: s['page'],

            documentguid: '',
            statusseqno: '',
            ID: `${details['docCode']}-${details['docRef']}`,
            fileAtt: s['attachment'] ? await s['attachment'][0].toBase64(true) : '',
            filetype: s['attachment'] ? s['attachment'][0].type : '',
            Action: 'N',
          });
        }

        if (editDetails.length == 0) {
          // For new
          const temp = this.documentsData;
          this.documentsData = [];

          //if no status check then add a blank record to allData.
          if (allData.length == 0) {
            const fixedData = {
              'Doc Code': details['docCode'],
              'Doc Ref #': details['docRef'],
              Attachment: '',
              Remarks: '',
              Status: '',
              'Start Date': '',
              'Received Date': '',
              'Due Date': '',
              'Assign To': '',
              Sets: '',
              Page: '0',

              documentguid: '',
              statusseqno: '',
              ID: `${details['docCode']}-${details['docRef']}`,
              fileAtt: '',
              filetype: '',
              Action: 'N',
            };
            allData.push(fixedData);
          }

          this.$nextTick(() => (this.documentsData = temp.concat(allData)));
        } else {
          // For edit
          //find if there is any records that have empty status. If yes then add that record into allData
          const emptyStatus = editDetails.find((f) => f['Status'] === '');
          if (emptyStatus) {
            const fixedData = {
              'Doc Code': emptyStatus['docCode'],
              'Doc Ref #': emptyStatus['docRef'],
              Attachment: '',
              Remarks: '',
              Status: '',
              'Start Date': '',
              'Received Date': '',
              'Due Date': '',
              'Assign To': '',
              Sets: '',
              Page: '0',

              documentguid: '',
              statusseqno: '',
              ID: `${emptyStatus['docCode']}-${emptyStatus['docRef']}`,
              fileAtt: '',
              filetype: '',
              Action: 'N',
            };
            allData.push(fixedData);
          }

          const oldStatus = editDetails.map((ed) => ed['Status']);
          const newStatus = allData.map((ad) => ad['Status']);

          const toDelete = oldStatus.filter((o) => !newStatus.includes(o));
          const toAdd = newStatus.filter((n) => !oldStatus.includes(n));
          const toCheck = newStatus.filter((n) => oldStatus.includes(n));

          toDelete.forEach((d) => {
            const deleting = editDetails.find((ed) => ed['Status'] == d);
            const index = this.documentsData.findIndex((d) => JSON.stringify(d) == JSON.stringify(deleting));

            this.documentsData.splice(index, 1);
            deleting['Action'] = 'D';
            this.documentsToDelete.push(deleting);
          });
          toAdd.forEach((a) => {
            const adding = allData.find((ad) => ad['Status'] == a);
            this.documentsData.push(adding);
          });
          toCheck.forEach((c) => {
            const oldData = editDetails.find((ed) => ed['Status'] == c);
            const newData = allData.find((ed) => ed['Status'] == c);
            const index = this.documentsData.findIndex((d) => JSON.stringify(d) == JSON.stringify(oldData));

            Object.keys(oldData).forEach((k) => {
              if (oldData[k] == null) {
                oldData[k] = '';
              }
            });

            if (oldData['Sets'] == 0) {
              oldData['Sets'] = '';
            }
            if (oldData['Page'] == 0) {
              oldData['Page'] = '';
            }

            let hasChanges = false;

            if (newData['Attachment']) {
              hasChanges = true;
            }

            if (
              newData['Start Date'] != oldData['Start Date'] ||
              newData['Received Date'] != oldData['Received Date'] ||
              newData['Due Date'] != oldData['Due Date'] ||
              newData['Remarks'] != oldData['Remarks'] ||
              newData['Assign To'] != oldData['Assign To'] ||
              newData['Sets'] != oldData['Sets'] ||
              newData['Page'] != oldData['Page']
            ) {
              oldData['Start Date'] = newData['Start Date'];
              oldData['Received Date'] = newData['Received Date'];
              oldData['Due Date'] = newData['Due Date'];
              oldData['Remarks'] = newData['Remarks'];
              oldData['Assign To'] = newData['Assign To'];
              oldData['Sets'] = newData['Sets'];
              oldData['Page'] = newData['Page'];

              hasChanges = true;
            }

            if (hasChanges) {
              oldData['Action'] = oldData['Action'] == 'N' ? oldData['Action'] : 'E';
              this.documentsData.splice(index, 1, oldData);
            }

            if (details['docRef'] != editDetails[0]['Doc Ref #']) {
              // Changes in docref#
              editDetails.forEach((ed) => {
                const index = this.documentsData.findIndex((d) => JSON.stringify(d) == JSON.stringify(ed));
                ed['Action'] = ed['Action'] == 'N' ? ed['Action'] : 'E';
                ed['Doc Ref #'] = details['docRef'];
                ed['ID'] = `${details['docCode']}-${details['docRef']}`;

                this.documentsData.splice(index, 1, ed);
              });
            }

            oldData['Attachment'] = newData['Attachment'];
            oldData['fileAtt'] = newData['fileAtt'];
            oldData['filetype'] = newData['filetype'];
          });

          const temp = this.documentsData;
          this.documentsData = [];
          this.$nextTick(() => (this.documentsData = temp));
        }
      }

      this.selectedDocuments = [];
    },
    //#endregion

    //#region Container No Popup
    addContainerNo: function () {
      if (this.contToAdd) {
        this.contList.push(this.contToAdd);
        this.contToAdd = '';
        this.addContainerError = '';
        this.$refs['contnoinput'].setFocus();
      } else {
        this.contToAddError = 'Please enter your container number';
      }
    },
    deleteContainerNumber: function (index) {
      this.contList.splice(index, 1);
    },
    containerNoButtonClicked: function (e) {
      const count = parseInt(this.contCount);
      if (e == 'Confirm Containers') {
        if (this.contList.length != count) {
          //this.addContainerError = `You need to add ${count} container numbers, but only ${this.contList.length} container numbers are added.`;
          this.containerNoEmptyPopup(e);
        } else {
          this.showContNoPopup = false;
          this.resolveContainerNo(e);
        }
      } else {
        this.showContNoPopup = false;
        this.resolveContainerNo(e);
      }
    },
    containerNoEmptyPopup: function (e) {
      // prompt warning if empty container number
      const count = parseInt(this.contCount);
      const countDiff = count - this.contList.length;
      let alertEmptyContainerNo = 'This is an Import job.<br>';
      alertEmptyContainerNo += `There are ${countDiff} consignments with empty container number. Do you wish to proceed?`;
      this.$showAlert('warning', 'Empty Container Number(s)', alertEmptyContainerNo, [
        { text: 'Yes' },
        { text: 'No', color: 'lightgray' },
      ]).then((addEmptyContainerNoError) => {
        if (addEmptyContainerNoError == 'Yes') {
          this.showContNoPopup = false;
          this.resolveContainerNo(e);
        }
      });
    },
    //#endregion

    //#region Job Type Popup
    jobTypeButtonClicked: function (e) {
      if (e == 'Confirm Job Type') {
        if (!this.selectedJobType) {
          this.jobTypeError = 'Please select your Job Type';
        } else {
          if (this.cnEditIndex > -1) {
            this.populateCNEditDetails(this.consignmentList[this.cnEditIndex]);
          }
          this.showJobTypePopup = false;
          // this.openConsignmentPopup = true;
          this.addConsignmentPopup(); //call this function to get default value as well
        }
      } else {
        this.selectedJobType = null;
        this.showJobTypePopup = false;
      }
    },
    jobTypePopupDropdownFocus: function (e) {
      this.isJobTypeDropdownFocus = e;
    },
    //#endregion

    //#region Get Data from API
    getJobInfoData: function () {
      const jobInfoDataPromises = [];
      // this.shipperItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'customer' })));
      jobInfoDataPromises.push(this.getShipperListing());

      // this.billToItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'billcust' })));
      jobInfoDataPromises.push(this.getBillToListing());

      // let trip = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'trip_rot' })));
      // this.tripItems = trip.map(t => {
      //   t['showValue'] = `${t['Trip']} (${t['Description']})`;
      //   return t;
      // });
      jobInfoDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'trip_rot' }).then((result) => {
          const trip = this.$deepTrimJsonV3(result);
          this.tripItems = trip.map((t) => {
            t['showValue'] = `${t['Trip']} (${t['Description']})`;
            return t;
          });
        }),
      );

      // this.chequeItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'paymenttype' })));
      // this.chequeItems.forEach(c => c['code-desc'] = `${c['Payment Type']} - ${c['Description']}`);
      jobInfoDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'paymenttype' }).then((result) => {
          const cheque = this.$deepTrimJsonV3(result);
          this.chequeItems = cheque.map((c) => {
            c['code-desc'] = `${c['Payment Type']} - ${c['Description']}`;
            return c;
          });
        }),
      );

      return jobInfoDataPromises;
    },
    getSendToData: function () {
      const sendToDataPromises = [];
      // this.pickUpItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'pickup_hms' })));
      sendToDataPromises.push(this.getPickUpListing());

      // this.premisesItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'premises' })));
      sendToDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'premises' }).then((result) => {
          this.premisesItems = this.$deepTrimJsonV3(result);
        }),
      );

      // this.sendToItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SENDTO_ALL' })));
      sendToDataPromises.push(this.getSendToListing());

      // this.dropOffItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'dropoff_hms' })));
      sendToDataPromises.push(this.getDropOffListing());

      return sendToDataPromises;
    },
    getContainerData: function () {
      const containerDataPromises = [];
      // this.sizeItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'contsize' })));
      containerDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'contsize' }).then((result) => {
          this.sizeItems = this.$deepTrimJsonV3(result);
        }),
      );

      // this.typeItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'conttype' })));
      containerDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'conttype' }).then((result) => {
          const trimmedResult = this.$deepTrimJsonV3(result);
          this.typeItems = trimmedResult.map((item) => {
            return {
              ...item,
              'Cont Type - Description': `${item['Cont Type']} - ${item['Description']}`,
            };
          });
        }),
      );

      // this.handlingItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTHANDLINGTYPE' })));
      containerDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTHANDLINGTYPE' }).then((result) => {
          const trimmedResult = this.$deepTrimJsonV3(result);
          this.handlingItems = trimmedResult.map((item) => {
            return {
              ...item,
              'Handling Type - Description': `${item['Handling Type']} - ${item['Description']}`,
            };
          });
        }),
      );

      // this.deliveryItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTDELIVERYTYPE' })));
      containerDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTDELIVERYTYPE' }).then((result) => {
          const trimmedResult = this.$deepTrimJsonV3(result);
          this.deliveryItems = trimmedResult.map((item) => {
            return {
              ...item,
              'Delivery Type - Description': `${item['Delivery Type']} - ${item['Description']}`,
            };
          });
        }),
      );

      // this.teamItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'team' })));
      containerDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'team' }).then((result) => {
          this.teamItems = this.$deepTrimJsonV3(result);
        }),
      );

      // this.billingFormatItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'BILLINGFORMAT' })));
      containerDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'BILLINGFORMAT', module: 'HMS' }).then((result) => {
          this.billingFormatItems = this.$deepTrimJsonV3(result);
        }),
      );

      return containerDataPromises;
    },
    getVoyageInfoData: function () {
      const voyageInfoDataPromises = [];
      // this.shipCallNoItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'shipcallno' })));
      voyageInfoDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'shipcallno' }).then((result) => {
          this.shipCallNoItems = this.$deepTrimJsonV3(result);
        }),
      );

      // this.vesselCodeItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'vesselid' })));
      voyageInfoDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'vesselid' }).then((result) => {
          const trimmedResult = this.$deepTrimJsonV3(result);
          this.vesselCodeItems = trimmedResult.map((item) => {
            return {
              ...item,
              Description: `${item['Vessel ID']} - ${item['Vessel Name']}`,
            };
          });
        }),
      );

      // let port = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'port' })));
      // this.transhipPortItems = port;
      // this.dischargeItems = port;
      voyageInfoDataPromises.push(this.getTranshipPortListing());

      // this.shippingAgentItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'shippingagent' })));
      voyageInfoDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'shippingagent' }).then((result) => {
          const trimmedResult = this.$deepTrimJsonV3(result);
          this.shippingAgentItems = trimmedResult.map((item) => {
            return {
              ...item,
              Description: `${item['Agent Code']} - ${item['Agent Name']}`,
            };
          });
        }),
      );

      // this.fwdgAgentItems = this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'FORWARDINGAGENT' })));
      voyageInfoDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'FORWARDINGAGENT' }).then((result) => {
          const trimmedResult = this.$deepTrimJsonV3(result);
          this.fwdgAgentItems = trimmedResult.map((item) => {
            return {
              ...item,
              Description: `${item['FA Code']} - ${item['FA Name']}`,
            };
          });
        }),
      );

      return voyageInfoDataPromises;
    },
    //#endregion

    //#region InputQuery Refresh Clicked Handlers
    shipperInputQueryRefreshClicked: async function (placeholder) {
      this.shipperItems = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      await this.getShipperListing();
      this.$fullscreenLoading();
      // <InputQuery :placeholder="shipperCaption" :items.sync="shipperItems" itemKey="Customer Code" descKey="Customer Name" :selectedObject.sync="selectedShipper"
      //               :isRequired="true" :errorMessage.sync="shipperError" ref="shipper" :isDisabled="viewMode || editJobBilledDisabled"
      //               addLink="/Home/MasterFiles/ProfileMaster/ShipperConsignee?new=1" :refreshData="{ masterfile: 'shipper' }" />

      // <InputQuery :placeholder="shipperCaption" :items.sync="shipperItems" itemKey="Customer Code" descKey="Customer Name" :selectedObject.sync="selectedShipper"
      //               :isRequired="true" :isDisabled="viewMode || editJobBilledDisabled" addLink="/Home/MasterFiles/ProfileMaster/ShipperConsignee?new=1" :refreshData="{ masterfile: 'shipper' }" />
    },
    billToInputQueryRefreshClicked: async function (placeholder) {
      this.billToItems = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      await this.getBillToListing();
      this.$fullscreenLoading();
      // <InputQuery placeholder="Bill To" :items.sync="billToItems" itemKey="Customer Code" descKey="Customer Name" :selectedObject.sync="selectedBillTo"
      //                 :isRequired="true" :errorMessage.sync="billToError" @selected="billToSelected" ref="billto" :isDisabled="viewMode || editJobBilledDisabled"
      //                 addLink="/Home/MasterFiles/ProfileMaster/Customer?new=1" :refreshData="{ masterfile: 'billcust' }" />

      // <InputQuery placeholder="Bill To" :items.sync="billToItems" itemKey="Customer Code" descKey="Customer Name" :selectedObject.sync="selectedBillTo"
      //               :isRequired="true" @selected="billToSelected" :isDisabled="viewMode || editJobBilledDisabled"
      //               addLink="/Home/MasterFiles/ProfileMaster/Customer?new=1" :refreshData="{ masterfile: 'billcust' }" />
    },
    pickUpInputQueryRefreshClicked: async function (placeholder) {
      this.pickUpItems = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      await this.getPickUpListing();
      this.$fullscreenLoading();
      // <InputQuery placeholder="Pick Up" :items.sync="pickUpItems" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedPickUp"
      //                 :isRequired="true" :errorMessage.sync="pickUpError" ref="sendto" @selected="sendToDetailsChanged($event, 'pickup')"
      //                 :isDisabled="viewMode" addLink="/Home/MasterFiles/OperationMaster/Destination?new=1" :refreshData="{ masterfile: 'pickup_hms' }" />

      // <InputQuery placeholder="Pick Up" :items.sync="pickUpItems" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedPickUp"
      //                 :isRequired="true" @selected="sendToDetailsChanged($event, 'pickup')" :isDisabled="viewMode"
      //                 addLink="/Home/MasterFiles/OperationMaster/Destination?new=1" :refreshData="{ masterfile: 'pickup_hms' }" />
    },
    sendToInputQueryRefreshClicked: async function (placeholder) {
      this.sendToItems = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      await this.getSendToListing();
      this.$fullscreenLoading();
      // <InputQuery placeholder="Send To" :items.sync="sendToItems" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedSendTo"
      //                 :isRequired="true" :errorMessage.sync="sendToError" ref="pickup" @selected="sendToDetailsChanged($event, 'sendto')"
      //                 :isDisabled="viewMode || editJobBilledDisabled" addLink="/Home/MasterFiles/OperationMaster/Destination?new=1" :refreshData="{ masterfile: 'SENDTO_ALL' }" />

      // <InputQuery placeholder="Send To" :items.sync="sendToItems" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedSendTo"
      //                 :isRequired="true" @selected="sendToDetailsChanged($event, 'sendto')" :isDisabled="viewMode || editJobBilledDisabled"
      //                 addLink="/Home/MasterFiles/OperationMaster/Destination?new=1" :refreshData="{ masterfile: 'SENDTO_ALL' }" />
    },
    dropOffInputQueryRefreshClicked: async function (placeholder) {
      this.dropOffItems = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      await this.getDropOffListing();
      this.$fullscreenLoading();
      // <InputQuery placeholder="Drop Off" :items.sync="dropOffItems" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedDropOff"
      //                 :isRequired="true" :errorMessage.sync="dropOffError" ref="dropoff" @selected="sendToDetailsChanged($event, 'dropoff')"
      //                 :isDisabled="viewMode" addLink="/Home/MasterFiles/OperationMaster/Destination?new=1" :refreshData="{ masterfile: 'dropoff_hms' }" />

      // <InputQuery placeholder="Drop Off" :items.sync="dropOffItems" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedDropOff"
      //                 :isRequired="true" @selected="sendToDetailsChanged($event, 'dropoff')" :isDisabled="viewMode"
      //                 addLink="/Home/MasterFiles/OperationMaster/Destination?new=1" :refreshData="{ masterfile: 'dropoff_hms' }" />
    },
    transhipPortInputQueryRefreshClicked: async function (placeholder) {
      this.transhipPortItems = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      await this.getTranshipPortListing();
      this.$fullscreenLoading();
      // <InputQuery placeholder="Tranship Port" :items.sync="transhipPortItems" itemKey="Port Code" descKey="Port Location"
      //             :selectedObject.sync="selectedTranshipPort" :isDisabled="viewMode"
      //             addLink="/Home/MasterFiles/ProfileMaster/Port?new=1" :refreshData="{ masterfile: 'port' }" />
    },
    dischargeInputQueryRefreshClicked: async function (placeholder) {
      this.dischargeItems = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      await this.getTranshipPortListing();
      this.$fullscreenLoading();
      // <InputQuery placeholder="Load/Discharge Port" :items.sync="dischargeItems" itemKey="Port Code" descKey="Port Location"
      //             :selectedObject.sync="selectedDischargePort" :isDisabled="viewMode"
      //             addLink="/Home/MasterFiles/ProfileMaster/Port?new=1" :refreshData="{ masterfile: 'port' }" />
    },
    //#endregion

    //#region API call add description
    getShipperListing: async function () {
      await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'customer' }).then((result) => {
        const trimmedResult = this.$deepTrimJsonV3(result);
        this.shipperItems = trimmedResult.map((item) => {
          return {
            ...item,
            Description: `${item['Customer Code']} - ${item['Customer Name']}`,
          };
        });
      });
    },
    getBillToListing: async function () {
      await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'billcust' }).then((result) => {
        const trimmedResult = this.$deepTrimJsonV3(result);
        this.billToItems = trimmedResult.map((item) => {
          return {
            ...item,
            Description: `${item['Customer Code']} - ${item['Customer Name']}`,
          };
        });
      });
    },
    getPickUpListing: async function () {
      await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'pickup_hms' }).then((result) => {
        const trimmedResult = this.$deepTrimJsonV3(result);
        this.pickUpItems = trimmedResult.map((item) => {
          return {
            ...item,
            Description: `${item['Destination Code']} - ${item['Company']}`,
          };
        });
      });
    },
    getSendToListing: async function () {
      await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SENDTO_ALL' }).then((result) => {
        const trimmedResult = this.$deepTrimJsonV3(result);
        this.sendToItems = trimmedResult.map((item) => {
          return {
            ...item,
            Description: `${item['Destination Code']} - ${item['Company']}`,
          };
        });
      });
    },
    getDropOffListing: async function () {
      await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'dropoff_hms' }).then((result) => {
        const trimmedResult = this.$deepTrimJsonV3(result);
        this.dropOffItems = trimmedResult.map((item) => {
          return {
            ...item,
            Description: `${item['Destination Code']} - ${item['Company']}`,
          };
        });
      });
    },
    getTranshipPortListing: async function () {
      await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'port' }).then((result) => {
        const port = this.$deepTrimJsonV3(result);
        const portList = port.map((item) => {
          return {
            ...item,
            Description: `${item['Port Code']} - ${item['Port Location']}`,
          };
        });
        this.transhipPortItems = portList;
        this.dischargeItems = portList;
      });
    },
    //#endregion

    //#region Edit Popup
    editPopupButtonClicked: async function (e) {
      switch (e) {
        case 'Yes':
          if (!this.editRemarks) {
            this.editRemarksError = 'Please enter your remarks to edit';
          } else {
            const updateStatusJSON = {
              finish: '1',
              jobno: this.selectedJob[0]['Job No'],
              status: '8018', //ST_EDIT_JOB
              remarks: this.editRemarks,
            };

            const updateStatusResult = await this.$apiCallV2('/DocStatusUpdate/UpdateStatusTask', updateStatusJSON);
            if (updateStatusResult[0]['Results'] == 0) {
              this.showEditPopup = false;
              this.editFields(this.editStatus, 'JOB');
              await this.getJobDetails('Edit Job', this.selectedJob[0]['Job No']);
            } else {
              this.$showAlert('error', 'Update Status', updateStatusResult[0]['ErrMsg']);
            }
          }
          break;
        case 'No':
          this.editRemarks = '';
          this.editRemarksError = '';
          this.editStatus = '';
          this.showEditPopup = false;
          break;
      }
    },

    editCNPopupButtonClicked: async function (e) {
      switch (e) {
        case 'Yes':
          if (!this.editCNRemarks) {
            this.editCNRemarksError = 'Please enter your remarks to edit';
          } else {
            const updateStatusJSON = {
              finish: '1',
              jobno: this.selectedJob[0]['Job No'],
              cn: this.editCNData['Consignment No'],
              container: this.editCNData['Cont No'],
              status: '8017', //ST_EDIT_CN
              remarks: this.editCNRemarks,
            };

            const updateStatusResult = await this.$apiCallV2('/DocStatusUpdate/UpdateStatusTask', updateStatusJSON);
            if (updateStatusResult[0]['Results'] == 0) {
              this.showEditCNPopup = false;
              this.editFields(this.editCNStatus, 'CN');
              this.populateCNEditDetails(this.editCNData);
              this.openConsignmentPopup = true;
            } else {
              this.$showAlert('error', 'Update Status', updateStatusResult[0]['ErrMsg']);
            }
          }
          break;
        case 'No':
          this.editCNRemarks = '';
          this.editCNRemarksError = '';
          this.editCNStatus = '';
          this.showEditCNPopup = false;
          break;
      }
    },

    editFields: function (editStatus, type) {
      if (type.trim() == 'CN') {
        this.editCNDisabled = true;
        if (editStatus.trim() == 'BILLED') {
          this.editCNBilledDisabled = true;
        } else if (editStatus.trim() == 'PAID') {
          this.editCNPaidDisabled = true;
        }
      } else if (type.trim() == 'JOB') {
        this.editJobDisabled = true;
        if (editStatus.trim() == 'BILLED') {
          this.editJobBilledDisabled = true;
          this.keepCharges = true;
        } else if (editStatus.trim() == 'PAID') {
          this.editJobPaidDisabled = true;
          this.keepCharges = true;
        }
      }
    },
    //#endregion

    //#region Delete Popup
    deletePopupButtonClicked: async function (e) {
      switch (e) {
        case 'Delete':
          if (!this.deleteRemarks) {
            this.deleteRemarksError = 'Please enter your remarks to delete';
          } else if (this.deleteRemarks.trim() === '') {
            this.deleteRemarksError = 'Remark is required!';
          } else {
            this.showDeletePopup = false;

            this.$fullscreenLoading('Deleting Job');
            const deleteResult = await this.$apiCallV2('/HaulageJob/SaveHMSJob', {
              jobno: this.selectedJob[0]['Job No'],
              system: 'HMS',
              action: 'D',
              contdel: this.selectedJob[0]['Job Assigned'] > 0 ? 'D' : '',
              deleteremarks: this.deleteRemarks,
            });
            this.$fullscreenLoading();

            this.deleteRemarksError = '';
            this.deleteRemarks = '';

            if (deleteResult[0]['Results'] == 0) {
              this.refreshClicked();

              await this.$showAlert(
                'success',
                'Job Deleted',
                `Job # ${this.selectedJob[0]['Job No']} has been successfully deleted.`,
              );

              this.selectedJob = [];
            } else {
              await this.$showAlert(
                'error',
                'Job Not Deleted',
                `Job # ${this.selectedJob[0]['Job No']} is not deleted.<br>Error: ${deleteResult[0]['ErrMsg']}`,
              );
            }
          }
          break;
        case 'Cancel':
          this.deleteRemarks = '';
          this.deleteRemarksError = '';

          this.showDeletePopup = false;
          break;
      }
    },

    deleteCNPopupButtonClicked: async function (e) {
      switch (e) {
        case 'Delete':
          if (!this.deleteCNRemarks) {
            this.deleteCNRemarksError = 'Please enter your remarks to delete';
          } else if (this.deleteCNRemarks.trim() === '') {
            this.deleteCNRemarksError = 'Remark is required!';
          } else {
            const temp = JSON.parse(JSON.stringify(this.consignmentList));
            this.consignmentList = [];
            await this.$nextTick();
            const index = temp.findIndex((t) => JSON.stringify(t) == JSON.stringify(this.selectedConsignments[0]));
            // let temp2 = JSON.parse(JSON.stringify(temp[index]));
            this.selectedConsignments[0]['cnaction'] = 'D';
            this.selectedConsignments[0]['condeleteassign'] = 'D';
            this.selectedConsignments[0]['condelete'] = 'D';
            this.selectedConsignments[0]['consignmentdeletereason'] = this.deleteCNRemarks ?? '';
            this.selectedConsignments[0]['CN State'] = 'Cancel';
            this.selectedConsignments[0]['isDeleted'] = 'deleted'; // add hidden value to indicate this record is deleted
            temp.splice(index, 1, this.selectedConsignments[0]);
            // temp.splice(index, 1, {
            //   'cnstate': '',
            //   'thirdparty': '',
            //   'printed': '',
            //   'billed': '',
            //   'assigned': '',
            //   'consignmentno': temp2['consignmentno'] ?? '',
            //   'seqno': '',
            //   'diversion': '',
            //   'premisesis': '',
            //   'cncontsize': '',
            //   'cnconttype': '',
            //   'cndeliverytype': '',
            //   'cnhandlingtype': '',
            //   'b2bcont': '',
            //   'timbang': '',
            //   'billingfmt': '',
            //   'containerno': temp2['containerno'] ?? '',
            //   'operatorcode': '',
            //   'sealno': '',
            //   'pickupref': '',
            //   'contheight': '',
            //   'contweight': '',
            //   'contmeasure': '',
            //   'cnstatus': '',
            //   'commodity': '',
            //   'requireddate': '',
            //   'requiredtime': '',
            //   'requireddatetimedesc': '',
            //   'cnremarks': '',
            //   'fumigation': '',
            //   'officehrsd': '',
            //   'officehrsc': '',
            //   'temperature': '',
            //   'team': '',
            //   'cnaction': 'D',
            //   'haulagerate': '',
            //   'tollrate': '',
            //   'cnsendto': '',
            //   'cnarea': '',
            //   'cnpickup': '',
            //   'cndropoff': '',
            //   'samesendto': '',
            //   'samepickup': '',
            //   'samedropoff': '',
            //   'condeleteassign':'D',
            //   'condelete':'D',
            //   'consignmentdeletereason': this.deleteCNRemarks ?? ''
            // });
            this.selectedConsignments = [];
            this.consignmentList = JSON.parse(JSON.stringify(temp));
            this.showDeleteCNPopup = false;
          }
          break;
        case 'Cancel':
          this.deleteCNRemarks = '';
          this.deleteCNRemarksError = '';
          this.showDeleteCNPopup = false;
          break;
      }
    },
    //#endregion

    //#region eROT methods
    rotCheckboxClicked: function (name) {
      this.allROTChecked = false;
      this.rangeROTChecked = false;
      this.selectionError = '';

      this.$nextTick(() => (this[name] = true));
    },
    rangeSelected: async function (item) {
      this.filter1 = null;
      this.filter2 = null;

      if (item['Type'] == 'Date') {
        this.isDateTime = true;
      } else {
        this.isDateTime = false;

        this.$fullscreenLoading('Getting Ranges');
        const rangeListing = this.$deepTrimJsonV3(
          await this.$apiCallV2(`/HaulageEROT/GeteJobListing`, {
            filter: item['SendKey'],
            getfilterdropdowndata: '0',
          }),
        );
        this.rangeSelectionListAsc = JSON.parse(JSON.stringify(rangeListing));
        this.rangeSelectionListDesc = JSON.parse(JSON.stringify(rangeListing)).sort((a, b) =>
          b['Item'].localeCompare(a['Item']),
        );
        this.$fullscreenLoading();
      }
    },
    clearROTFilterErrors: function () {
      this.senderError = '';
      this.selectionError = '';
      this.fromError = '';
      this.toError = '';
    },
    refreshROTClicked: async function () {
      let error = false;

      if (!this.selectedSender) {
        error = true;
        this.senderError = 'Please select a sender';
      }

      if (this.rangeROTChecked) {
        // ROT range

        //#region Validation Check
        if (!this.selectedRange) {
          error = true;
          this.selectionError = 'Please select your Range Selection';
        }
        if (!this.filter1) {
          error = true;
          this.fromError = 'Please select your from';
        }
        if (!this.filter2) {
          error = true;
          this.toError = 'Please select your to';
        }
        //#endregion
      }

      if (error) {
        return;
      } // Validation does not pass

      const dataToPost = {
        from: this.selectedSender['From'],
        filter: '',
        filtertype: '',
        filtervalue1: '',
        filtervalue2: '',
      };
      if (this.rangeROTChecked) {
        dataToPost['filter'] = this.selectedRange['SendKey'];
        dataToPost['filtertype'] = this.selectedRange['Type'];
        dataToPost['filtervalue1'] =
          this.filter1 ?
            this.isDateTime ?
              this.filter1.formatString('yyyy-MM-dd HH:mm')
            : this.filter1['Item']
          : '';
        dataToPost['filtervalue2'] =
          this.filter2 ?
            this.isDateTime ?
              this.filter2.formatString('yyyy-MM-dd HH:mm')
            : this.filter2['Item']
          : '';
      }

      this.erotListing = [];
      this.erotLoading = true;
      const erot = this.$deepTrimJsonV3(await this.$apiCallV2(`/HaulageEROT/GeteJobListing`, dataToPost));
      this.erotLoading = false;
      this.eROTLastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');

      if (erot.length == 1 && erot[0]['Results'] && erot[0]['ErrMsg']) {
        this.erotListing = [];
      } else {
        this.erotFilterOpen = false;
        //add style to the Attachment column
        //place the Attachment column at the beginning of the table
        this.erotListing = erot.map((item) => {
          const erotWithAttachment = {
            Attachment:
              item['eROTAtt'] == '1' || item['WebAtt1'] == '1' || item['WebAtt2'] == '1' || item['eROTFMS'] == '1' ?
                '<div height="15" width="15" style="background-color: green; padding: 5px; border-radius:5px; color: white; pointer-events: none">Yes</div>'
              : '<div height="15" width="15" style="background-color: gray; padding: 5px; border-radius:5px; color: white; pointer-events: none">No</div>',
            ...item,
          };

          return erotWithAttachment;
        });
      }
    },
    eROTTableBoxButtonClicked: function (_buttonText, row) {
      this.eROTContainersPopupTableData = row.Containers;
      this.eROTContainersPopupTableBoxTitle = `Containers for Request ${row['Cust Ref #']}`;
      this.showeROTContainersPopup = true;
    },
    eROTContainersPopupCloseClicked: function (_pointerEvent) {
      this.showeROTContainersPopup = false;
    },
    getJobRequestJson: async function () {
      const toVerify = JSON.parse(JSON.stringify(this.selectedROT[0]));

      this.eROTSections = [];
      this.$fullscreenLoading('Getting Details');
      const fullDetails = this.$deepTrimJsonV3(
        await this.$apiCallV2(`/HaulageEROT/geteJobRequestJSON?requestNo=${toVerify['Request #']}`),
      );
      this.$fullscreenLoading();

      return fullDetails;
    },
    eROTAccept: async function () {
      const fullDetails = await this.getJobRequestJson();
      //#region Clearing required list for erotcn
      this.eROTcncontsizeList = [];
      this.eROTcnconttypeList = [];
      this.eROTcndeliverytypeList = [];
      this.eROTcnhandlingtypeList = [];
      this.eROTbillingfmtList = [];
      this.eROToperatorcodeList = [];
      this.eROTcnstatusList = [];
      this.eROTcommodityList = [];
      this.documentsData = []; // clear documents
      //#endregion

      if (Array.isArray(fullDetails)) {
        this.eROTFullDetails = null;
        this.$showAlert('error', 'No details', `${fullDetails[0]['ErrMsg']}`);
      } else {
        this.eROTRequestNo = this.selectedROT[0]['Request #'];
        this.eROTSections = [
          {
            name: 'Job Information',
            verifyData: [
              {
                column: 'Shipper/Consignee',
                code: `${fullDetails['cu_number']}`,
                name: `${fullDetails['cu_name']}`,
                detected: `${fullDetails['cu_number']}
${fullDetails['cu_name']}
${fullDetails['cu_addr1']}
${fullDetails['cu_addr2']}
${fullDetails['cu_addr3']}
${fullDetails['cu_addr4']}
${fullDetails['postcode']} ${fullDetails['city']}
Tel: ${fullDetails['cu_phone']}
Fax: ${fullDetails['cu_fax']}`,
                submittedList: this.shipperItems.map((shipperItem) => {
                  return {
                    ...shipperItem,
                    _fullAddress: [
                      shipperItem.Addr1,
                      shipperItem.Addr2,
                      shipperItem.Addr3,
                      shipperItem.Addr4,
                      `${shipperItem.PostCode ?? ''} ${shipperItem.City ?? ''}`,
                      `${shipperItem.State ?? ''} ${shipperItem.Country ?? ''}`,
                    ],
                  };
                }),
                submittedKey: 'Customer Code',
                submittedDesc: 'Customer Name',
                displayKey: 'Description',
                submittedDetails: '_fullAddress',
                addSubmittedRecordLink: `/Home/MasterFiles/ProfileMaster/ShipperConsignee?new=1`,
                canRefreshRecords: true,
                historyKey: 'shipperConsignee',
                isRequired: true,
                compareIndex: 1,
              },
              {
                column: 'Bill To',
                code: `${fullDetails['billto']}`,
                detected: `${fullDetails['billto']}`,
                submittedList: this.billToItems,
                submittedKey: 'Customer Code',
                submittedDesc: 'Customer Name',
                displayKey: 'Description',
                historyKey: 'billTo',
                addSubmittedRecordLink: `/Home/MasterFiles/ProfileMaster/Customer?new=1`,
                canRefreshRecords: true,
                isRequired: true,
                compareIndex: 0,
                compareByKey: fullDetails['bookingsource'] === 'W',
              },
            ],
          },
          {
            name: 'Send To / Container Information',
            verifyData: [
              {
                column: 'Pick Up',
                code: `${fullDetails['pickup']}`,
                name: `${fullDetails['pickup_company']}`,
                detected: `${fullDetails['pickup']}
${fullDetails['pickup_company']}
${fullDetails['pickup_addr1']}
${fullDetails['pickup_addr2']}
${fullDetails['pickup_addr3']}
${fullDetails['pickup_addr4']}
${fullDetails['pickup_postcode']} ${fullDetails['pickup_city']}
${fullDetails['pickup_state']} ${fullDetails['pickup_country']}
Tel: ${fullDetails['pickup_phone']}
Fax: ${fullDetails['pickup_fax']}`,
                submittedList: this.pickUpItems.map((pickUpItem) => {
                  return {
                    ...pickUpItem,
                    _fullAddress: [
                      pickUpItem.Addr1,
                      pickUpItem.Addr2,
                      pickUpItem.Addr3,
                      pickUpItem.Addr4,
                      `${pickUpItem.PostCode ?? ''} ${pickUpItem.City ?? ''}`,
                      `${pickUpItem.State ?? ''} ${pickUpItem.Country ?? ''}`,
                    ],
                  };
                }),
                submittedKey: 'Destination Code',
                submittedDesc: 'Company',
                displayKey: 'Description',
                submittedDetails: '_fullAddress',
                addSubmittedRecordLink:
                  `/Home/MasterFiles/OperationMaster/Destination?new=1` +
                  (fullDetails['pickup_company'] ?
                    `&companyname=${encodeURIComponent(fullDetails['pickup_company'].trim())}`
                  : '') +
                  (fullDetails['pickup_addr1'] ?
                    `&addr1=${encodeURIComponent(fullDetails['pickup_addr1'].trim())}`
                  : '') +
                  (fullDetails['pickup_addr2'] ?
                    `&addr2=${encodeURIComponent(fullDetails['pickup_addr2'].trim())}`
                  : '') +
                  (fullDetails['pickup_addr3'] ?
                    `&addr3=${encodeURIComponent(fullDetails['pickup_addr3'].trim())}`
                  : '') +
                  (fullDetails['pickup_addr4'] ?
                    `&addr4=${encodeURIComponent(fullDetails['pickup_addr4'].trim())}`
                  : '') +
                  (fullDetails['pickup_postcode'] ?
                    `&postcode=${encodeURIComponent(fullDetails['pickup_postcode'].trim())}`
                  : '') +
                  (fullDetails['pickup_city'] ? `&city=${encodeURIComponent(fullDetails['pickup_city'].trim())}` : '') +
                  (fullDetails['pickup_state'] ?
                    `&state=${encodeURIComponent(fullDetails['pickup_state'].trim())}`
                  : '') +
                  (fullDetails['pickup_country'] ?
                    `&country=${encodeURIComponent(fullDetails['pickup_country'].trim())}`
                  : '') +
                  (fullDetails['pickup_phone'] ?
                    `&phoneno=${encodeURIComponent(fullDetails['pickup_phone'].trim())}`
                  : '') +
                  (fullDetails['pickup_fax'] ? `&faxno=${encodeURIComponent(fullDetails['pickup_fax'].trim())}` : ''),
                canRefreshRecords: true,
                historyKey: 'pickup',
                isRequired: true,
                compareIndex: 1,
              },
              {
                column: 'Send To',
                code: `${fullDetails['destination_code']}`,
                name: `${fullDetails['sendto_company']}`,
                detected: `${fullDetails['destination_code']}
${fullDetails['sendto_company']}
${fullDetails['sendto_addr1']}
${fullDetails['sendto_addr2']}
${fullDetails['sendto_addr3']}
${fullDetails['sendto_addr4']}
${fullDetails['sendto_postcode']} ${fullDetails['sendto_city']}
${fullDetails['sendto_state']} ${fullDetails['sendto_country']}
Tel: ${fullDetails['sendto_phone']}
Fax: ${fullDetails['sendto_fax']}
Attn: ${fullDetails['sendto_attn']}`,
                submittedList: this.sendToItems.map((sendToItem) => {
                  return {
                    ...sendToItem,
                    _fullAddress: [
                      sendToItem.Addr1,
                      sendToItem.Addr2,
                      sendToItem.Addr3,
                      sendToItem.Addr4,
                      `${sendToItem.PostCode ?? ''} ${sendToItem.City ?? ''}`,
                      `${sendToItem.State ?? ''} ${sendToItem.Country ?? ''}`,
                    ],
                  };
                }),
                submittedKey: 'Destination Code',
                submittedDesc: 'Company',
                displayKey: 'Description',
                submittedDetails: '_fullAddress',
                addSubmittedRecordLink:
                  `/Home/MasterFiles/OperationMaster/Destination?new=1` +
                  (fullDetails['sendto_company'] ?
                    `&companyname=${encodeURIComponent(fullDetails['sendto_company'].trim())}`
                  : '') +
                  (fullDetails['sendto_addr1'] ?
                    `&addr1=${encodeURIComponent(fullDetails['sendto_addr1'].trim())}`
                  : '') +
                  (fullDetails['sendto_addr2'] ?
                    `&addr2=${encodeURIComponent(fullDetails['sendto_addr2'].trim())}`
                  : '') +
                  (fullDetails['sendto_addr3'] ?
                    `&addr3=${encodeURIComponent(fullDetails['sendto_addr3'].trim())}`
                  : '') +
                  (fullDetails['sendto_addr4'] ?
                    `&addr4=${encodeURIComponent(fullDetails['sendto_addr4'].trim())}`
                  : '') +
                  (fullDetails['sendto_postcode'] ?
                    `&postcode=${encodeURIComponent(fullDetails['sendto_postcode'].trim())}`
                  : '') +
                  (fullDetails['sendto_city'] ? `&city=${encodeURIComponent(fullDetails['sendto_city'].trim())}` : '') +
                  (fullDetails['sendto_state'] ?
                    `&state=${encodeURIComponent(fullDetails['sendto_state'].trim())}`
                  : '') +
                  (fullDetails['sendto_country'] ?
                    `&country=${encodeURIComponent(fullDetails['sendto_country'].trim())}`
                  : '') +
                  (fullDetails['sendto_phone'] ?
                    `&phoneno=${encodeURIComponent(fullDetails['sendto_phone'].trim())}`
                  : '') +
                  (fullDetails['sendto_fax'] ? `&faxno=${encodeURIComponent(fullDetails['sendto_fax'].trim())}` : ''),
                canRefreshRecords: true,
                historyKey: 'sendto',
                isRequired: true,
                compareIndex: 1,
              },
              {
                column: 'Drop Off',
                code: `${fullDetails['dropoff']}`,
                name: `${fullDetails['dropoff_company']}`,
                detected: `${fullDetails['dropoff']}
${fullDetails['dropoff_company']}
${fullDetails['dropoff_addr1']}
${fullDetails['dropoff_addr2']}
${fullDetails['dropoff_addr3']}
${fullDetails['dropoff_addr4']}
${fullDetails['dropoff_postcode']} ${fullDetails['dropoff_city']}
${fullDetails['dropoff_state']} ${fullDetails['dropoff_country']}
Tel: ${fullDetails['dropoff_phone']}
Fax: ${fullDetails['dropoff_fax']}`,
                submittedList: this.dropOffItems.map((dropOffItem) => {
                  return {
                    ...dropOffItem,
                    Description: `${dropOffItem['Destination Code']} - ${dropOffItem['Company']}`,
                    _fullAddress: [
                      dropOffItem.Addr1,
                      dropOffItem.Addr2,
                      dropOffItem.Addr3,
                      dropOffItem.Addr4,
                      `${dropOffItem.PostCode ?? ''} ${dropOffItem.City ?? ''}`,
                      `${dropOffItem.State ?? ''} ${dropOffItem.Country ?? ''}`,
                    ],
                  };
                }),
                submittedKey: 'Destination Code',
                submittedDesc: 'Company',
                displayKey: 'Description',
                submittedDetails: '_fullAddress',
                addSubmittedRecordLink:
                  `/Home/MasterFiles/OperationMaster/Destination?new=1` +
                  (fullDetails['dropoff_company'] ?
                    `&companyname=${encodeURIComponent(fullDetails['dropoff_company'].trim())}`
                  : '') +
                  (fullDetails['dropoff_addr1'] ?
                    `&addr1=${encodeURIComponent(fullDetails['dropoff_addr1'].trim())}`
                  : '') +
                  (fullDetails['dropoff_addr2'] ?
                    `&addr2=${encodeURIComponent(fullDetails['dropoff_addr2'].trim())}`
                  : '') +
                  (fullDetails['dropoff_addr3'] ?
                    `&addr3=${encodeURIComponent(fullDetails['dropoff_addr3'].trim())}`
                  : '') +
                  (fullDetails['dropoff_addr4'] ?
                    `&addr4=${encodeURIComponent(fullDetails['dropoff_addr4'].trim())}`
                  : '') +
                  (fullDetails['dropoff_postcode'] ?
                    `&postcode=${encodeURIComponent(fullDetails['dropoff_postcode'].trim())}`
                  : '') +
                  (fullDetails['dropoff_city'] ?
                    `&city=${encodeURIComponent(fullDetails['dropoff_city'].trim())}`
                  : '') +
                  (fullDetails['dropoff_state'] ?
                    `&state=${encodeURIComponent(fullDetails['dropoff_state'].trim())}`
                  : '') +
                  (fullDetails['dropoff_country'] ?
                    `&country=${encodeURIComponent(fullDetails['dropoff_country'].trim())}`
                  : '') +
                  (fullDetails['dropoff_phone'] ?
                    `&phoneno=${encodeURIComponent(fullDetails['dropoff_phone'].trim())}`
                  : '') +
                  (fullDetails['dropoff_fax'] ? `&faxno=${encodeURIComponent(fullDetails['dropoff_fax'].trim())}` : ''),
                canRefreshRecords: true,
                historyKey: 'dropoff',
                isRequired: true,
                compareIndex: 1,
              },
            ],
          },
          {
            name: 'Voyage Information',
            verifyData: [
              {
                column: 'Forwarding Agent',
                detected: `${fullDetails['frtship_no']}
${fullDetails['frtship_name']}`,
                submittedList: this.fwdgAgentItems,
                submittedKey: 'FA Code',
                submittedDesc: 'FA Name',
                displayKey: 'Description',
                historyKey: 'forwardingAgent',
                isRequired: true,
                compareIndex: 1,
              },
              {
                column: 'Shipping Agent',
                detected: `${fullDetails['ag_code']}
${fullDetails['ag_name']}`,
                submittedList: this.shippingAgentItems,
                submittedKey: 'Agent Code',
                submittedDesc: 'Agent Name',
                displayKey: 'Description',
                historyKey: 'shippingAgent',
                isRequired: true,
                compareIndex: 1,
              },
            ],
          },
        ];

        await this.appendAttachmentToVerification(fullDetails['attachments']);
        this.verificationTitle = '';
        this.verificationTitle = `Verify Details [Sender:${fullDetails['senderco']}],[Request #:${fullDetails['autorequestno']}],[CMR #:${fullDetails['cmr_no']}]`;
        this.showVerification = true;
        this.eROTFullDetails = fullDetails;

        //check is there any attachment
        if (Array.isArray(fullDetails.attachments)) {
          const transformedAttachments = fullDetails.attachments.map((att) => ({
            docCode: att.doc_code,
            docRef: att.doc_refno,
            remarks: att.doc_remark,
            fileAtt: att.doc_image,
            filetype: att.doc_imagetype,
            statuses: 'N/A',
          }));
          for (const details of transformedAttachments) {
            await this.documentUpdateROT({ details });
          }
        }
      }
    },
    verificationSubmittedRefreshClicked: async function (placeholder) {
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);

      switch (placeholder) {
        case 'Shipper/Consignee':
          this.eROTSections[0]['verifyData'][0]['submittedList'] = [];
          await this.getShipperListing();
          this.eROTSections[0]['verifyData'][0]['submittedList'] = this.shipperItems.map((shipperItem) => {
            return {
              ...shipperItem,
              Description: `${shipperItem['Customer Code']} - ${shipperItem['Customer Name']}`,
              _fullAddress: [
                shipperItem.Addr1,
                shipperItem.Addr2,
                shipperItem.Addr3,
                shipperItem.Addr4,
                `${shipperItem.PostCode ?? ''} ${shipperItem.City ?? ''}`,
                `${shipperItem.State ?? ''} ${shipperItem.Country ?? ''}`,
              ],
            };
          });
          break;

        case 'Pick Up':
          this.eROTSections[1]['verifyData'][0]['submittedList'] = [];
          await this.getPickUpListing();
          this.eROTSections[1]['verifyData'][0]['submittedList'] = this.pickUpItems.map((pickUpItem) => {
            return {
              ...pickUpItem,
              Description: `${pickUpItem['Destination Code']} - ${pickUpItem['Company']}`,
              _fullAddress: [
                pickUpItem.Addr1,
                pickUpItem.Addr2,
                pickUpItem.Addr3,
                pickUpItem.Addr4,
                `${pickUpItem.PostCode ?? ''} ${pickUpItem.City ?? ''}`,
                `${pickUpItem.State ?? ''} ${pickUpItem.Country ?? ''}`,
              ],
            };
          });
          break;

        case 'Send To':
          this.eROTSections[1]['verifyData'][1]['submittedList'] = [];
          await this.getSendToListing();
          this.eROTSections[1]['verifyData'][1]['submittedList'] = this.sendToItems.map((sendToItem) => {
            return {
              ...sendToItem,
              Description: `${sendToItem['Destination Code']} - ${sendToItem['Company']}`,
              _fullAddress: [
                sendToItem.Addr1,
                sendToItem.Addr2,
                sendToItem.Addr3,
                sendToItem.Addr4,
                `${sendToItem.PostCode ?? ''} ${sendToItem.City ?? ''}`,
                `${sendToItem.State ?? ''} ${sendToItem.Country ?? ''}`,
              ],
            };
          });
          break;

        case 'Drop Off':
          this.eROTSections[1]['verifyData'][2]['submittedList'] = [];
          await this.getDropOffListing();
          this.eROTSections[1]['verifyData'][2]['submittedList'] = this.dropOffItems.map((dropOffItem) => {
            return {
              ...dropOffItem,
              Description: `${dropOffItem['Destination Code']} - ${dropOffItem['Company']}`,
              _fullAddress: [
                dropOffItem.Addr1,
                dropOffItem.Addr2,
                dropOffItem.Addr3,
                dropOffItem.Addr4,
                `${dropOffItem.PostCode ?? ''} ${dropOffItem.City ?? ''}`,
                `${dropOffItem.State ?? ''} ${dropOffItem.Country ?? ''}`,
              ],
            };
          });
          break;
      }

      this.$fullscreenLoading();
    },
    verificationConfirm: function (detectedData, selectedData) {
      const selectedRequestNo = this.selectedROT[0]['Request #'];
      this.showEROT = false;
      this.eROTDetectedData = detectedData;
      this.eROTSelectedData = selectedData;

      this.showVerification = false;
      this.menuClicked({ title: 'New Job (eROT)' });

      this.$nextTick(() => {
        // Populate details from the erot full details
        //#region Job Info Data
        // this.jobNo = this.eROTFullDetails['keytochange'];
        this.urgent = this.eROTFullDetails['urgent'] == '1';
        // this.jobDateTime = this.eROTFullDetails['job_date'].toString().toDate();
        // this.selectedShipper = this.shipperItems.getSelected(viewJobData[shipperKey].trim(), 'Customer Code')
        this.selectedShipper = this.shipperItems.getSelected(
          this.eROTSelectedData['shipperConsignee'],
          'Customer Code',
        );
        this.custRefNo = this.eROTFullDetails['cmr_no']; //curefno change to cmr_no
        this.projectNo = this.eROTFullDetails['orderno'];
        this.requestNo = this.eROTFullDetails['autorequestno'] || selectedRequestNo; //requestno change to autorequestno
        this.prevrefjobno = this.eROTFullDetails['job_no'] ?? '';
        this.eROTDisable = true;
        this.selectedJobType = this.jobTypeItems.find(
          (j) => j['Job Type'] == `${this.eROTFullDetails['job_type'] == 'I' ? 'IMP' : 'EXP'}`,
        );
        // this.selectedCheque = this.eROTFullDetails['keytochange'];
        this.selectedTrip = this.tripItems.getSelected(this.eROTFullDetails['trip'], 'Trip');
        // this.coeff = this.eROTFullDetails['keytochange'];
        // this.keepCharges = this.eROTFullDetails['keytochange'];

        this.$nextTick(() => {
          this.selectedBillTo = this.billToItems.getSelected(this.eROTSelectedData['billTo'], 'Customer Code');
          this.billToSelected(this.selectedBillTo);
        });
        //#endregion

        //#region Send To / Container Data
        this.selectedSendTo = this.sendToItems.getSelected(this.eROTSelectedData['sendto'], 'Destination Code');
        // this.isDiversion = cnList[0]['Diversion'].trim() == '1'; // = false;
        const tempPremises =
          this.eROTFullDetails['securedpremises'] ?
            this.eROTFullDetails['securedpremises'] == '0' ?
              '1'
            : this.eROTFullDetails['securedpremises']
          : '1';
        this.selectedPremises = this.premisesItems.getSelected(tempPremises, '#');
        // this.selectedPremises = this.eROTFullDetails['securedpremises'] ? this.premisesItems[parseInt(this.eROTFullDetails['securedpremises'])] : null;
        this.selectedPickUp = this.pickUpItems.getSelected(this.eROTSelectedData['pickup'], 'Destination Code');
        this.selectedDropOff = this.dropOffItems.getSelected(this.eROTSelectedData['dropoff'], 'Destination Code');
        this.consignmentList = [];
        this.selectedConsignments = [];

        if (!Array.isArray(this.eROTFullDetails['consignments'])) {
          this.eROTFullDetails['consignments'] = [];
        }
        const consignmentNote = this.eROTFullDetails['consignments'].map((c) => {
          return {
            'CN State': '',
            'Third Party': '',
            Printed: '0',
            Billed: '0',
            Assigned: '0',
            'Consignment No': '', //this.cdaNo,
            seqno: '', //'',
            // 'diversion': c['Diversion'] ? c['Diversion'].trim() : '0', //this.isDiversionCN ? '1' : '0',
            Diversion: '0',
            // 'premisesis': c['securedpremises'] ? c['securedpremises'].trim() : '', //this.getValueFromObject(this.selectedPremisesCN, '#') ? this.getValueFromObject(this.selectedPremisesCN, '#') : '1',
            'Premises Is':
              c['securedpremises'] ?
                c['securedpremises'] == '0' ?
                  '1'
                : c['securedpremises']
              : '1',
            'Cont Size': this.getValueFromObject(c, 'size'), //this.getValueFromObject(this.selectedSize, 'Size'),
            'Cont Type': this.getValueFromObject(c, 'cont_type'), //this.getValueFromObject(this.selectedType, 'Cont Type'),
            'Delivery Type': this.getValueFromObject(c, 'deliverytype'), //this.getValueFromObject(this.selectedDelivery, 'Delivery Type'),
            'Handling Type': this.getValueFromObject(c, 'handlingtype'), //this.getValueFromObject(this.selectedHandling, 'Handling Type'),
            // 'b2bcont': parseInt(this.getValueFromObject(c, 'B2BCont')), //this.isb2b ? '1' : '0',
            B2B: '0',
            // 'timbang': parseInt(this.getValueFromObject(c, 'PackageCode')), //this.isTimbang ? '1' : '0',
            Timbang: '0',
            // 'Billing Format': this.getValueFromObject(c, 'BillingFormat'), //this.getValueFromObject(this.selectedBillingFormat, 'Billing Fmt'),
            'Cont No': this.getValueFromObject(c, 'cont_no'), //this.isContNo ? this.contNo : this.contList[i],
            'Cont Operator': this.getValueFromObject(c, 'contoperator'), //this.contOp,
            'Seal No': this.getValueFromObject(c, 'seal_no'), //this.sealNo,
            // 'Ref No': this.getValueFromObject(c, 'RefNo'), //this.refNo,
            'Cont Height': this.getValueFromObject(c, 'height'), //this.height,
            'Cont Weight': this.getValueFromObject(c, 'gweight'), //this.weight,
            'Cont Measure': this.getValueFromObject(c, 'measurement'), //this.measure,
            // 'Cont Status': c['Status'] ? (c['Status'] == 'E' ? 'Empty' : 'Laden') : '', //this.statusButtons.filter(s => s['checked'])[0]['title'],
            Commodity: this.getValueFromObject(c, 'commodity'), //this.commodity,
            'Required Date': this.getValueFromObject(c, 'daterequired'), //this.requiredTime ? this.$dateTime.getDateTime(this.requiredTime, 'yyyy-MM-dd') : '',
            'Required Time': this.getValueFromObject(c, 'timerequired'), //this.requiredTime ? this.$dateTime.getDateTime(this.requiredTime, 'HHmm') : '',
            'Required Desc': c['ReqTimeDesc'] ? c['ReqTimeDesc'] : '',
            Remarks: this.getValueFromObject(c, 'remarks1'), //this.containerRemarks,
            Fumigation: parseInt(this.getValueFromObject(c, 'fumigation')), //this.isFumigation ? '1' : '0',
            'Office Hours Delivery': parseInt(this.getValueFromObject(c, 'officehrs')), //this.isOfficeHrsD ? '1' : '0',
            'Office Hours Collection': parseInt(c['rfcofficehrs'] ? this.getValueFromObject(c, 'rfcofficehrs') : '0'), //this.isOfficeHrsC ? '1' : '0',
            Temperature: this.getValueFromObject(c, 'temperature'), //this.temperature,
            // 'Team': this.getValueFromObject(c, 'Team'), //this.getValueFromObject(this.selectedTeam, 'Team'),
            Team: '',
            cnaction: 'N', //'N',
            // 'Haulage Rate': this.getValueFromObject(c, 'HaulageRate'), //this.haulageTariff,
            'Haulage Rate': this.selectedSendTo ? this.selectedSendTo[`20' Rate`].toFixed(2) : '0.00',
            // 'Toll Rate': this.getValueFromObject(c, 'TollRate'), //this.tollTariff,
            'Toll Rate': this.selectedSendTo ? this.selectedSendTo['Toll'].toFixed(2) : '0.00',
            'Send To': this.eROTSelectedData['sendto'], //this.getValueFromObject(this.selectedSendToCN, 'Destination Code'),
            // 'Area': this.eROTSelectedData['sendto'], //this.getValueFromObject(this.selectedSendToCN, 'Tariff Area'),
            Area: this.selectedSendTo ? this.getValueFromObject(this.selectedSendTo, 'Tariff Area') : '',
            'Pick Up': this.eROTSelectedData['pickup'], //this.getValueFromObject(this.selectedPickUpCN, 'Destination Code'),
            'Drop Off': this.eROTSelectedData['dropoff'], //this.getValueFromObject(this.selectedDropOffCN, 'Destination Code'),
            haubookingid: c['id'] ?? '',
            samesendto: true, //this.sameSendTo,
            samepickup: true, //this.samePickUp,
            samedropoff: true, //this.sameDropOff,
          };
        });
        this.$nextTick(() => {
          this.consignmentList = consignmentNote;
          if (this.consignmentList.length > 0) {
            this.checkAllConsignmentCompulsoryField();
          }
        });
        //#endregion

        //#region Voyage Info Data
        this.selectedShipCallNo = this.shipCallNoItems.getSelected(this.eROTFullDetails['shipcall_no'], 'Ship Call No');
        if (!this.selectedShipCallNo) {
          this.shipCallNoFreeText = this.eROTFullDetails['shipcall_no'];
        }
        this.voyNo = this.eROTFullDetails['voyno'] ?? '';
        this.selectedVesselCode = this.vesselCodeItems.getSelected(this.eROTFullDetails['vessel_no'], 'Vessel ID');
        if (!this.selectedVesselCode) {
          this.selectedVesselCode = this.vesselCodeItems.getSelected(
            this.eROTFullDetails['vessel_name'],
            'Vessel Name',
          );
        }
        this.selectedTranshipPort = this.transhipPortItems.getSelected(this.eROTFullDetails['trans_port'], 'Port Code');
        this.selectedDischargePort = this.dischargeItems.getSelected(
          this.eROTFullDetails['discharge_port'],
          'Port Code',
        );
        if (!this.selectedDischargePort) {
          this.dischargePortFreeText = this.eROTFullDetails['discharge_portname'];
        }
        this.etaDateTime =
          this.eROTFullDetails['date_eta'] ? this.eROTFullDetails['date_eta'].toString().toDate() : null;
        this.etdDateTime =
          this.eROTFullDetails['date_etd'] ? this.eROTFullDetails['date_etd'].toString().toDate() : null;
        this.closeDateTime =
          this.eROTFullDetails['closingtime'] ? this.eROTFullDetails['closingtime'].toString().toDate() : null;
        this.demurageDate =
          this.eROTFullDetails['datedemurage'] ? this.eROTFullDetails['datedemurage'].toString().toDate() : null;
        this.detentionDate =
          this.eROTFullDetails['datedetention'] ? this.eROTFullDetails['datedetention'].toString().toDate() : null;
        this.shippingLine = this.eROTFullDetails['shipline'] ?? '';
        this.selectedShippingAgent = this.shippingAgentItems.getSelected(
          this.eROTSelectedData['shippingAgent'],
          'Agent Code',
        );
        this.selectedFwdgAgent = this.fwdgAgentItems.getSelected(this.eROTSelectedData['forwardingAgent'], 'FA Code');
        this.bookingRefNo = this.eROTFullDetails['bookingrefno'] ?? '';
        this.requestedBy = this.eROTFullDetails['requestedby'] ?? '';
        this.finalDestination = this.eROTFullDetails['finaldest'] ?? '';
        this.premisOffload = this.eROTFullDetails['offloadatpremis'] == '1';

        this.freeStorage = this.eROTFullDetails['freestorageval'] ?? '';
        this.storageUnit = this.eROTFullDetails['storageunit'] ?? 'D';
        this.freeDemurrage = this.eROTFullDetails['freedemurrage'] ?? '';
        this.demurrageUnit = this.eROTFullDetails['demurrageUnit'] ?? 'D';
        this.freeDetention = this.eROTFullDetails['freedetention'] ?? '';
        this.detentionUnit = this.eROTFullDetails['detentionunit'] ?? 'D';
        //#endregion
      });
    },
    checkAllConsignmentCompulsoryField: async function () {
      // this.haulageTariff = this.selectedSendToCN[`20' Rate`] ? this.selectedSendToCN[`20' Rate`].toFixed(2) : '0.00';
      //this.tollTariff = this.selectedSendToCN['Toll'] ? this.selectedSendToCN['Toll'].toFixed(2) : '0.00';
      this.consignmentList.forEach((c) => {
        if (!c['Cont Status']) {
          c['Cont Status'] = this.eROTFullDetails['job_type'] == 'I' ? 'Laden' : 'Empty';
        }
        if (this.selectedBillTo && !c['billingfmt']) {
          c['Billing Format'] = this.selectedBillTo['Billing Format'] || '';
        }
      });

      this.eROTcncontsizeList = this.consignmentList.filter((c) => !c['Cont Size']);
      this.eROTcnconttypeList = this.consignmentList.filter((c) => !c['Cont Type']);
      this.eROTcndeliverytypeList = this.consignmentList.filter((c) => !c['Delivery Type']);
      this.eROTcnhandlingtypeList = this.consignmentList.filter((c) => !c['Handling Type']);
      this.eROTbillingfmtList = this.consignmentList.filter((c) => !c['Billing Format']);
      this.eROToperatorcodeList = this.consignmentList.filter((c) => !c['Cont Operator']);
      this.eROTcnstatusList = this.consignmentList.filter((c) => !c['Cont Status']);
      this.eROTcommodityList = this.consignmentList.filter((c) => !c['Commodity']);

      if (
        this.eROTcncontsizeList.length > 0 ||
        this.eROTcnconttypeList.length > 0 ||
        this.eROTcndeliverytypeList.length > 0 ||
        this.eROTcnhandlingtypeList.length > 0 ||
        this.eROTbillingfmtList.length > 0 ||
        this.eROToperatorcodeList.length > 0 ||
        this.eROTcnstatusList.length > 0 ||
        this.eROTcommodityList.length > 0
      ) {
        this.eROTCNErrorPopup = true;
        const selectedItem = await new Promise((r) => (this.eROTCNErrorResolve = r));
        if (selectedItem) {
          const temp = this.consignmentList;
          this.consignmentList = [];
          Object.keys(selectedItem).forEach((k) => {
            temp.forEach((c) => {
              if (!c[k]) {
                c[k] = selectedItem[k];
              }
            });
          });

          this.$nextTick(() => {
            this.consignmentList = temp;
          });
        }
      }
    },
    eROTCNErrorButtonsClicked: async function (buttonText) {
      switch (buttonText) {
        case 'Confirm': {
          let hasError = false;
          const objToResolve = {
            'Cont Size': null,
            'Cont Type': null,
            'Delivery Type': null,
            'Handling Type': null,
            'Billing Format': null,
            'Cont Operator': null,
            'Cont Status': null,
            Commodity: null,
            'Required Date': null,
            'Required Time': null,
          };
          //#region Validating
          if (this.eROTcncontsizeList.length > 0) {
            if (!this.selectedSize) {
              hasError = true;
              this.sizeError = 'Container Size is Required!';
            } else {
              objToResolve['Cont Size'] = this.selectedSize['Size'];
            }
          }
          if (this.eROTcnconttypeList.length > 0) {
            if (!this.selectedType) {
              hasError = true;
              this.typeError = 'Container Type is Required!';
            } else {
              objToResolve['Cont Type'] = this.selectedType['Cont Type'];
            }
          }
          if (this.eROTcndeliverytypeList.length > 0) {
            if (!this.selectedDelivery) {
              hasError = true;
              this.deliveryError = 'Delivery Type is Required!';
            } else {
              objToResolve['Delivery Type'] = this.selectedDelivery['Delivery Type'];
            }
          }
          if (this.eROTcnhandlingtypeList.length > 0) {
            if (!this.selectedHandling) {
              hasError = true;
              this.handlingError = 'Handling Type is Required!';
            } else {
              objToResolve['Handling Type'] = this.selectedHandling['Handling Type'];
            }
          }
          if (this.eROTbillingfmtList.length > 0) {
            if (!this.selectedBillingFormat) {
              hasError = true;
              this.billingFormatError = 'Billing Format is Required!';
            } else {
              objToResolve['Billing Format'] = this.selectedBillingFormat['Billing Fmt'];
            }
          }
          if (this.eROToperatorcodeList.length > 0) {
            if (!this.contOp) {
              hasError = true;
              this.contOpError = 'Operator Code is Required!';
            } else {
              objToResolve['Cont Operator'] = this.contOp;
            }
          }
          if (this.eROTcnstatusList.length > 0) {
            if (this.statusButtons.filter((s) => s['checked']).length == 0) {
              hasError = true;
              this.statusError = 'Container Status is Required!';
            } else {
              objToResolve['Cont Status'] = this.statusButtons.filter((s) => s['checked'])[0]['title'];
            }
          }
          if (this.eROTcommodityList.length > 0) {
            if (!this.commodity) {
              hasError = true;
              this.commodityError = 'Commodity is Required!';
            } else {
              objToResolve['Commodity'] = this.commodity;
            }
          }
          //#endregion
          if (!hasError) {
            const objResult = Object.assign(
              {},
              ...Object.entries(objToResolve)
                .map(([k, v]) => {
                  // Removing all the null value from the object
                  if (v) {
                    return { [k]: v };
                  }
                })
                .filter((v) => v),
            );
            this.eROTCNErrorResolve(objResult);
            this.eROTCNErrorPopup = false;
          }
          break;
        }
        case 'Cancel': {
          const confirmCancel = await this.$showAlert(
            'warning',
            'Cancel Job Creation',
            `If you choose to cancel, the job creation will be cancelled and you'll need to repeat the verification process again.`,
            [{ text: 'Cancel Job Creation', color: 'red', textColor: 'white' }, { text: 'Continue Job Creation' }],
          );

          if (confirmCancel == 'Cancel Job Creation') {
            this.eROTCNErrorResolve(null);
            this.eROTCNErrorPopup = false;
            this.popupShow = false;
          }
          break;
        }
      }
    },
    eROTReject: async function () {
      const fullDetails = await this.getJobRequestJson();

      if (Array.isArray(fullDetails)) {
        this.eROTFullDetails = null;
        this.$showAlert('error', 'No details', `${fullDetails[0]['ErrMsg']}`);
      } else {
        this.showeROTReject = true;
        this.eROTFullDetails = fullDetails;
        // auto populate form with sender email
        const senderEmail = this.selectedROT[0]['Sender Email'];
        if (senderEmail) {
          this.rejectToEmails.push({ email: senderEmail, valid: true });
        }
      }
    },
    totalEmailLength: function (emailArray) {
      return emailArray.reduce((count, item) => {
        return count + item['email'].length;
      }, 0);
    },
    eROTRejectButtonsClicked: async function (buttonText) {
      let errorMessage = [];
      let errorToEmails = [];
      let errorCCEmails = [];
      let errorBCCEmails = [];
      switch (buttonText) {
        case 'Reject':
          errorMessage = [];

          //#region Validation
          errorToEmails = this.rejectToEmails.filter((e) => !e['valid']);
          errorCCEmails = this.rejectCCEmails.filter((e) => !e['valid']);
          errorBCCEmails = this.rejectBCCEmails.filter((e) => !e['valid']);

          if (this.rejectToEmails.length == 0) {
            errorMessage.push('Please enter at least 1 email address to send to rejection notice to.');
          } else if (errorToEmails.length > 0 || errorCCEmails.length > 0 || errorBCCEmails.length > 0) {
            errorMessage.push('Please make sure that all your email address are in correct format.');
          }

          if (this.totalEmailLength(this.rejectToEmails) > 500) {
            errorMessage.push('Please make sure that your email addresses (To) are less than 500 characters');
          }
          if (this.totalEmailLength(this.rejectCCEmails) > 500) {
            errorMessage.push('Please make sure that your email addresses (CC) are less than 500 characters');
          }
          if (this.totalEmailLength(this.rejectBCCEmails) > 500) {
            errorMessage.push('Please make sure that your email addresses (BCC) are less than 500 characters');
          }

          if (!this.eROTRejectReason) {
            errorMessage.push('Please enter the reason for the rejection.');
          } else if (this.eROTRejectReason.length > 500) {
            errorMessage.push('Please make sure that your reason to reject is less than 500 characters');
          }
          //#endregion

          //#region Reason validation
          if (errorMessage.length > 0) {
            this.$showAlert('error', 'eROT Reject Error', errorMessage.join('\n'));
          } else {
            this.$fullscreenLoading('Rejecting an eROT');
            const rejectResult = await this.$apiCallV2('/HaulageJob/RejecteJob', {
              emailto: this.rejectToEmails.map((e) => e['email']).join(';'),
              rejectreason: this.eROTRejectReason,
              rejectnotice: '',
              autorequestno: this.selectedROT[0]['Request #'],
              emailmessage: this.eROTRejectMessage,
            });
            this.$fullscreenLoading();

            const rot = JSON.parse(JSON.stringify(this.selectedROT[0])); //move here so catch also can user rot

            if (rejectResult[0]['Results'] == 0) {
              // Reject success
              //#region Send Reject Email
              this.$fullscreenLoading('Sending Rejection Email');
              const attachmentsToAdd = [];
              if (this.eROTFullDetails['attachments']) {
                const report = this.eROTFullDetails['attachments'].find(
                  (a) => a['doc_remark'].toLowerCase() == 'auto generated report',
                );
                if (report) {
                  attachmentsToAdd.push({
                    Content: `${report['doc_image']}`,
                    FileName: report['doc_refno'],
                    ContentType: report['doc_imagetype'],
                  });
                }
              }

              let body = 'Your ROT/CMR has been rejected.<br>';
              body += `Request #: ${this.eROTFullDetails['cmr_no']}<br>`;
              body += `Date/Time Received: ${this.eROTFullDetails['datereceived']} ${this.eROTFullDetails['timereceived']}<br>`;
              body += `Date/Time Processed: ${new Date().formatString('dd/MM/yyyy HHmm')}<br>`;
              body += `Reason: ${this.eROTRejectReason}<br><br>`;
              body += 'Containers<br>';
              body += '---------------<br>';
              const rejectContainerDetails = this.eROTFullDetails['consignments'].map(
                (c) =>
                  `Container No: ${c['cont_no']}, Seal No: ${c['seal_no']}, Size: ${c['size']}, Type: ${c['cont_type']}`,
              );
              body += rejectContainerDetails.join('<br>');

              if (this.eROTRejectMessage) {
                body += `<br><br>${this.eROTRejectMessage}`;
              }

              const disclaimer = await this.$apiCallV2(`/HaulageJob/GetSettingsSystem?settingsItem=Disclaimer`);
              body += `<br><br><i>${disclaimer[0]['SettingsValue']}</i><br><br>`;

              body += `Thank you.<br>`;
              body += `Regards,<br>`;
              body += `${this.loginDetails['LoginUserId']}<br>`;

              const dataForEmailing = {
                ToEmails: this.rejectToEmails.map((e) => e['email']),
                CCEmails: this.rejectCCEmails.map((e) => e['email']),
                BCCEmails: this.rejectBCCEmails.map((e) => e['email']),
                Subject: `ROT Rejected - ${this.eROTFullDetails['cmr_no']}`,
                Body: body,
                Attachments: attachmentsToAdd,
              };

              await this.$apiCallV2('/HaulageJob/SendRejectEmail', dataForEmailing);
              this.$fullscreenLoading();
              //#endregion

              // let rot = JSON.parse(JSON.stringify(this.selectedROT[0]));
              this.$showAlert(
                'success',
                'eROT Rejected',
                `eROT with Request No ${rot['Request #']} has been rejected.`,
              );

              this.selectedROT = [];
              this.refreshROTClicked();
            } else {
              // Reject error
              this.$showAlert(
                'error',
                'eROT Reject Error',
                `There was an error while rejecting eROT with Request No ${rot['Request #']}.\n Error Message : ${rejectResult[0]['ErrMsg']}\n Please try again.`,
              );
              return;
            }
          }
          //#endregion
          break;
        case 'Cancel':
          break;
      }

      this.showeROTReject = false;
      this.rejectToEmails = [];
      this.rejectCCEmails = [];
      this.rejectBCCEmails = [];
      this.eROTRejectMessage = '';
      this.eROTRejectReason = '';
      this.showCC = false;
      this.showBCC = false;
    },
    appendAttachmentToVerification: async function (att) {
      if (att) {
        if (att.length > 0) {
          att = this.$deepTrimJsonV3(att);
          const form = new FormData();
          for (let x = 0; x < att.length; x++) {
            const bytesChar = atob(att[x]['doc_image']);
            const bytesArray = new Array(bytesChar.length);
            for (let i = 0; i < bytesChar.length; i++) {
              bytesArray[i] = bytesChar.charCodeAt(i);
            }
            const blob = new Blob([new Uint8Array(bytesArray)]);

            const fileNameSplit = att[x]['doc_refno'].split('.');
            form.append('file', blob, `${fileNameSplit[0]}_${x + 1}.${fileNameSplit[1]}`);
          }
          form.append('folder', `eROT_${this.eROTRequestNo}`);

          const result = await this.$apiCallV2('/Upload/UploadFile', form);
          result['Files'].forEach((r, i) =>
            this.eROTAttachments.push({
              link: r,
              filename: att[i]['doc_refno'],
              remarks: att[i]['doc_remark'],
            }),
          );
        }
      } else {
        const files = await this.$apiCallV2(
          `/HaulageJob/GetAvailableFiles?folderName=${this.selectedROT[0]['Request #']}`,
        );
        if (!Array.isArray(files)) {
          const fileNameList = files['Name'];
          const filesList = files['File'];
          const attachment = this.$deepTrimJsonV3(filesList);
          //loop through the files and create a blob url for each file
          for (let i = 0; i < fileNameList.length; i++) {
            const fileType = await this.$apiCallV2(`/HaulageJob/GetMIMEType?filename=${fileNameList[i]}`);
            const bytesChar = atob(attachment[i]); //decode the base64 string
            const bytesArray = new Array(bytesChar.length); //create a byte array of each character
            for (let j = 0; j < bytesChar.length; j++) {
              bytesArray[j] = bytesChar.charCodeAt(j);
            }
            //convert into real typed byte array
            const blob = new Blob([new Uint8Array(bytesArray)], { type: fileType });
            const blobUrl = URL.createObjectURL(blob); //create a string containing the url

            this.eROTAttachments.push({
              link: blobUrl,
              filename: fileNameList[i],
              remarks: '',
            });
          }
        }
      }
    },
    //#endregion

    //#region File Upload Methods
    uploadFileChanged: async function (files) {
      if (files.length > 0) {
        const filename = files[0].name.split('.');
        if (filename[filename.length - 1].toLowerCase() != 'pdf') {
          await this.$showAlert(
            'error',
            'Unsupported File Type',
            `We only support PDF files at the moment.<br/><br/>Sorry for the invonvenience.`,
          );
          this.$refs['uploadInput'].clearAttachmentClicked();
        } else {
          this.uploadFile = files[0];
          this.uploadFileBase64 = await files[0].toBase64();
        }
      } else {
        this.uploadFileBase64 = '';
      }
    },
    scanDocumentClicked: async function () {
      this.$fullscreenLoading('Analyzing File');
      const formData = new FormData();
      formData.append('file', this.uploadFile);
      const data = await this.$apiCallV2('/Verification/ReadFile?pageName=HaulageJob', formData);
      this.$fullscreenLoading();

      this.eROTSections = [
        {
          name: 'Job Information',
          verifyData: [
            {
              column: 'Shipper/Consignee',
              detected: `${data['formattedData']['cu_number']}`,
              submittedList: this.shipperItems,
              submittedKey: 'Customer Code',
              submittedDesc: 'Customer Name',
              historyKey: 'shipperConsignee',
              isRequired: true,
              compareIndex: 0,
              displayKey: 'Description',
            },
            {
              column: 'Bill To',
              detected: `${data['formattedData']['billto']}`,
              submittedList: this.billToItems,
              submittedKey: 'Customer Code',
              submittedDesc: 'Customer Name',
              historyKey: 'billTo',
              isRequired: true,
              compareIndex: 0,
              displayKey: 'Description',
            },
          ],
        },
        {
          name: 'Send To / Container Information',
          verifyData: [
            {
              column: 'Pick Up',
              detected: `${data['formattedData']['pickup']}`,
              submittedList: this.pickUpItems,
              submittedKey: 'Destination Code',
              submittedDesc: 'Company',
              historyKey: 'pickup',
              isRequired: true,
              compareIndex: 1,
              displayKey: 'Description',
            },
            {
              column: 'Send To',
              detected: `${data['formattedData']['sendto_chamareacode']}`,
              submittedList: this.sendToItems,
              submittedKey: 'Destination Code',
              submittedDesc: 'Company',
              historyKey: 'sendto',
              isRequired: true,
              compareIndex: 0,
              displayKey: 'Description',
            },
            {
              column: 'Drop Off',
              detected: `${data['formattedData']['dropoff']}`,
              submittedList: this.dropOffItems,
              submittedKey: 'Destination Code',
              submittedDesc: 'Company',
              historyKey: 'dropoff',
              isRequired: true,
              compareIndex: 0,
              displayKey: 'Description',
            },
          ],
        },
        {
          name: 'Voyage Information',
          verifyData: [
            {
              column: 'Forwarding Agent',
              detected: `${data['formattedData']['frtship_no']}`,
              submittedList: this.fwdgAgentItems,
              submittedKey: 'FA Code',
              submittedDesc: 'FA Name',
              historyKey: 'forwardingAgent',
              isRequired: true,
              compareIndex: 1,
              displayKey: 'Description',
            },
            {
              column: 'Shipping Agent',
              detected: `${data['formattedData']['ag_code']}`,
              submittedList: this.shippingAgentItems,
              submittedKey: 'Agent Code',
              submittedDesc: 'Agent Name',
              historyKey: 'shippingAgent',
              isRequired: true,
              compareIndex: 1,
              displayKey: 'Description',
            },
          ],
        },
      ];

      this.eROTFullDetails = data['formattedData'];
      this.eROTFullDetails['attachments'] = [
        {
          doc_code: '',
          doc_image: this.uploadFileBase64.split(',')[1],
          doc_imagetype: 'application/pdf',
          doc_refno: 'Uploaded Doc.pdf',
          doc_remark: 'User upload',
        },
      ];
      await this.appendAttachmentToVerification(this.eROTFullDetails['attachments']);
      this.$nextTick(() => (this.showVerification = true));
    },
    //#endregion

    //#region Confirm Save Popup
    confirmSavePopupClicked: function (e) {
      if (e === 'Save') {
        if (this.saveAsConfirm) {
          this.confirmSavePopupResolve('confirm');
        } else {
          if (!this.selectedUnconfirmReason) {
            this.selectedUnconfirmReasonError = 'Reason is required!';
            return;
          }

          if (this.selectedUnconfirmReason['Reason'].includes('OTHERS') && !this.unconfirmRemarks) {
            this.unconfirmRemarksError = 'Remarks is required!';
            return;
          }

          this.confirmSavePopupResolve('unconfirm');
        }
      } else {
        this.confirmSavePopupResolve('cancel');
        this.selectedSaveBy = { keyValue: '1', label: 'Confirm Job' };
      }
    },
    shipCallNoSelected: function (val) {
      if (val) {
        this.voyNo = val['Voy No'] ? val['Voy No'].trim() : '';
        this.selectedVesselCode = this.vesselCodeItems.find((v) => v['Vessel ID'].trim() == val['Vessel ID'].trim());
        this.etaDateTime = val['ETA'] ? new Date(`${val['ETA'].substring(0, 13)}:${val['ETA'].substring(13)}`) : null;
        this.etdDateTime = val['ETD'] ? new Date(`${val['ETD'].substring(0, 13)}:${val['ETD'].substring(13)}`) : null;
        this.closeDateTime =
          val['Closing FCL'] ?
            new Date(`${val['Closing FCL'].substring(0, 13)}:${val['Closing FCL'].substring(13)}`)
          : null;
      } else {
        this.voyNo = '';
        this.selectedVesselCode = null;
        this.etaDateTime = null;
        this.etdDateTime = null;
        this.closeDateTime = null;
      }
    },
    //#endregion

    coeffLostFocus: function () {
      if (!this.coeff) {
        this.coeff = '1';
      }
    },

    //#region Diversion
    clearField: function () {
      this.showCreateDiversion = false;
      this.diverpickupori = '0';
      this.diverinternal = '';
      this.diverseqno = '';
      this.cnno = '';
      this.selectedDiversionLoc1 = null;
      this.selectedDiversionLoc2 = null;
      this.selectedDiversionLoc3 = null;
      this.selectedDiversionLoc4 = null;
      this.diversionLoc1 = '';
      this.cnnoLoc1 = '';
      this.diversionLoc2 = '';
      this.cnnoLoc2 = '';
      this.diversionLoc3 = '';
      this.cnnoLoc3 = '';
      this.diversionLoc4 = '';
      this.cnnoLoc4 = '';
      this.internalDiversionLoc1 = false;
      this.internalDiversionLoc2 = false;
      this.internalDiversionLoc3 = false;
      this.internalDiversionLoc4 = false;
      this.remarksDiversionLoc1 = '';
      this.remarksDiversionLoc2 = '';
      this.remarksDiversionLoc3 = '';
      this.remarksDiversionLoc4 = '';
      this.jobDetailForDiversion = null;
    },
    diversionButtonClicked: async function (e) {
      switch (e) {
        case 'Cancel':
          this.clearField();
          break;
        case 'Update':
          if (this['selectedDiversionLoc' + (this.diversionDetails.length + 1)]) {
            this.$fullscreenLoading('Updating Diversion . . . ');
            const viewJobData = this.$jsonNullToString(
              this.$deepTrimJsonV3(
                (await this.$apiCallV2(`/HaulageJob/JobDetails?jobno=${this.selectedJob[0]['Job No']}`))['JobDetails'][
                  'Job'
                ],
              ),
            );
            const cnList = viewJobData['ConsignmentNote'];
            this.selectedSendTo =
              cnList[0]['SendTo'] ?
                this.sendToItems.find((s) => s['Destination Code'].trim() == cnList[0]['SendTo'].trim())
              : null; // = null;
            const dataToPost = {
              action: 'N',
              jobno: this.selectedJob[0]['Job No'],
              cnno: this.isDiversionForCN && this.popupShow ? this.selectedConsignments['0']['Consignment No'] : '',
              requestno: viewJobData['Request No'],
              oridest: this.selectedSendTo['Destination Code'] ? this.selectedSendTo['Destination Code'] : '',
              oridestarea: this.selectedSendTo['Tariff Area'] ? this.selectedSendTo['Tariff Area'] : '',
              diverdest: this['selectedDiversionLoc' + (this.diversionDetails.length + 1)]['Destination Code'],
              diverarea:
                this['selectedDiversionLoc' + (this.diversionDetails.length + 1)]['Area Code'] ?
                  this['selectedDiversionLoc' + (this.diversionDetails.length + 1)]['Area Code']
                : '',
              internal: this['internalDiversionLoc' + (this.diversionDetails.length + 1)] ? '1' : '0',
              remarks:
                this['remarksDiversionLoc' + (this.diversionDetails.length + 1)] ?
                  this['remarksDiversionLoc' + (this.diversionDetails.length + 1)]
                : '',
              system: '',
              deletereason: '',
              seqno: this.diversionDetails.length + 1,
            };
            const saveDiversion = await this.$apiCallV2('/HaulageJob/SaveHMSDiversion', dataToPost);
            this.$fullscreenLoading();

            if (saveDiversion[0]['Results'] == 0) {
              this.refreshClicked();

              await this.$showAlert(
                'success',
                'Diversion Updated',
                `Diversion for Job # ${this.selectedJob[0]['Job No']} has been successfully updated.`,
              );
              // this.selectedJob = [];
            } else {
              await this.$showAlert(
                'error',
                'Update Failed',
                `Job # ${this.selectedJob[0]['Job No']} is not updated. <br>Error: ${saveDiversion[0]['ErrMsg']}`,
              );
            }
            this.$nextTick(() => {
              this.showCreateDiversion = false;
              this.menuClicked({ title: 'View/Create Diversion' });
            });
          } else {
            await this.$showAlert(
              'error',
              'No Diversion Details Specified',
              'Please specify a diversion destination that you want to update.',
            );
          }

          break;

        case 'Print CDA':
          break;
      }
    },
    getJobDetailsForDiversion: async function (useJob) {
      let jobDetail = null;
      this.cndiversionList = [];
      this.jobDetailForDiversion = null;
      if (useJob) {
        this.$fullscreenLoading('Getting Job Details . . .');
        jobDetail = (
          await this.$apiCallV2(
            `/HaulageJob/JobDetails?jobno=${this.selectedJob['0']['Job No']}&&diverpickupori=${this.diverpickupori}&rpt=RptDiversionCN&${this.diverinternal}&diverseqno=${this.diverseqno}`,
          )
        )['JobDetails']['Job'];
        this.$fullscreenLoading();

        const temp = jobDetail['ConsignmentNote']?.['0']['CNDiversion'];
        if (jobDetail['ConsignmentNote']['0']['CNDiversion'] == undefined) {
          this.$showAlert('info', 'Record Check', `No diversion for selected CDA ${this.selectedJob['0']['Job No']}`);
          return;
        }
        this.cndiversionList =
          temp.length > 1 ?
            jobDetail['ConsignmentNote']?.['0']['CNDiversion'][`${temp.length - 1}`]
          : jobDetail['ConsignmentNote']?.['0']['CNDiversion'];
      } else {
        // jobDetail = (await this.$apiCallV2(`/HaulageJob/JobDetails?cnno=${this.selectedConsignmentNo}&diverpickupori=${this.diverpickupori}&diverinternal=${this.diverinternal}&diverseqno=${this.diverseqno}`))['JobDetails']['Job'];
        this.$fullscreenLoading('Getting Job Details . . .');
        jobDetail = (
          await this.$apiCallV2(
            `/HaulageJob/JobDetails?cnno=${this.selectedConsignmentNo ? this.selectedConsignmentNo : ''}&diverpickupori=${this.diverpickupori}&diverinternal=${this.diverinternal}&diverseqno=${this.diverseqno}`,
          )
        )['JobDetails']['Job'];
        this.$fullscreenLoading();
        if (jobDetail['ConsignmentNote']['0']['CNDiversion'] == undefined) {
          this.$showAlert('info', 'Record Check', `No diversion for selected CDA ${this.selectedJob['0']['Job No']}`);
          return;
        }
        this.cndiversionList = jobDetail['ConsignmentNote']['0']['CNDiversion'];
      }
      const qrDetail = `{"CNNO" : "${jobDetail['ConsignmentNote']['0']['CNDiversion']['ConsignmentNo']}"} `;
      jobDetail['ConsignmentNote']['0']['QR'] = await this.$getQRURL(qrDetail, { size: 150, margin: 10 });
      this.jobDetailForDiversion = jobDetail;
    },
    printButtonClicked: async function (diverinternal, cnno, diverseqno) {
      if (diverseqno > this.diversionDetails.length) {
        this.$showAlert('error', 'No data', 'Please add diversion location to print');
        return;
      }
      const temp = parseInt(diverseqno) - 1;
      this.printDiversionTitle = `Print Diversion for ${this.diversionDetails[`${temp}`]['Consignment No']}`;
      // this.diverpickupori = this.useOriDest ? '1' : '0';
      this.diverinternal = diverinternal;
      this.diverseqno = diverseqno;
      this.cnno = cnno;
      await this.getJobDetailsForDiversion(this.selectedConsignmentNo.trim() == '');
      this.printDiversionTitleOri =
        this.diverseqno == '1' ?
          this.jobDetailForDiversion['ConsignmentNote']['0']['SendTo']
        : this[`selectedDiversionLoc1`]['Destination Code'];
      this.printDiversionTitleDivert = this.diversionDetails[`${temp}`]['Diversion Dest'];
      this.showIndividualPrintDiversion = true;
      this.showPrintDiversion = true;
    },
    deleteButtonClicked: function (sequence) {
      this.deleteDivError = '';
      this.sequence = sequence;
      this.showDeleteDivPopup = true;
    },
    deleteDivButtonClicked: async function (e) {
      switch (e) {
        case 'Delete':
          if (!this.deleteDivRemarks) {
            this.deleteDivError = 'Please enter your reason to delete!';
          } else {
            this.$fullscreenLoading('Deleting Diversion . . . ');
            const dataToPost = {
              action: 'D',
              jobno: this.selectedJob[0]['Job No'],
              cnno: this.isDiversionForCN && this.popupShow ? this.selectedConsignments['0']['Consignment No'] : '',
              system: 'HMS',
              deletereason: this.deleteDivRemarks,
              seqno: this.sequence,
            };
            const deleteDiversion = await this.$apiCallV2('/HaulageJob/SaveHMSDiversion', dataToPost);
            this.showDeleteDivPopup = false;
            this.$fullscreenLoading();
            if (deleteDiversion[0]['Results'] == 0) {
              this.refreshClicked();

              await this.$showAlert(
                'success',
                'Diversion Deleted',
                `Diversion for Job # ${this.selectedJob[0]['Job No']} has been successfully deleted.`,
              );
              this.deleteDivRemarks = '';
              this.clearField();
            } else {
              await this.$showAlert(
                'error',
                'Diversion is Not Deleted',
                `Job # ${this.selectedJob[0]['Job No']} is not deleted.<br>Error: ${deleteDiversion[0]['ErrMsg']}`,
              );
            }
            this.showCreateDiversion = false;
            this.$nextTick(() => {
              this.menuClicked({ title: 'View/Create Diversion' });
              if (this.diversionDetails.length < 4) {
                this.diversionButtons = [{ text: 'Update' }, { text: 'Cancel', color: 'indianred' }];
              }
            });
          }
          break;
        case 'Cancel':
          this.showDeleteDivPopup = false;
      }
    },
    printDiversionPopupClicked: function (e) {
      switch (e) {
        case 'Cancel':
          this.showPrintDiversion = false;
          break;
        case 'Print':
          this.showPrintDiversion = false;
          this.showCreateDiversion = false;
          // this.printDiversion();
          this.menuClicked({ title: 'Print Diversion' });
      }
    },
    consignmentPrintJobNo: async function (_type) {
      if (this.selectedConsignments.length == 0) {
        await this.$showAlert('error', 'No Consignment Selected', 'Please select a consignment to print');
        return;
      }
      const selectedCNNos = this.selectedConsignments.map((c) => c['Consignment No']);
      const jobNo = [this.jobNo];
      await this.printCN(jobNo, selectedCNNos);
    },
    diversionForCN: async function (type) {
      if (this.selectedConsignments.length == 0) {
        await this.$showAlert(
          'error',
          'No Consignment Selected',
          'Please select a consignment to view/create Diversion',
        );
        return;
      }
      this.isDiversionForCN = true;
      this.selectedConsignmentNo = this.selectedConsignments['0']['Consignment No'];
      if (type == 'view') {
        this.menuClicked({ title: 'View/Create Diversion' });
      } else {
        this.menuClicked({ title: 'Print Diversion' });
      }
    },
    jobTypeChanged: async function () {
      this.$fullscreenLoading('Getting Price Coeff ...');
      const coeff = await this.$apiCallV2(
        `/HaulageJob/HMSCoeffCheck?jobtype=${this.selectedJobType['Job Type'].trim()}`,
      );
      //assign this.coeff to the value of the coeff from the api (ErrMsg)
      this.coeff = coeff[0]['ErrMsg'];
      this.$fullscreenLoading();
    },
    //#endregion
    validateDates: function (e, field) {
      const fieldsToValidate = [
        'jobDateTime',
        'etaDateTime',
        'etdDateTime',
        'closeDateTime',
        'demurageDate',
        'detentionDate',
        'requiredTime',
      ];
      this.dateErrMsg[field] = '';
      if (fieldsToValidate.includes(field)) {
        if (e > this.maxDate || e < this.minDate) {
          let formattedField = '';
          let capitalizedField = '';
          for (let i = 0; i < field.length; i++) {
            if (i > 0 && field[i] === field[i].toUpperCase()) {
              formattedField += ' '; //add a space before uppercase letters from field parameter
            }
            formattedField += field[i]; //append the current character
          }

          if (field.startsWith('eta') || field.startsWith('etd')) {
            capitalizedField = formattedField.slice(0, 3).toUpperCase() + formattedField.slice(3); //capitalize first 3 characters of field parameter
          } else {
            capitalizedField = formattedField.charAt(0).toUpperCase() + formattedField.slice(1); //capitalize first caharcter of field parameter
          }

          if (e > this.maxDate)
            this.dateErrMsg[field] =
              `Please select ${capitalizedField} earlier than ${this.maxDate.formatString('dd/MM/yyyy')}`;
          else if (e < this.minDate)
            this.dateErrMsg[field] =
              `Please select ${capitalizedField} later than ${this.minDate.formatString('dd/MM/yyyy')}`;
          return true;
        }
      }
      return false;
    },
    setUnit(field, value) {
      // console.log('lesgo', field, value);
      // if(field == 'storageUnit')
      this[field] = value;
    },

    async openFromParams() {
      const params = new URLSearchParams(window.location.search);

      const viewValue = params.get('View') || params.get('Edit');

      if (viewValue) {
        this.searchInputValue = viewValue;
        this.filterDate = false;
        this.filterSearch = true;
        await this.refreshClicked();
        this.$nextTick(() => {
          const objectCleaned = Object.fromEntries(Object.entries(this.jobData[0]).map(([k, v]) => [k, v ?? '']));
          this.selectedJob = [{ ...objectCleaned, _rowid: 'row0' }];

          if (params.get('Edit')) this.menuEditClicked();
          else if (params.get('View')) this.menuViewClicked();
        });
      }

      const newValue = params.get('New');
      if (newValue != null) this.menuNewClicked();
    },
  },
  mounted() {
    let mountedPromises = [];
    let totalPromisesFulfilledCount = 0;
    const haulageJobListPromises = [];

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'erotfrom', module: 'HMS' }).then((result) => {
        this.senderList = result;
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
      }),
    );

    const loadList = this.refreshClicked().then(() => {
      this.filterIsDisabled = false; //set to false after populate dropdown to prevent user from selecting while loading/empty
      totalPromisesFulfilledCount += 2;
      //  totalPromisesFulfilledCount is increased by 2 instead of 1 because loadList is pushed into two arrays instead of one
      this.$topLoading(totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
    }); // non-blocking

    mountedPromises.push(loadList);
    haulageJobListPromises.push(loadList);

    mountedPromises.push(
      // non-blocking
      this.$apiCallV2('/Master/GetSettingsSystem?settingsItem=HMS_NonISOContType').then((result) => {
        if (result) {
          const nonISOContTypeOri = result[0]['SettingsValue'];
          this.nonISOContType = nonISOContTypeOri.split(',');
        }
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
      }),
    );

    // this.settingsSystemRequestNo = (await this.$apiCallV2("/Master/GetSettingsSystem?settingsitem=HMS_RequestNo"))?.[0]?.["SettingsValue"];
    // this.settingsSystemOPFwdgAgt = (await this.$apiCallV2("/Master/GetSettingsSystem?settingsitem=HMS_OP_FwdgAgt"))?.[0]?.["SettingsValue"];
    mountedPromises.push(
      // non-blocking
      this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=HMS_RequestNo').then((result) => {
        this.settingsSystemRequestNo = result?.[0]?.['SettingsValue'];
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=HMS_OP_FwdgAgt').then((result) => {
        this.settingsSystemOPFwdgAgt = result?.[0]?.['SettingsValue'];
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
      }),
    );

    // this.$fullscreenLoading('Getting Data');
    const getJobInfoDataPromises = this.getJobInfoData().map((promise) => {
      // non-blocking
      return promise.then(() => {
        // chain another .then() here to increment count, instead of chaining in getJobInfoData()
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length)); // so that getJobInfoData() can be used by other functions in the future with no side-effects
      });
    });
    mountedPromises = mountedPromises.concat(getJobInfoDataPromises);

    const getSendToDataPromises = this.getSendToData().map((promise) => {
      // non-blocking
      return promise.then(() => {
        // chain another .then() here to increment count, instead of chaining in getSendToData()
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length)); // so that getSendToData() can be used by other functions in the future with no side-effects
      });
    });
    mountedPromises = mountedPromises.concat(getSendToDataPromises);

    const getContainerDataPromises = this.getContainerData().map((promise) => {
      // non-blocking
      return promise.then(() => {
        // chain another .then() here to increment count, instead of chaining in getContainerData()
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length)); // so that getContainerData() can be used by other functions in the future with no side-effects
      });
    });
    mountedPromises = mountedPromises.concat(getContainerDataPromises);

    const getVoyageInfoDataPromises = this.getVoyageInfoData().map((promise) => {
      // non-blocking
      return promise.then(() => {
        // chain another .then() here to increment count, instead of chaining in getVoyageInfoData()
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length)); // so that getVoyageInfoData() can be used by other functions in the future with no side-effects
      });
    });
    mountedPromises = mountedPromises.concat(getVoyageInfoDataPromises);

    // this.reasonsList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'job_unconfirm_reason'  }); // non-blocking
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'job_unconfirm_reason' }).then((result) => {
        this.reasonsList = result;
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
      }),
    );

    // this.diversionLocation = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'destination', module: 'HMS' }); // non-blocking
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'destination', module: 'HMS' }).then((result) => {
        this.diversionLocation = result;
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
      }),
    );

    // this.filterList = this.$deepTrimJsonV3(await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'EROTFILTER' }));
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'EROTFILTER' }).then((result) => {
        this.filterList = this.$deepTrimJsonV3(result);
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
      }),
    );

    // this.jobTypeItems = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'jobtype', module: 'HMS' }); // non-blocking
    haulageJobListPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'jobtype', module: 'HMS' }).then((result) => {
        this.allJobTypes = result;
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
      }),
    );

    // this.$fullscreenLoading("Getting Search By");
    // this.searchByItems = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'jobquery', module: 'HMS' }); // non-blocking
    // this.selectedFilterSearchBy = this.searchByItems?.[0];
    haulageJobListPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'jobquery', module: 'HMS' }).then((result) => {
        this.searchByItems = result;
        this.selectedFilterSearchBy = this.searchByItems?.[0];
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=HMS_DEFAULT_TRIP').then((result) => {
        this.hms_Default_Trip = result?.[0]?.['SettingsValue'];
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
      }),
    );

    this.selectedFilterSearchCriteria = this.searchCriteriaItems.find((item) => {
      return item['name'] === 'CONTAINS';
    }); // items hardcoded

    haulageJobListPromises.push(
      this.$apiCallV2('/Login/GetDetails').then((result) => {
        this.loginDetails = result;
        this.designerV2ReportFile = [`CN_${this.loginDetails['CoRefname']}.json`]; // Wrap in an array. For now, this page only uses one template per CN
        this.designerV2ReportFileDiversion = [`CNDiversion_${this.loginDetails['CoRefname']}.json`]; // Wrap in an array. For now, this page only uses one template per CN
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
      }),
    );

    haulageJobListPromises.push(
      this.$signal.init('HaulageJobPageHub').then((result) => {
        this.haulageJobPageSignalHub = result;
        this.$topLoading(++totalPromisesFulfilledCount / (haulageJobListPromises.length + mountedPromises.length));
      }),
    );

    Promise.allSettled(mountedPromises).then((_promiseOutcomes) => {
      this.menu = this.menu.map((menu) => ({
        ...menu,
        enabled: menu.title === 'Print CN' ? menu.enabled : true,
      }));

      this.openFromParams();
    });

    Promise.allSettled(haulageJobListPromises).then((_promiseOutcomes) => {
      this.menu = this.menu.map((menu) => ({
        ...menu,
        enabled: menu.title === 'Print CN' ? true : menu.enabled,
      }));
    });

    // let hms_ChangeJTypeCoeff = await this.$apiCallV2('/Master/GetSettingsSystem?settingsItem=HMS_ChangeJTypeCoeff');
    // console.log(hms_ChangeJTypeCoeff);
    // if( hms_ChangeJTypeCoeff[0]?.['SettingsValue'] != '1') { //1 = true means user can change coeff value
    //   this.coeffDisable = true; //disable if not "1"
    // }
  },
  beforeDestroy() {
    this.$signal.stop('HaulageJobPageHub');
  },
  watch: {
    popupShow: function (val) {
      if (val) {
        if (this.popupTitle[0] === 'N') {
          this.jobDateTime = new Date();
          this.jobTypeItems = this.allJobTypes;
        }
      } else {
        this.clearData();
      }
    },
    selectedJob: function (val) {
      if (val) {
        this.cndiversionList = [];
        this.selectedConsignmentNo = '';
        this.jobDetailForDiversion = [];
      }
    },
    selectedDiversionLoc1: function (val) {
      if (val && this.diversionDetails.length == 0) {
        this.diversionLoc1 = val['Address'];
      }
    },
    selectedDiversionLoc2: function (val) {
      if (val && this.diversionDetails.length == 1) {
        this.diversionLoc2 = val['Address'];
      }
    },
    selectedDiversionLoc3: function (val) {
      if (val && this.diversionDetails.length == 2) {
        this.diversionLoc3 = val['Address'];
      }
    },
    selectedDiversionLoc4: function (val) {
      if (val && this.diversionDetails.length == 3) {
        this.diversionLoc4 = val['Address'];
      }
    },
    useOriDest: function (val) {
      this.diverpickupori = val ? '1' : '0';
      this.getJobDetailsForDiversion(false);
    },
    // selectedJob: async function(val) {
    //   console.log('selectedJob');
    //   console.log(val);
    //   this.diversionDetails = [];
    //   this.diversionDetails = (await this.$apiCallV2(`/HaulageJob/GetHMSDiversion?jobno=${val[0]["Job No"]}&cnno=${val[0]["Consignment No"] ? val[0]["Consignment No"] : '' }`));
    //   // this.getJobDetailsForDiversion(false);
    // },
    openConsignmentPopup: function (val) {
      if (!val) {
        // For close
        this.clearConsignmentPopup();
      } else {
        // For open
        if (this.selectedJobType['Job Type Header'] == 'I') {
          this.isContNo = true;
          this.isContCount = false;
        } else if (this.selectedJobType['Job Type Header'] == 'E') {
          this.isContNo = false;
          this.isContCount = true;
        }

        if (this.cnEditIndex > -1) {
          this.isContNo = true;
          this.isContCount = false;
        }

        if (this.selectedPickUp) {
          this.selectedPickUpCN = this.selectedPickUp;
          this.pickUpAddressCN = this.pickUpAddress;
        }
        if (this.selectedSendTo) {
          this.selectedSendToCN = this.selectedSendTo;
          this.sendToAddressCN = this.sendToAddress;

          this.tollTariff = this.selectedSendToCN['Toll'] ? this.selectedSendToCN['Toll'].toFixed(2) : '0.00';
          this.haulageTariff =
            this.selectedSendToCN[`20' Rate`] ? this.selectedSendToCN[`20' Rate`].toFixed(2) : '0.00';
        }
        if (this.selectedDropOff) {
          this.selectedDropOffCN = this.selectedDropOff;
          this.dropOffAddressCN = this.dropOffAddress;
        }
        this.isDiversionCN = this.isDiversion;
        if (this.selectedPremises) {
          this.selectedPremisesCN = this.selectedPremises;
        }
      }
    },
    samePickUp: function (val) {
      if (val) {
        this.selectedPickUpCN = this.selectedPickUp;
        this.pickUpAddressCN = this.pickUpAddress;
        // this.isDiversionCN = this.isDiversion; //move to samesendto
        // this.selectedPremisesCN = this.selectedPremises; //move to samesendto
      } else {
        this.selectedPickUpCN = null;
        // this.isDiversionCN = false; //move to samesendto
        // this.selectedPremisesCN = null; //move to samesendto
        this.pickUpAddressCN = '';
      }
    },
    sameSendTo: function (val) {
      if (val) {
        this.selectedSendToCN = this.selectedSendTo;
        this.sendToAddressCN = this.sendToAddress;
        this.isDiversionCN = this.isDiversion;
        this.selectedPremisesCN = this.selectedPremises;
      } else {
        this.selectedSendToCN = null;
        this.isDiversionCN = false;
        this.selectedPremisesCN = null;
        this.sendToAddressCN = '';
      }
    },
    sameDropOff: function (val) {
      if (val) {
        this.selectedDropOffCN = this.selectedDropOff;
        this.dropOffAddressCN = this.dropOffAddress;
      } else {
        this.selectedDropOffCN = null;
        this.dropOffAddressCN = '';
      }
    },
    selectedShippingAgent: function (val) {
      if (val) {
        this.shipAgtTel = val['Agent Tel'] ? val['Agent Tel'].trim() : '';
        this.shipAgtFax = val['Agent Fax'] ? val['Agent Fax'].trim() : '';
      } else {
        this.shipAgtTel = '';
        this.shipAgtFax = '';
      }
    },
    selectedFwdgAgent: function (val) {
      if (val) {
        this.fwdgAgtTel = val['Agent Tel'] ? val['Agent Tel'].trim() : '';
        this.fwdgAgtFax = val['Agent Fax'] ? val['Agent Fax'].trim() : '';
      } else {
        this.fwdgAgtTel = '';
        this.fwdgAgtFax = '';
      }
    },
    selectedShipper: function (val) {
      if (val) {
        if (val['Status Desc'].includes('INACTIVE')) {
          this.$showAlert(
            'error',
            'Inactive Shipper',
            `Shipper ${val['Customer Code'].trim()} is inactive. Please select a different shipper.`,
          );
          this.$nextTick(() => (this.selectedShipper = null));
        } else {
          this.selectedBillTo = this.billToItems.find((s) => s['Customer Code'].trim() == val['Bill To Code'].trim());
        }
      } else {
        this.selectedBillTo = null;
      }

      this.billToSelected(this.selectedBillTo);
    },
    // selectedShipCallNo: function(val) {
    //   if (val) {
    //     this.voyNo = val['Voy No'] ? val['Voy No'].trim() : '';
    //     this.selectedVesselCode = this.vesselCodeItems.find(v => v['Vessel ID'].trim() == val['Vessel ID'].trim());
    //     this.etaDateTime = val['ETA'] ? new Date(`${val['ETA'].substring(0, 13)}:${val['ETA'].substring(13)}`) : null;
    //     this.etdDateTime = val['ETD'] ? new Date(`${val['ETD'].substring(0, 13)}:${val['ETD'].substring(13)}`) : null;
    //     this.closeDateTime = val['Closing FCL'] ? new Date(`${val['Closing FCL'].substring(0, 13)}:${val['Closing FCL'].substring(13)}`) : null;
    //   } else {
    //     this.voyNo = '';
    //     this.selectedVesselCode = null;
    //     this.etaDateTime = null;
    //     this.etdDateTime = null;
    //     this.closeDateTime = null;
    //   }
    // },

    selectedPickUp: function (val) {
      this.pickUpAddress = '';
      this.getAddress(val, 'pickUpAddress');
    },
    selectedSendTo: function (val) {
      this.sendToAddress = '';
      this.getAddress(val, 'sendToAddress');
    },
    selectedDropOff: function (val) {
      this.dropOffAddress = '';
      this.getAddress(val, 'dropOffAddress');
    },

    selectedPickUpCN: function (val) {
      this.pickUpAddressCN = '';
      this.getAddress(val, 'pickUpAddressCN');
    },
    selectedSendToCN: function (val) {
      this.sendToAddressCN = '';
      this.getAddress(val, 'sendToAddressCN');

      if (val) {
        this.tollTariff = val['Toll'] ? val['Toll'].toFixed(2) : '0.00';
        this.haulageTariff = val[`20' Rate`] ? val[`20' Rate`].toFixed(2) : '0.00';
      } else {
        this.tollTariff = '';
        this.haulageTariff = '';
      }
    },
    selectedDropOffCN: function (val) {
      this.dropOffAddressCN = '';
      this.getAddress(val, 'dropOffAddressCN');
    },

    selectedJobType: function (newVal, oldVal) {
      if (!this.checkJobTypeChange) {
        this.checkJobTypeChange = true;
        return;
      }

      if (newVal && oldVal) {
        this.checkJobTypeChanges(newVal, oldVal);
      }

      //default value
      this.shipperCaption = 'Shipper';
      this.bookingRefNoRequired = false;
      this.closeDateTimeDisable = false;
      this.demurageDateDisable = false;
      this.detentionDateDisable = false;
      //statusButtons 0 -Laden, 1- Empty
      this.statusButtonsOri.forEach((s) => (s['checked'] = false));
      // this.statusButtons.forEach(s => s['checked'] = false);

      if (this.selectedJobType) {
        switch (this.selectedJobType['Job Type']) {
          case 'IMP-EXP':
            this.shipperCaption = 'Consignee';
            this.statusButtonsOri[0]['checked'] = true;
            break;
          case 'IMP':
          case '1-IMP':
          case '1-IMP-MT':
            this.shipperCaption = 'Consignee';
            this.closeDateTimeDisable = true;
            this.closeDateTime = null;
            this.statusButtonsOri[0]['checked'] = true;
            break;
          case 'EXP':
          case '1-EXP':
          case '1-EXP-MT':
            this.shipperConsignee = 'Shipper';
            this.bookingRefNoRequired = true;
            this.demurageDateDisable = true;
            this.demurageDate = null;
            this.detentionDateDisable = true;
            this.detentionDate = null;
            this.statusButtonsOri[1]['checked'] = true;
            break;
          case 'MTR':
          case 'REPO':
          case 'LOLO':
          case 'DOMESTIC':
            this.shipperCaption = 'Customer';
            this.closeDateTimeDisable = true;
            this.closeDateTime = null;
            this.demurageDateDisable = true;
            this.demurageDate = null;
            this.detentionDateDisable = true;
            this.detentionDate = null;
            this.statusButtonsOri[1]['checked'] = true;
            break;
        }
      }
    },

    showEROT: function (val) {
      if (!val) {
        this.selectedROT = [];
        this.eROTLastRefreshed = '';
        this.uploadFileBase64 = '';
      }
    },
    showVerification: function (val) {
      if (!val) {
        this.$apiCallV2(`/Upload/DeleteFiles?folder=eROT_${this.eROTRequestNo}`);
        this.eROTAttachments = [];
      }
    },
    designerV2IsShown: function (shown) {
      if (shown) {
        this.haulageJobPageSignalHub.on('ConsignmentNotePrinted', this.consignmentNotePrintedEventHandler);
        // start listening to the "ConsignmentNotePrinted" event and specify the event handler method,
        // the arguments passed by the controller will be passed into this method
      } else {
        this.haulageJobPageSignalHub.off('ConsignmentNotePrinted');
        // stop listening to the "ConsignmentNotePrinted" event
      }
    },

    confirmSavePopup: function (val) {
      if (val) {
        this.selectedUnconfirmReason = null;
        this.selectedUnconfirmReasonError = '';
        this.unconfirmRemarks = '';
        this.unconfirmRemarksError = '';
      }
    },

    selectedType: function (val) {
      if (val) {
        if (this.nonISOContType.includes(val['Cont Type'])) {
          this.isContainerCheck = false;
        } else {
          this.isContainerCheck = true;
        }
      } else {
        this.isContainerCheck = true;
      }
    },

    tabIndex: function (val) {
      if (val === 5 && this.viewMode && this.jobNo) {
        this.showTASAndKPILoader = true;
        this.$apiCallV2(`/HaulageJob/GetStatusTaskList?jobno=${this.jobNo}`)
          .then((result) => {
            this.statusTaskStatusData = this.appendStatusIcon(result);
            this.showTASAndKPILoader = false;
          });
      }
    },

    requiredDateTimeChk: function (isChecked) {
      if (!isChecked) {
        this.requiredTime = null;
        this.dateErrMsg['requiredTime'] = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.haulage-job-main {
  display: flex;
  font-size: 12px;
  padding: 10px 45px;

  > .right-container {
    width: 100%;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    > .top-section,
    > .bottom-section {
      background-color: white;
      border-radius: 5px;
      padding: 5px;
    }

    > .top-section {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      > .filter-description {
        padding-right: 8px;
      }

      > .button-filter-component {
        margin-right: 5px;
        position: relative;

        .filter-popup {
          display: flex;
          flex-direction: column;

          > button {
            margin-top: 5px;
            width: fit-content;
            align-self: flex-end;
          }
        }
      }
    }

    > .bottom-section {
      height: calc(100% - 38px - 5px); // deduct height of top-section and margin
      margin-top: 5px;
    }
  }

  > .container-popup,
  > .erot-popup {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.5);
    top: 50px;
    left: 0;
    height: calc(100% - 50px);
    width: 100%;
    z-index: 999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > .title {
      background-color: white;
      padding: 5px;
      width: 90%;
      font-weight: bold;
      font-size: 1.1em;
      text-align: center;
    }

    > .send-to-section {
      background-color: white;
      width: 90%;
      display: flex;
      padding: 5px;

      > * {
        margin-right: 5px;
        width: 33%;
      }
    }

    > .button-section {
      display: flex;
      background-color: white;
      padding: 5px;
      width: 90%;
      justify-content: flex-end;

      > button {
        margin-left: 5px;
      }
    }

    > .content {
      width: 90%;
      background-color: white;
      display: flex;
      padding: 5px;

      > .container-left,
      > .container-right {
        width: 50%;
        margin-right: 5px;
        display: flex;
        flex-direction: column;
      }
    }
  }

  > .erot-popup {
    > .erot-content {
      background-color: lightgray;
      padding: 5px;
      width: calc(100% - 90px);
      height: calc(100% - 20px);
      position: relative;
      display: flex;
      flex-direction: column;

      > .top-section,
      > .table-section,
      > .bottom-section {
        background-color: white;
        border-radius: 5px;
        padding: 5px;
      }

      > .top-section,
      > .bottom-section {
        display: flex;
        justify-content: flex-end;
      }

      > .top-section {
        align-items: center;

        > :first-child {
          margin-right: 5px;
        }

        > :last-child {
          margin-left: 5px;
        }
      }

      > .table-section {
        height: 100%;
        margin-top: 5px;
        overflow: hidden;

        > .verification-upload {
          display: flex;
          flex-direction: column;
          height: 100%;

          > object {
            background-color: lightgray;
            height: 100%;
          }
        }
      }

      > .bottom-section {
        margin-top: 5px;

        > button {
          margin-left: 5px;
          color: white;
        }

        > :nth-child(1) {
          background-color: green;
        }

        > :nth-child(2) {
          background-color: red;
        }

        > :nth-child(3),
        > .cancel-btn {
          background-color: gray;
        }
      }
    }

    > .erot-containers-popup-container {
      position: absolute;
      height: 100%;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 999;
      display: flex;
      justify-content: center;
      align-items: center;

      > .erot-containers-popup {
        height: 50%;
        width: 60%;
        padding: 5px;
        background-color: lightgray;
        display: flex;
        flex-direction: column;

        > .table-box-container {
          height: calc(100% - 38px);
          border-radius: 5px;
          background-color: white;
          padding: 5px;
        }

        > .call-to-action-buttons {
          margin-top: 5px;
          border-radius: 5px;
          padding: 5px;
          background-color: white;

          > button {
            width: 100%;
          }
        }
      }
    }
  }

  > .designer-v2-container {
    position: fixed;
    top: $top-nav-height;
    left: 0;
    height: calc(100% - #{$top-nav-height});
    width: 100%;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);

    > .designer-v2-component-container {
      height: 95%;
      width: 90%;
    }
  }
}

.popup-entry-content {
  display: flex;
  flex-direction: column;
  height: 100%;

  > .popup-milestones {
    border: 1px solid rgba(0, 0, 0, 0.3);
    width: 100%;
    padding: 5px;
    margin-bottom: 8px;
    position: relative;
    font-size: 10px;

    > .loader {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1000;

      > .loader-text {
        font-weight: bolder;
        font-size: 20px;
        color: white;
      }
    }

    > .milestones-row {
      display: flex;
      align-items: center;

      > * {
        margin-right: 5px;
      }

      > .milestones-block {
        position: relative;
        margin-bottom: 2px;

        > .milestones-item {
          border: 1px solid rgba(128, 128, 128, 0.5);
          max-width: 100px;
          min-width: 100px;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          text-overflow: ellipsis;
          overflow: hidden;
          -webkit-box-orient: vertical;
          cursor: default;
          padding: 3px;
        }

        > .milestone-tooltip {
          position: absolute;
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
        }
      }

      > .legend-items {
        display: flex;
        align-items: center;

        > .legend-box {
          height: 10px;
          width: 10px;
          border: 1px solid rgba(128, 128, 128, 0.5);
          margin-right: 3px;
        }
      }
    }

    > .collapse-milestone {
      position: absolute;
      bottom: 2px;
      right: 2px;
      transition: 0.3s;
      cursor: pointer;
    }
  }

  .popup-details {
    display: flex;
    height: 100%;

    > .summary {
      width: 115px;
      min-width: 115px;
      margin-right: 5px;
    }
  }

  > .main-content-container {
    display: flex;
    flex-direction: row;
    height: 100%;
    overflow: hidden;

    > .summary {
      width: 115px;
      min-width: 115px;
      margin-right: 5px;
    }
  }
}

.documents {
  position: relative;
  height: 100%;

  > .top-button-section {
    > button {
      margin-right: 5px;
    }
  }

  > .loader {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;

    > .loader-text {
      font-weight: bolder;
      font-size: 20px;
      color: white;
    }
  }
}

.filter-section {
  display: flex;
  flex-direction: column;

  > .refresh-button {
    margin-top: 5px;
    position: relative;
    align-self: flex-end;
  }
}

.job-info-top {
  display: flex;
  margin-bottom: 15px;

  > div {
    width: 50%;

    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}

.job-info-bottom {
  display: flex;

  > .left-section {
    width: 50%;
    padding-right: 5px;
  }

  > .right-section {
    width: 50%;

    > .row-display:nth-child(2) {
      padding-top: 4px;
    }
  }
}

.send-to-container-info {
  border: 1px solid gray;
  padding: 5px;
  padding-top: 10px;
  margin-top: 15px;
  display: flex;
  position: relative;

  > .title {
    background-color: white;
    padding: 5px 15px;
    position: absolute;
    top: -16px;
  }

  > .expand-icon {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    z-index: 999;
  }

  > .collapsed-title {
    position: absolute;
    top: 0;
    left: 0;
    padding-left: 10px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
  }

  > .left-section {
    width: 60%;
    margin-right: 5px;
  }

  > .right-section {
    width: 40%;
    padding-top: 2px;
  }
}

.button-area {
  // display: flex;
  // justify-items: flex-end;
  margin-top: 8px;

  > button {
    margin-right: 5px;
  }
}

.tas-and-kpi {
  position: relative;
  height: 100%;

  > .loader {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;

    > .loader-text {
      font-weight: bolder;
      font-size: 20px;
      color: white;
    }
  }

  > .status-page-component {
    height: calc(100% - 60px);
  }
}

.voyage-info {
  display: flex;
  align-items: stretch;
  flex-direction: column;

  > .top-section {
    display: flex;
    align-items: flex-start;
    > .left-section {
      width: 60%;
      margin-right: 5px;
    }

    > .right-section {
      width: 40%;
    }
  }

  > .bottom-section{
    width: 100%;
    margin-top: 10px;
    display: flex; 
    gap: 10px;
    justify-content: flex-start;

    > .free-input-group {
      display: flex;
      flex-direction: row;
      gap: 4px;
      width: auto;

      > .unit-toggle {
        display: flex;
        flex-shrink: 0;
        border: 1px solid #b3c4ff;
        border-radius: 4px;
        overflow: hidden;
        // width: 90px;

        &.disabled {
          opacity: 0.5;
          pointer-events: none;
        }

        .toggle-btn {
          padding: 0 8px;
          height: 28px;
          font-size: 11px;
          border: none;
          background-color: #f0f0f0;
          color: #555;
          cursor: pointer;
          transition: background-color 0.15s, color 0.15s;

          &:first-child {
            border-right: 1px solid rgba(0, 0, 0, 0.15);
          }

          &.active {
            background-color: #6e6eff;
            color: #fff;
            font-weight: 600;
          }

          &:hover:not(:disabled):not(.active) {
            background-color: #b3c4ff;
            color: #fff;
          }
        }
      }
    }
  }
}

.row-display {
  display: flex;

  > * {
    margin-right: 5px !important;
  }

  > :last-child {
    margin-right: 0 !important;
  }

  > .checkbox-main {
    white-space: nowrap;
  }
}

.status-container {
  border: 1px solid rgb(200, 200, 200);
  padding: 3px;
  margin-right: 5px;
  margin-left: 3px;
}

.outstanding-prog {
  display: flex;
  border: 1px solid rgb(200, 200, 200);
  position: relative;
  width: calc(100% - 2px);
  margin-left: 3px;
  padding: 3px;

  > .progress-ind {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 50%;
    background-color: rgba(51, 231, 255, 0.5);
  }
}

.send-to-details {
  width: 33%;
  border: 1px solid gray;
  padding: 5px;
  margin-top: 5px;
  padding-top: 10px;
}

.quick-entry-cn {
  margin-top: 5px;
  display: flex;
  align-items: center;

  > * {
    margin-right: 5px;
  }

  > a {
    text-decoration: underline;
    cursor: pointer;
  }
}

.cont-listing {
  border: 1px solid gray;
  margin-top: 5px;

  > .cont-no {
    padding: 5px;
    text-align: left;
    position: relative;

    > .delete-cont-no {
      position: absolute;
      height: calc(100% - 8px);
      right: 3px;
      cursor: pointer;
    }

    &:nth-child(odd) {
      background-color: rgba(211, 211, 211, 0.5);
    }
  }
}

.address-container {
  white-space: pre-wrap;
}

.erot-reject-content {
  text-align: left;
  margin: 0 10px;

  > .collapsible-title-container {
    display: flex;
    align-items: center;
    cursor: pointer;

    > img {
      height: 20px;
      transition: 0.3s;
    }
  }

  > .message-reason-container {
    height: 100px;
  }
}

.erotcn-error-popup-content {
  > .content {
    > * {
      margin: 10px 0;
    }
  }
}
</style>
